export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: Date; output: Date; }
  /** Date with time (isoformat) */
  DateTime: { input: Date; output: Date; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

export type IAcceptTosInput = {
  token: Scalars['String']['input'];
};

/** ⚠️ Summary-view fields to avoid: details ⚠ */
export type IAccount = {
  __typename?: 'Account';
  /** ⚠️Expensive */
  closeable?: Maybe<Scalars['Boolean']['output']>;
  currency: ICurrency;
  /** Restricted to users with read:accounts:restricted */
  details?: Maybe<IAccountDetails>;
  hasVerificationLetter: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPayoutOnly: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Internal CC or unit account ID */
  providerAccountId?: Maybe<Scalars['String']['output']>;
  /** Restricted to users with read:accounts:restricted */
  restrictedFields?: Maybe<IAccountRestrictedFields>;
  status: IAccountStatus;
  type: IAccountType;
};

export type IAccountDetails = ICadAccountDetails | ICreditAccountDetails | IEurAccountDetails | IGbpAccountDetails | ISwiftAccountDetails | IUsdAccountDetails;

export type IAccountDetailsWithLocalPayIns = {
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  localPaymentRailName?: Maybe<Scalars['String']['output']>;
  swift: ISwiftAccountDetails;
};

export type IAccountInfoResponse = {
  __typename?: 'AccountInfoResponse';
  accountInfo: IAccountTypeInfo;
};

export type IAccountLimit = IMoneyAccountLimit | IVolumeAccountLimit;

export type IAccountLimitInterface = {
  limitType: IAccountLimitType;
};

export enum IAccountLimitType {
  DailyAchCredit = 'DAILY_ACH_CREDIT',
  DailyAchDebit = 'DAILY_ACH_DEBIT',
  DailyCheckDeposit = 'DAILY_CHECK_DEPOSIT',
  DailyPurchase = 'DAILY_PURCHASE',
  DailyWithdrawal = 'DAILY_WITHDRAWAL',
  MonthlyAchCredit = 'MONTHLY_ACH_CREDIT',
  MonthlyAchDebit = 'MONTHLY_ACH_DEBIT',
  MonthlyCheckDeposit = 'MONTHLY_CHECK_DEPOSIT',
  MonthlyFreeLocalRailPayments = 'MONTHLY_FREE_LOCAL_RAIL_PAYMENTS',
  MonthlyFreeWirePayments = 'MONTHLY_FREE_WIRE_PAYMENTS',
  MonthlyPurchase = 'MONTHLY_PURCHASE',
  MonthlyWithdrawal = 'MONTHLY_WITHDRAWAL'
}

export type IAccountRestrictedFields = {
  __typename?: 'AccountRestrictedFields';
  apy: Scalars['Float']['output'];
  availableBalance: IMoney;
  currentBalance: IMoney;
};

export type IAccountStatement = ICheckingAccountStatement | IConsolidatedAccountStatement | ICreditAccountStatement;

export type IAccountStatementInterface = {
  account: IAccount;
  /** ⚠️ Expensive. Do not use in summary view */
  balance: ICreditStatementBalance;
  /** ⚠️ Expensive. Generated on demand */
  csvUrl?: Maybe<Scalars['String']['output']>;
  /** ⚠️ Expensive. Generated on demand */
  html?: Maybe<Scalars['String']['output']>;
  /** We identify statements by their period, eg 2023-01 */
  id: Scalars['ID']['output'];
  /** ⚠️ Expensive. Generated on demand */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  period: IPeriod;
  /** ⚠️ Expensive. Generated on demand */
  qboUrl?: Maybe<Scalars['String']['output']>;
  statementDate: Scalars['Date']['output'];
};

export enum IAccountStatus {
  Closed = 'CLOSED',
  Frozen = 'FROZEN',
  Open = 'OPEN'
}

export enum IAccountType {
  Checking = 'CHECKING',
  Credit = 'CREDIT',
  Ops = 'OPS',
  Savings = 'SAVINGS'
}

export type IAccountTypeInfo = {
  __typename?: 'AccountTypeInfo';
  achDebitClearingBusinessDays: Scalars['Int']['output'];
  apy: Scalars['Float']['output'];
  maxDebitVirtualCardsPerUser: Scalars['Int']['output'];
  minBalance: Scalars['Float']['output'];
};

export type IAccountingCategory = {
  __typename?: 'AccountingCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentAccountingCategory?: Maybe<IAccountingCategory>;
  status?: Maybe<IAccountingCategoryStatus>;
  type: IAccountingCategoryType;
};

export enum IAccountingCategoryStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export enum IAccountingCategoryType {
  Class = 'CLASS',
  Department = 'DEPARTMENT',
  Location = 'LOCATION',
  Unknown = 'UNKNOWN'
}

export type IAccountingConnection = {
  __typename?: 'AccountingConnection';
  /** (Only for QBO) When a customer has Automated Sales Tax enabled, tax rate id on bill line item is required */
  astEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  name: IAccountingConnectionName;
  /** @deprecated Use sync status instead */
  status: IAccountingConnectionStatus;
  /** Resolved separately for performance. */
  syncStatus: IAccountingConnectionSyncStatus;
};

export enum IAccountingConnectionName {
  DynamicsBusinessCentral = 'DYNAMICS_BUSINESS_CENTRAL',
  Freshbooks = 'FRESHBOOKS',
  OracleNetsuite = 'ORACLE_NETSUITE',
  Quickbooks = 'QUICKBOOKS',
  QuickbooksDesktop = 'QUICKBOOKS_DESKTOP',
  SageBusinessCloud = 'SAGE_BUSINESS_CLOUD',
  SageIntacct = 'SAGE_INTACCT',
  Wave = 'WAVE',
  Xero = 'XERO',
  ZohoBooks = 'ZOHO_BOOKS'
}

export type IAccountingConnectionRequiredError = IErrorInterface & {
  __typename?: 'AccountingConnectionRequiredError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IAccountingConnectionResponse = IAccountingConnection | IAccountingDeauthorized | IAccountingNotConnected;

export enum IAccountingConnectionStatus {
  Active = 'ACTIVE',
  Deauthorized = 'DEAUTHORIZED',
  Disconnected = 'DISCONNECTED',
  Pending = 'PENDING'
}

export enum IAccountingConnectionSyncStatus {
  Complete = 'COMPLETE',
  NeedsReauth = 'NEEDS_REAUTH',
  Syncing = 'SYNCING'
}

export type IAccountingCustomer = {
  __typename?: 'AccountingCustomer';
  contactName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: IAccountingCustomerStatus;
};

export enum IAccountingCustomerStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unknown = 'UNKNOWN'
}

export type IAccountingDeauthorized = {
  __typename?: 'AccountingDeauthorized';
  /** Placeholder field, cannot create types without fields */
  void: Scalars['Boolean']['output'];
};

export type IAccountingFilter = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export enum IAccountingItemStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unknown = 'UNKNOWN'
}

export enum IAccountingItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY',
  Service = 'SERVICE',
  Unknown = 'UNKNOWN'
}

export type IAccountingNotConnected = {
  __typename?: 'AccountingNotConnected';
  /** Placeholder field, cannot create types without fields */
  neverConnected: Scalars['Boolean']['output'];
};

export type IAccountingTaxRate = {
  __typename?: 'AccountingTaxRate';
  code: Scalars['String']['output'];
  effectiveTaxRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalTaxRate?: Maybe<Scalars['Float']['output']>;
};

export type IAccountingVendor = {
  __typename?: 'AccountingVendor';
  contactName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<ICurrency>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  levroRecipientId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type IAccountingVendorSyncing = {
  __typename?: 'AccountingVendorSyncing';
  syncing: Scalars['Boolean']['output'];
};

export type IAccountsWidget = IBaseWidget & {
  __typename?: 'AccountsWidget';
  accounts: Array<IAccount>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IActivationChecklistItem = IChecklistItem & {
  __typename?: 'ActivationChecklistItem';
  status: IChecklistItemStatus;
  step: IActivationChecklistStep;
};

export enum IActivationChecklistStep {
  FirstCardTransaction = 'FIRST_CARD_TRANSACTION',
  FirstDeposit = 'FIRST_DEPOSIT',
  FirstPayment = 'FIRST_PAYMENT',
  FirstRecipient = 'FIRST_RECIPIENT',
  InviteTeam = 'INVITE_TEAM'
}

/**
 * ⚠ Summary-view fields to avoid (use summary field instead):
 *   entity, autoRetryInfo, schedulingInfo, approvalInfo, receiptAvailable
 * On-demand fields: receiptUrl ⚠️
 */
export type IActivity = {
  __typename?: 'Activity';
  approvalInfo?: Maybe<IApprovalInfo>;
  /** Non-null iff the activity will be retried automatically */
  autoRetryInfo?: Maybe<IAutoRetryInfo>;
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  date: Scalars['Date']['output'];
  entity?: Maybe<IActivityEntity>;
  error?: Maybe<IActivityError>;
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  id: Scalars['ID']['output'];
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  receiptAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Set to null when there's no receipt - receipts are only prsent for for payment activities */
  receiptUrl?: Maybe<Scalars['String']['output']>;
  schedulingInfo?: Maybe<ISchedulingInfo>;
  status?: Maybe<IExecutionStatus>;
  summary?: Maybe<IActivitySummary>;
  type: IActivityType;
};

export type IActivityEntity = IConversion | IDeposit | IInternalTransfer | IPayment;

export type IActivityError = IComplianceError | IDefaultError | IInvalidRecipientError;

export type IActivitySummary = IConversionSummary | IDepositSummary | IInternalTransferSummary | IPaymentSummary;

export enum IActivityType {
  Conversion = 'CONVERSION',
  Deposit = 'DEPOSIT',
  InternalTransfer = 'INTERNAL_TRANSFER',
  Payment = 'PAYMENT'
}

export type IAddContractsToSeriesInput = {
  contractIds: Array<Scalars['ID']['input']>;
  /** If null, creates a new series. */
  contractInDestinationSeriesId?: InputMaybe<Scalars['ID']['input']>;
  setActiveContractInDestinationSeries?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies which remaining contract from the source series should be active after the current active version is removed from its series. Null if the current active version is not being moved or if no contracts remain. */
  setActiveContractInSourceSeries?: InputMaybe<Scalars['ID']['input']>;
};

export type IAddContractsToSeriesResponse = IBaseResponse & {
  __typename?: 'AddContractsToSeriesResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IAddress = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type IAddressInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type IAdminContract = {
  __typename?: 'AdminContract';
  contract: IContract;
  contractRawJson: Scalars['String']['output'];
  customer: ICustomer;
};

export type IAdminCustomerOrg = {
  __typename?: 'AdminCustomerOrg';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IAdminGetContractsInput = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  unannotated?: Scalars['Boolean']['input'];
};

export type IAdminGetContractsResponse = IBaseResponse & {
  __typename?: 'AdminGetContractsResponse';
  contracts: Array<IAdminContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IAdminGetCustomerOrgsResponse = IBaseResponse & {
  __typename?: 'AdminGetCustomerOrgsResponse';
  customerOrgs?: Maybe<Array<IAdminCustomerOrg>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IAdminUpdateContractInput = {
  annotatedJson: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
};

export type IAdminUpdateContractResponse = IBaseResponse & {
  __typename?: 'AdminUpdateContractResponse';
  errors?: Maybe<Array<IDefaultError>>;
  updatedContract?: Maybe<IContract>;
};

export type IAmountThresholdCriterion = {
  __typename?: 'AmountThresholdCriterion';
  /** Matches requests with amount greater than or equal to the threshold. */
  amountThreshold: IMoney;
};

export type IAmountThresholdCriterionInput = {
  /** Matches requests with amount greater than or equal to the threshold (currency is determined by the containing MultiLayerApprovalRulesInput). Flows using this criterion must have monotonically decreasing thresholds. */
  amountThreshold: Scalars['Float']['input'];
};

export type IAnalyzeBulkPaymentFileInput = {
  data: Array<IAnalyzeBulkPaymentRowInput>;
};

export type IAnalyzeBulkPaymentRowInput = {
  values: Array<InputMaybe<ISpreadsheetValueInput>>;
};

export type IAnnotatedObject = IContractAnnotationObject;

export type IAnnotation = {
  __typename?: 'Annotation';
  annotationJson: Scalars['String']['output'];
  annotatorIdentityId: Scalars['String']['output'];
  task: IAnnotationTask;
};

export type IAnnotationTask = {
  __typename?: 'AnnotationTask';
  annotatedObject?: Maybe<IAnnotatedObject>;
  annotations: Array<IAnnotation>;
  customer?: Maybe<IOrg>;
  file?: Maybe<IFile>;
  id: Scalars['String']['output'];
  inputJson?: Maybe<Scalars['String']['output']>;
  schemaJson: Scalars['String']['output'];
  schemaType: ISchemaType;
  schemaVersion: Scalars['String']['output'];
  status: IAnnotationTaskStatus;
};

export enum IAnnotationTaskStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED'
}

export type IApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Since the suffix is stored hashed, this is the primary identifier */
  prefix: Scalars['String']['output'];
};

export type IApplication = {
  __typename?: 'Application';
  applicationUrl?: Maybe<Scalars['String']['output']>;
  dbaName?: Maybe<Scalars['String']['output']>;
  documents: Array<IApplicationDocument>;
  id: Scalars['String']['output'];
  legalName: Scalars['String']['output'];
  status: IApplicationStatus;
};

export type IApplicationDocument = {
  __typename?: 'ApplicationDocument';
  /** Individual address, present only for the AddressVerification document type. */
  address?: Maybe<IAddress>;
  /** Present only for Passport and IdDocument document types. */
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** The document requirements description. */
  description: Scalars['String']['output'];
  documentType: IApplicationDocumentType;
  /** Business EIN. Present only for the EmployerIdentificationNumberConfirmation document type. */
  ein?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Name of business or individual. */
  name: Scalars['String']['output'];
  /** Individual passport number. Present only for the Passport document type. */
  passport?: Maybe<Scalars['String']['output']>;
  /** Application Document rejection reason. Present only when document status is Invalid. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Application Document rejection reason code. Present only when document status is Invalid. */
  reasonCode?: Maybe<IApplicationDocumentReasonCode>;
  status: IApplicationDocumentStatus;
};

/** https://docs.unit.co/resources#applicationdocument */
export enum IApplicationDocumentReasonCode {
  AddressMismatch = 'ADDRESS_MISMATCH',
  DobMismatch = 'DOB_MISMATCH',
  EinMismatch = 'EIN_MISMATCH',
  ExpiredId = 'EXPIRED_ID',
  NameMismatch = 'NAME_MISMATCH',
  Other = 'OTHER',
  PoorQuality = 'POOR_QUALITY',
  SsnMismatch = 'SSN_MISMATCH',
  StateMismatch = 'STATE_MISMATCH'
}

/** https://docs.unit.co/application-documents#application-document-status */
export enum IApplicationDocumentStatus {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  PendingReview = 'PENDING_REVIEW',
  ReceivedBack = 'RECEIVED_BACK',
  ReceivedFront = 'RECEIVED_FRONT',
  Required = 'REQUIRED'
}

/** https://docs.unit.co/application-documents#document-types */
export enum IApplicationDocumentType {
  AddressVerification = 'ADDRESS_VERIFICATION',
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  /** Client requested customer document */
  ClientRequested = 'CLIENT_REQUESTED',
  EmployerIdentificationNumberConfirmation = 'EMPLOYER_IDENTIFICATION_NUMBER_CONFIRMATION',
  IdDocument = 'ID_DOCUMENT',
  Passport = 'PASSPORT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  SelfieVerification = 'SELFIE_VERIFICATION',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD'
}

/** https://docs.unit.co/applications#application-statuses */
export enum IApplicationStatus {
  /** Application approved and account setup is complete */
  AccountSetup = 'ACCOUNT_SETUP',
  Approved = 'APPROVED',
  AwaitingDocuments = 'AWAITING_DOCUMENTS',
  Canceled = 'CANCELED',
  Denied = 'DENIED',
  /** User does not have an application yet */
  New = 'NEW',
  Pending = 'PENDING',
  PendingReview = 'PENDING_REVIEW',
  /** Failed to send application to Unit */
  SubmissionError = 'SUBMISSION_ERROR'
}

export type IApplicationSummary = {
  __typename?: 'ApplicationSummary';
  dbaName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalName: Scalars['String']['output'];
  status: IApplicationStatus;
};

export type IApplyCreditAccountInput = {
  /** Either the debit counterparty ID or levro account ID */
  autoPayAccountId: Scalars['String']['input'];
  autoPayAccountType: IRepaymentAccountType;
  dateOfIncorporation: Scalars['Date']['input'];
  estimatedAnnualRevenue: IMoneyInput;
  /** NAICS industry from naics_industries.yml */
  naicsIndustry: Scalars['String']['input'];
};

export type IApplyCreditAccountResponse = IBaseResponse & {
  __typename?: 'ApplyCreditAccountResponse';
  application?: Maybe<ICreditApplication>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IApproval = {
  __typename?: 'Approval';
  timestamp: Scalars['DateTime']['output'];
  type: IApprovalType;
  user: IUser;
};

export type IApprovalFlow = {
  __typename?: 'ApprovalFlow';
  id: Scalars['ID']['output'];
  /** Ordered sequence of layers, each of which must be satisfied before the next is considered. */
  layerConfigs: Array<ILayerConfig>;
};

export type IApprovalFlowAndCriterion = {
  __typename?: 'ApprovalFlowAndCriterion';
  approvalFlow: IApprovalFlow;
  /** If null, always matches. */
  criterion?: Maybe<IApprovalFlowCriterion>;
};

export type IApprovalFlowAndCriterionInput = {
  approvalFlow: IApprovalFlowInput;
  /** Must be null iff it is the last flow in a set of rules, thereby always matching. */
  criterion?: InputMaybe<IApprovalFlowCriterionInput>;
};

/** A criterion that is applied to a request to determine if this flow will be used for it. */
export type IApprovalFlowCriterion = IAmountThresholdCriterion;

/** A criterion that is applied to a request to determine if this flow will be used for it. */
export type IApprovalFlowCriterionInput =
  { amountThresholdCriterion: IAmountThresholdCriterionInput; };

export type IApprovalFlowInput = {
  /** Ordered sequence of layers, each of which must be satisfied before the next is considered. Must not be empty. */
  layerConfigs: Array<ILayerConfigInput>;
};

export type IApprovalFlowWidget = IBaseWidget & {
  __typename?: 'ApprovalFlowWidget';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IApprovalInfo = {
  __typename?: 'ApprovalInfo';
  /** null iff multi-layer approvals are not enabled for this request */
  multiLayerApprovalState?: Maybe<IMultiLayerApprovalState>;
  requestedAt: Scalars['DateTime']['output'];
  requester?: Maybe<IUser>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolver?: Maybe<IUser>;
  selfApproved?: Maybe<Scalars['Boolean']['output']>;
  status: IApprovalRequestStatus;
};

export enum IApprovalLogic {
  All = 'ALL',
  Any = 'ANY'
}

export enum IApprovalRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  PendingRelease = 'PENDING_RELEASE',
  Rejected = 'REJECTED'
}

export enum IApprovalType {
  ImplicitByRequester = 'IMPLICIT_BY_REQUESTER',
  Regular = 'REGULAR'
}

export type IApproveCreditApplicationInput = {
  creditApplicationId: Scalars['ID']['input'];
  creditLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type IApproveCreditApplicationResponse = IBaseResponse & {
  __typename?: 'ApproveCreditApplicationResponse';
  creditApplication?: Maybe<ICreditApplication>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IApprover = IRoleApprover | ISingleUserApprover | IUserGroupApprover | IVendorManagerApprover;

export type IApproverInput =
  { roleApprover: IRoleApproverInput; singleUserApprover?: never; userGroupApprover?: never; vendorManagerApprover?: never; }
  |  { roleApprover?: never; singleUserApprover: ISingleUserApproverInput; userGroupApprover?: never; vendorManagerApprover?: never; }
  |  { roleApprover?: never; singleUserApprover?: never; userGroupApprover: IUserGroupApproverInput; vendorManagerApprover?: never; }
  |  { roleApprover?: never; singleUserApprover?: never; userGroupApprover?: never; vendorManagerApprover: IVendorManagerApproverInput; };

export type IApproverState = {
  __typename?: 'ApproverState';
  approvals: Array<IApproval>;
  config: IApprover;
  pendingApprovers: Array<IUser>;
  satisfied: Scalars['Boolean']['output'];
};

export enum IApproverUserRole {
  Accountant = 'ACCOUNTANT',
  Administrator = 'ADMINISTRATOR',
  LiteAdmin = 'LITE_ADMIN',
  Reviewer = 'REVIEWER'
}

export type IAssistantBoard = IBaseAssistantEvent & {
  __typename?: 'AssistantBoard';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: IAssistantEventStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** ⚠️ Expensive. Do not use in list view ⚠️ */
  widgets: Array<IWidget>;
};

export type IAssistantEvent = IAssistantBoard | IAssistantMessage | IAssistantPythonSession | IAssistantToolCall | IAssistantToolSelection | IAssistantVariableDefinitions | IAssistantWorkflowSelection;

export enum IAssistantEventStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type IAssistantInvoicePrefill = {
  __typename?: 'AssistantInvoicePrefill';
  account?: Maybe<IAccount>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  invoiceAmount?: Maybe<IMoney>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<IInvoiceLineItem>>;
  /** Specify either payer or payerRequest. */
  payer?: Maybe<IPayer>;
  /** Specify either payer or payerRequest. */
  payerRequest?: Maybe<IAssistantPayerPrefill>;
};

export type IAssistantMessage = IBaseAssistantEvent & {
  __typename?: 'AssistantMessage';
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<IFile>>;
  id: Scalars['ID']['output'];
  role: IAssistantMessageRole;
  status: IAssistantEventStatus;
  /** The text of the message to display to a user */
  text?: Maybe<Scalars['String']['output']>;
};

export type IAssistantMessageInput =
  { textInput: Scalars['String']['input']; };

export enum IAssistantMessageRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type IAssistantPayerPrefill = {
  __typename?: 'AssistantPayerPrefill';
  defaultAccount?: Maybe<IAccount>;
  email?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
};

export type IAssistantProgress = {
  __typename?: 'AssistantProgress';
  ongoingAction?: Maybe<Scalars['String']['output']>;
};

export type IAssistantPythonSession = IBaseAssistantEvent & {
  __typename?: 'AssistantPythonSession';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  status: IAssistantEventStatus;
  transcript: Scalars['String']['output'];
};

export type IAssistantRecipientPrefill = {
  __typename?: 'AssistantRecipientPrefill';
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<IAddress>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paypalEmail?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  routingNumber2?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  venmoHandle?: Maybe<Scalars['String']['output']>;
};

export type IAssistantThread = {
  __typename?: 'AssistantThread';
  createdAt: Scalars['DateTime']['output'];
  /** Do not use in summary view */
  events: Array<IAssistantEvent>;
  id: Scalars['ID']['output'];
  lastActiveAt: Scalars['DateTime']['output'];
  /** Do not use in summary view */
  progress?: Maybe<IAssistantProgress>;
  status: IAssistantEventStatus;
  subject: Scalars['String']['output'];
};

export type IAssistantToolCall = IBaseAssistantEvent & {
  __typename?: 'AssistantToolCall';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: IAssistantEventStatus;
  toolArgs: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput?: Maybe<Scalars['String']['output']>;
};

export type IAssistantToolSelection = IBaseAssistantEvent & {
  __typename?: 'AssistantToolSelection';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  selectedTools: Array<Scalars['String']['output']>;
  status: IAssistantEventStatus;
};

export type IAssistantVariableDefinition = {
  __typename?: 'AssistantVariableDefinition';
  instructions: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IAssistantVariableDefinitions = IBaseAssistantEvent & {
  __typename?: 'AssistantVariableDefinitions';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: IAssistantEventStatus;
  variables: Array<IAssistantVariableDefinition>;
};

export type IAssistantWorkflowAnalysis = {
  __typename?: 'AssistantWorkflowAnalysis';
  cons: Scalars['String']['output'];
  pros: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  workflowName: Scalars['String']['output'];
};

export type IAssistantWorkflowSelection = IBaseAssistantEvent & {
  __typename?: 'AssistantWorkflowSelection';
  analysis: Array<IAssistantWorkflowAnalysis>;
  createdAt: Scalars['DateTime']['output'];
  decision?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: IAssistantEventStatus;
};

export type IAtmTransactionMetadata = {
  __typename?: 'AtmTransactionMetadata';
  atmLocation?: Maybe<Scalars['String']['output']>;
  atmName?: Maybe<Scalars['String']['output']>;
  cardId?: Maybe<Scalars['ID']['output']>;
  originalCurrencyAmount?: Maybe<IMoney>;
  surcharge?: Maybe<IMoney>;
};

export type IAttachActivityFilesInput = {
  activityId: Scalars['ID']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  showToRecipient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IAttachActivityFilesResponse = IBaseResponse & {
  __typename?: 'AttachActivityFilesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  files?: Maybe<Array<IFile>>;
};

export type IAttachEventInstanceFilesInput = {
  eventId: Scalars['ID']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  ordinal: Scalars['Int']['input'];
  showToRecipient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IAttachEventInstanceFilesResponse = IBaseResponse & {
  __typename?: 'AttachEventInstanceFilesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  files?: Maybe<Array<IFile>>;
};

export type IAttachScheduledEventFilesInput = {
  eventId: Scalars['ID']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  showToRecipient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IAttachScheduledEventFilesResponse = IBaseResponse & {
  __typename?: 'AttachScheduledEventFilesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  files?: Maybe<Array<IFile>>;
};

export type IAttachTransactionFilesInput = {
  fileIds: Array<Scalars['ID']['input']>;
  showToRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type IAttachTransactionFilesResponse = IBaseResponse & {
  __typename?: 'AttachTransactionFilesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  files?: Maybe<Array<IFile>>;
};

export type IAuthInfo = {
  __typename?: 'AuthInfo';
  isMfaSetUp: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  usesPhoneNumberForMfa: Scalars['Boolean']['output'];
};

export type IAutoRetryInfo = {
  __typename?: 'AutoRetryInfo';
  until: Scalars['Date']['output'];
};

export type IBankDetail = {
  __typename?: 'BankDetail';
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankBranch?: Maybe<Scalars['String']['output']>;
  bankCity?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankCountryIso?: Maybe<Scalars['String']['output']>;
  bankName: Scalars['String']['output'];
  bankPostCode?: Maybe<Scalars['String']['output']>;
  bankState?: Maybe<Scalars['String']['output']>;
  bicSwift?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  identifierType?: Maybe<Scalars['String']['output']>;
  identifierValue?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export enum IBankDetailIdentifier {
  Aba = 'ABA',
  BicSwift = 'BIC_SWIFT',
  BsbCode = 'BSB_CODE',
  Cnaps = 'CNAPS',
  Iban = 'IBAN',
  RoutingNumber = 'ROUTING_NUMBER',
  SortCode = 'SORT_CODE'
}

export type IBaseAssistantEvent = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: IAssistantEventStatus;
};

export type IBaseRate = {
  client: Scalars['Float']['output'];
  markup: Scalars['Float']['output'];
  midmarket: Scalars['Float']['output'];
};

export type IBaseResponse = {
  errors?: Maybe<Array<IDefaultError>>;
};

export type IBaseWidget = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IBaseWidgetStatus = {
  status: IWidgetStatusCategory;
};

export type IBill = {
  __typename?: 'Bill';
  /** All attached files. Use in details views, not summaries. */
  attachments: Array<IFile>;
  createdAt: Scalars['DateTime']['output'];
  /** ⚠️ Moderately expensive object. May increase latency in summary view ⚠ */
  details?: Maybe<IBillDetails>;
  id: Scalars['ID']['output'];
  /** ⚠️ Moderately expensive object. May increase latency in summary view ⚠ */
  payment?: Maybe<IBillPayment>;
  /** ⚠️ Moderately expensive object. May increase latency in summary view ⚠ */
  provenance?: Maybe<IBillProvenance>;
  status: IBillStatus;
  summary?: Maybe<IBillSummary>;
};

export type IBillAccountingItem = {
  __typename?: 'BillAccountingItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: IAccountingItemStatus;
  type: IAccountingItemType;
};

export type IBillDetails = {
  __typename?: 'BillDetails';
  billPaymentNominalAccount?: Maybe<INominalAccount>;
  lineItems: Array<IBillLineItem>;
  parsedRecipient?: Maybe<IParsedRecipient>;
  recipient?: Maybe<IRecipient>;
};

export type IBillDetailsWidget = IBaseWidget & {
  __typename?: 'BillDetailsWidget';
  bill: IBill;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IBillLineItem = {
  __typename?: 'BillLineItem';
  accountingClass?: Maybe<IAccountingCategory>;
  accountingCustomer?: Maybe<IAccountingCustomer>;
  accountingDepartment?: Maybe<IAccountingCategory>;
  accountingItem?: Maybe<IBillAccountingItem>;
  accountingLocation?: Maybe<IAccountingCategory>;
  accountingTaxRate?: Maybe<IAccountingTaxRate>;
  billId: Scalars['ID']['output'];
  billable?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  nominalAccount?: Maybe<INominalAccount>;
  ordinal: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type IBillLineItemInput = {
  accountingClassId?: InputMaybe<Scalars['ID']['input']>;
  accountingCustomerId?: InputMaybe<Scalars['ID']['input']>;
  accountingDepartmentId?: InputMaybe<Scalars['ID']['input']>;
  accountingItemId?: InputMaybe<Scalars['ID']['input']>;
  accountingLocationId?: InputMaybe<Scalars['ID']['input']>;
  accountingTaxRateId?: InputMaybe<Scalars['ID']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  nominalAccountId?: InputMaybe<Scalars['ID']['input']>;
  ordinal: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  total: Scalars['Float']['input'];
  unitAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type IBillPayLineItemPreferences = {
  __typename?: 'BillPayLineItemPreferences';
  showBillable: IToggleConstrainedValue;
  showClass: IToggleConstrainedValue;
  showCustomer: IToggleConstrainedValue;
  showDepartment: IToggleConstrainedValue;
  showLocation: IToggleConstrainedValue;
};

export type IBillPayLineItemPreferencesInput = {
  showBillable?: InputMaybe<IToggleValueInput>;
  showClass?: InputMaybe<IToggleValueInput>;
  showCustomer?: InputMaybe<IToggleValueInput>;
  showDepartment?: InputMaybe<IToggleValueInput>;
  showLocation?: InputMaybe<IToggleValueInput>;
};

export type IBillPayPreferences = {
  __typename?: 'BillPayPreferences';
  lineItems: IBillPayLineItemPreferences;
  showNominalPaymentAccounts: IToggleConstrainedValue;
};

export type IBillPayPreferencesInput = {
  lineItems?: InputMaybe<IBillPayLineItemPreferencesInput>;
  showNominalPaymentAccounts?: InputMaybe<IToggleValueInput>;
};

export type IBillPayWidget = IBaseWidget & {
  __typename?: 'BillPayWidget';
  bill: IBill;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/**
 * Type resolution:
 * - if the associated payment was self-approved and ran synchronously: Activity.
 * - otherwise: ScheduledPayment.
 */
export type IBillPayment = IActivity | IScheduledPayment;

/** Used when the bill is still being processed to tell clients when to call getBill */
export type IBillProcessingState = {
  __typename?: 'BillProcessingState';
  /** Expected wait time (in seconds) after which the bill shall have been processed. None iff the bill has already been processed, or cannot be processed. */
  expectedProcessingTimeSeconds?: Maybe<Scalars['Float']['output']>;
  status: IBillStatus;
};

export type IBillProvenance = {
  __typename?: 'BillProvenance';
  /** Non-null if the bill was created from an email. */
  invoiceEmail?: Maybe<IInvoiceEmail>;
  /** Non-null if the bill was created from an invoice file. */
  invoiceFile?: Maybe<IFile>;
};

export enum IBillStatus {
  Canceled = 'CANCELED',
  FullyApproved = 'FULLY_APPROVED',
  /** bill has no invoice, and requires manual input. */
  NoInvoiceProcessed = 'NO_INVOICE_PROCESSED',
  /** bill updated manually; payment not yet created. */
  Overwritten = 'OVERWRITTEN',
  Paid = 'PAID',
  PendingApproval = 'PENDING_APPROVAL',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  ProcessingFailed = 'PROCESSING_FAILED'
}

export type IBillSummary = {
  __typename?: 'BillSummary';
  amount?: Maybe<Scalars['Float']['output']>;
  billDate?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  method?: Maybe<IPaymentMethod>;
  reason?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
};

export type IBillTableWidget = IBaseWidget & {
  __typename?: 'BillTableWidget';
  bills: Array<IBill>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum IBillingTerms {
  AdHoc = 'AD_HOC',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type IBlobConstrainedValue = {
  __typename?: 'BlobConstrainedValue';
  blob?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type IBlobValueInput = {
  blob?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type IBoolBulkPaymentColumn = {
  __typename?: 'BoolBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['Boolean']['output']>>;
};

export type IBrandingPreferences = {
  __typename?: 'BrandingPreferences';
  logoFile: IFileConstrainedValue;
  primaryColorHex: ITextConstrainedValue;
  secondaryColorHex: ITextConstrainedValue;
};

export type IBrandingPreferencesInput = {
  logoFile?: InputMaybe<IFileValueInput>;
  primaryColorHex?: InputMaybe<ITextValueInput>;
  secondaryColorHex?: InputMaybe<ITextValueInput>;
};

export type IBulkPayment = {
  __typename?: 'BulkPayment';
  files: Array<IFile>;
  id: Scalars['String']['output'];
};

export type IBulkPaymentAnalysisResponse = IBaseResponse & {
  __typename?: 'BulkPaymentAnalysisResponse';
  coverWireFees?: Maybe<IBoolBulkPaymentColumn>;
  destinationAmount?: Maybe<IFloatBulkPaymentColumn>;
  destinationCurrency?: Maybe<IStrBulkPaymentColumn>;
  errors?: Maybe<Array<IDefaultError>>;
  invoiceDate?: Maybe<IDateBulkPaymentColumn>;
  invoiceNumber?: Maybe<IStrBulkPaymentColumn>;
  levroRecipientId?: Maybe<IStrBulkPaymentColumn>;
  method?: Maybe<IPaymentMethodBulkPaymentColumn>;
  numRows: Scalars['Int']['output'];
  purposeCode?: Maybe<IStrBulkPaymentColumn>;
  reason?: Maybe<IStrBulkPaymentColumn>;
  recipientEmail?: Maybe<IStrBulkPaymentColumn>;
  recipientName?: Maybe<IStrBulkPaymentColumn>;
  reference?: Maybe<IStrBulkPaymentColumn>;
  sourceAmount?: Maybe<IFloatBulkPaymentColumn>;
  sourceCurrency?: Maybe<IStrBulkPaymentColumn>;
  unmappedColumns: Array<IUnmappedBulkPaymentColumn>;
};

export type IBulkPaymentWidgetStatus = IBaseWidgetStatus & {
  __typename?: 'BulkPaymentWidgetStatus';
  bulkPaymentId?: Maybe<Scalars['String']['output']>;
  status: IWidgetStatusCategory;
};

export type ICadAccountDetails = IAccountDetailsWithLocalPayIns & {
  __typename?: 'CADAccountDetails';
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  branchTransitNumber: Scalars['String']['output'];
  institutionNumber: Scalars['String']['output'];
  localPaymentRailName?: Maybe<Scalars['String']['output']>;
  routingCode: Scalars['String']['output'];
  swift: ISwiftAccountDetails;
  transitNumberMicr: Scalars['String']['output'];
};

export type ICachedRate = IBaseRate & {
  __typename?: 'CachedRate';
  asOf: Scalars['DateTime']['output'];
  client: Scalars['Float']['output'];
  markup: Scalars['Float']['output'];
  midmarket: Scalars['Float']['output'];
};

export type ICancelBillInput = {
  billId: Scalars['String']['input'];
};

export type ICancelBillResponse = IBaseResponse & {
  __typename?: 'CancelBillResponse';
  bill?: Maybe<IBill>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICancelEventInstanceInput = {
  eventId: Scalars['String']['input'];
  ordinal: Scalars['Int']['input'];
};

export type ICancelEventInstanceResponse = IBaseResponse & {
  __typename?: 'CancelEventInstanceResponse';
  canceled: Scalars['Boolean']['output'];
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  eventInstance?: Maybe<IEventInstance>;
};

export type ICancelScheduledEventInput = {
  eventId: Scalars['String']['input'];
};

export type ICancelScheduledEventResponse = IBaseResponse & {
  __typename?: 'CancelScheduledEventResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  event?: Maybe<IScheduledEvent>;
};

export type ICannotReduceRecipientManagerPermissionError = IErrorInterface & {
  __typename?: 'CannotReduceRecipientManagerPermissionError';
  message: Scalars['String']['output'];
  nRecipientsManaged: Scalars['Int']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type ICannotUpdateBusinessContactRoleError = IErrorInterface & {
  __typename?: 'CannotUpdateBusinessContactRoleError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type ICard = {
  __typename?: 'Card';
  billingAddress: IAddress;
  cardHolderEmail?: Maybe<Scalars['String']['output']>;
  cardHolderFullName: Scalars['String']['output'];
  cardHolderPhone?: Maybe<Scalars['String']['output']>;
  cardLast4: Scalars['String']['output'];
  cardLimit?: Maybe<ICardLimit>;
  cardName?: Maybe<Scalars['String']['output']>;
  cardType: ICardType;
  expirationDate: Scalars['Date']['output'];
  funding: IFundingType;
  id: Scalars['ID']['output'];
  pinStatus?: Maybe<IPinStatus>;
  shippingAddress?: Maybe<IAddress>;
  status: ICardStatus;
  userId: Scalars['ID']['output'];
};

export type ICardActionResponse = IBaseResponse & {
  __typename?: 'CardActionResponse';
  card?: Maybe<ICard>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICardActionWidget = IBaseWidget & {
  __typename?: 'CardActionWidget';
  action?: Maybe<Scalars['String']['output']>;
  cardId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: IWidgetStatus;
  title: Scalars['String']['output'];
};

export type ICardAuthorization = {
  __typename?: 'CardAuthorization';
  amount: IMoney;
  cardLast4: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<ICardTransactionMetadata>;
  status: ICardAuthorizationStatus;
  summary: Scalars['String']['output'];
};

export enum ICardAuthorizationStatus {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED'
}

export type ICardLimit = ICreditCardLimit | IDebitCardLimit;

export enum ICardPaymentMethod {
  ChipAndPin = 'CHIP_AND_PIN',
  Contactless = 'CONTACTLESS',
  Manual = 'MANUAL',
  Other = 'OTHER',
  Stored = 'STORED',
  Swipe = 'SWIPE'
}

export enum ICardStatus {
  Active = 'ACTIVE',
  ClosedByCustomer = 'CLOSED_BY_CUSTOMER',
  Frozen = 'FROZEN',
  Inactive = 'INACTIVE',
  Lost = 'LOST',
  Stolen = 'STOLEN',
  SuspectedFraud = 'SUSPECTED_FRAUD'
}

export type ICardTransactionMetadata = IAtmTransactionMetadata | IPurchaseTransactionMetadata;

export enum ICardTransactionType {
  Atm = 'ATM',
  Card = 'CARD',
  CardReversal = 'CARD_REVERSAL',
  Purchase = 'PURCHASE'
}

export enum ICardType {
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export type ICardsInput = {
  /** Funding or account ID must be provided if card ID is not. Only provide funding or account ID not both */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  cardHolderUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Card ID must be provided if funding is not */
  cardId?: InputMaybe<Scalars['ID']['input']>;
  /** Funding or account ID must be provided if card ID is not. Only provide funding or account ID not both */
  funding?: InputMaybe<IFundingType>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type ICardsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'CardsResponse';
  cards?: Maybe<Array<ICard>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export type ICashManagementVariancePeriodData = {
  __typename?: 'CashManagementVariancePeriodData';
  actual: IMultiCurrencyMoney;
  actualIncludesUnpaidBill: Scalars['Boolean']['output'];
  planned: IMultiCurrencyMoneyFormula;
  plannedIsAverageFromNPeriods?: Maybe<Scalars['Int']['output']>;
  variance: IMultiCurrencyMoneyFormula;
};

export type ICheckDepositWidget = IBaseWidget & {
  __typename?: 'CheckDepositWidget';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ICheckRecipientInvitationTokenResponse = IBaseResponse & {
  __typename?: 'CheckRecipientInvitationTokenResponse';
  activeFeatures: Array<IFeatureFlag>;
  errors?: Maybe<Array<IDefaultError>>;
  recipientInvitation?: Maybe<IRecipientInvitationForRecipient>;
};

export type ICheckVerificationForCustomerInput = {
  code: Scalars['String']['input'];
};

export type ICheckVerificationInput = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ICheckVerificationResponse = IBaseResponse & {
  __typename?: 'CheckVerificationResponse';
  errors?: Maybe<Array<IDefaultError>>;
  success: Scalars['Boolean']['output'];
};

/** Used for representing a statement containing checking account transactions */
export type ICheckingAccountStatement = IAccountStatementInterface & {
  __typename?: 'CheckingAccountStatement';
  account: IAccount;
  /** ⚠️ Expensive. Do not use in summary view */
  balance: ICreditStatementBalance;
  /** ⚠️ Expensive. Generated on demand */
  csvUrl?: Maybe<Scalars['String']['output']>;
  /** ⚠️ Expensive. Generated on demand */
  html?: Maybe<Scalars['String']['output']>;
  /** We identify statements by their period, eg 2023-01 */
  id: Scalars['ID']['output'];
  /** ⚠️ Expensive. Generated on demand */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  period: IPeriod;
  /** ⚠️ Expensive. Generated on demand */
  qboUrl?: Maybe<Scalars['String']['output']>;
  statementDate: Scalars['Date']['output'];
};

export type IChecklistItem = {
  status: IChecklistItemStatus;
};

export enum IChecklistItemStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

export type ICloseAccountInput = {
  id: Scalars['ID']['input'];
};

export type ICloseAccountResponse = IBaseResponse & {
  __typename?: 'CloseAccountResponse';
  account?: Maybe<IAccount>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICloseCustomerAccountInput = {
  customerId: Scalars['String']['input'];
  reason: ICloseReason;
};

export type ICloseCustomerAccountResponse = IBaseResponse & {
  __typename?: 'CloseCustomerAccountResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export enum ICloseReason {
  BreachOfTc = 'BREACH_OF_TC',
  ByBank = 'BY_BANK',
  ByBankSuspectedFraud = 'BY_BANK_SUSPECTED_FRAUD',
  ByCustomer = 'BY_CUSTOMER',
  Fraud = 'FRAUD',
  NegativeBalance = 'NEGATIVE_BALANCE',
  NoAccountActivity = 'NO_ACCOUNT_ACTIVITY',
  Overdue = 'OVERDUE',
  ProgramChange = 'PROGRAM_CHANGE'
}

export type IComment = {
  __typename?: 'Comment';
  author: IUser;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type ICommentInput = {
  content: Scalars['String']['input'];
};

export type IComplianceError = IErrorInterface & {
  __typename?: 'ComplianceError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export enum IConfidence {
  /** The value was parsed / annotated by us, but not validated or written by the user. We are confident in the value. */
  ParsedCertain = 'PARSED_CERTAIN',
  /** The value was parsed / annotated by us, but not validated or written by the user. We are not confident in the value. */
  ParsedUncertain = 'PARSED_UNCERTAIN',
  /** The value was validated (typically written) by the user. */
  UserValidated = 'USER_VALIDATED'
}

export type IConnectAccountInput = {
  plaidAccounts: Array<IPlaidAccount>;
  publicPlaidToken: Scalars['String']['input'];
};

export type IConnectAccountResponse = IBaseResponse & {
  __typename?: 'ConnectAccountResponse';
  accounts?: Maybe<Array<IConnectedAccount>>;
  errors?: Maybe<Array<IDefaultError>>;
};

/** ⚠️ Summary-view fields to avoid: balances ⚠ */
export type IConnectedAccount = IBaseResponse & {
  __typename?: 'ConnectedAccount';
  accountNumberLast4?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<IAccountType>;
  /** ⚠ Expensive */
  balances?: Maybe<IConnectedAccountBalances>;
  bankName: Scalars['String']['output'];
  errors?: Maybe<Array<IDefaultError>>;
  id: Scalars['ID']['output'];
  /** ⚠ Expensive */
  isAutoPay?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** ⚠ Expensive */
  recipientId?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export type IConnectedAccountBalances = {
  __typename?: 'ConnectedAccountBalances';
  availableBalance?: Maybe<IMoney>;
  currentBalance?: Maybe<IMoney>;
  errors?: Maybe<Array<IPlaidError>>;
  isMicrodepositAccount: Scalars['Boolean']['output'];
};

/** Used for representing a statement containing all accounts' transactions */
export type IConsolidatedAccountStatement = {
  __typename?: 'ConsolidatedAccountStatement';
  /** ⚠️ Expensive. Generated on demand */
  csvZipUrl?: Maybe<Scalars['String']['output']>;
  /** We identify statements by their period, eg 2023-01 */
  id: Scalars['ID']['output'];
  /** ⚠️ Expensive. Generated on demand */
  pdfZipUrl?: Maybe<Scalars['String']['output']>;
  period: IPeriod;
  /** ⚠️ Expensive. Generated on demand */
  qboZipUrl?: Maybe<Scalars['String']['output']>;
  statementDate: Scalars['Date']['output'];
};

export type IContract = {
  __typename?: 'Contract';
  accountingCategories?: Maybe<Array<IAccountingCategory>>;
  allVersions: Array<IContract>;
  /** Annual contract value based on the first billing year of the contract. */
  annualContractValue?: Maybe<IMoneyFormula>;
  autoRenews?: Maybe<Scalars['Boolean']['output']>;
  billingTerms?: Maybe<IBillingTerms>;
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  confidences?: Maybe<IContractConfidences>;
  department?: Maybe<IDepartment>;
  displayName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  file?: Maybe<IFile>;
  /** True if the contract is gated due to customer tier */
  gated?: Maybe<Scalars['Boolean']['output']>;
  /** True only if the contract is known to have ended (even if end_date is not known); False or None otherwise. */
  hasEnded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isActiveVersion: Scalars['Boolean']['output'];
  /** True if the contract is a sample */
  isSample?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<IContractLocations>;
  nominalAccounts?: Maybe<Array<INominalAccount>>;
  notValidatedFieldsOmitted: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  noticePeriodDays?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<IUser>;
  ownerName?: Maybe<Scalars['String']['output']>;
  /** parsedRecipient is null if recipient not-null */
  parsedRecipient?: Maybe<IParsedRecipient>;
  paymentObligations?: Maybe<Array<IContractPaymentObligation>>;
  paymentSummary?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<IPaymentTerms>;
  processingStatus?: Maybe<IContractProcessingStatus>;
  purchaseOrderId?: Maybe<Scalars['ID']['output']>;
  recipient?: Maybe<IRecipient>;
  recipientDisplayName?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['Date']['output']>;
  signatureDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<IContractStatus>;
  termsUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type IContractAnnotationObject = {
  __typename?: 'ContractAnnotationObject';
  termsUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type IContractCashflowWidget = IBaseWidget & {
  __typename?: 'ContractCashflowWidget';
  cashflow: IContractsCashflow;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IContractConfidences = {
  __typename?: 'ContractConfidences';
  annualContractValueConfidence?: Maybe<IConfidence>;
  autoRenewsConfidence?: Maybe<IConfidence>;
  billingFrequencyConfidence?: Maybe<IConfidence>;
  endDateConfidence?: Maybe<IConfidence>;
  noticePeriodDaysConfidence?: Maybe<IConfidence>;
  paymentTermsConfidence?: Maybe<IConfidence>;
  recipientConfidence?: Maybe<IConfidence>;
  renewalDateConfidence?: Maybe<IConfidence>;
  signatureDateConfidence?: Maybe<IConfidence>;
  startDateConfidence?: Maybe<IConfidence>;
};

export type IContractDetailsWidget = IBaseWidget & {
  __typename?: 'ContractDetailsWidget';
  contract: IContract;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IContractLocations = {
  __typename?: 'ContractLocations';
  autoRenewsLocation?: Maybe<ILocation>;
  billingFrequencyLocation?: Maybe<ILocation>;
  endDateLocation?: Maybe<ILocation>;
  noticePeriodDaysLocation?: Maybe<ILocation>;
  paymentTermsLocation?: Maybe<ILocation>;
  paymentsLocations: IPaymentsLocations;
  recipientLocations: IRecipientLocations;
  renewalDateLocation?: Maybe<ILocation>;
  signatureDateLocation?: Maybe<ILocation>;
  startDateLocation?: Maybe<ILocation>;
};

export type IContractPaymentObligation = {
  __typename?: 'ContractPaymentObligation';
  amount: IVariableMoney;
  /** Date on which the payment is billed/invoiced */
  billDate?: Maybe<Scalars['Date']['output']>;
  contractId: Scalars['ID']['output'];
  /** Date on which the payment is due w.r.t. bill_date and the payment terms */
  dueDate?: Maybe<Scalars['Date']['output']>;
  hasVariableComponent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  purpose: Scalars['String']['output'];
};

export type IContractPaymentObligationInput = {
  amount: IVariableMoneyInput;
  /** Date on which the payment is billed/invoiced */
  billDate?: InputMaybe<Scalars['Date']['input']>;
  hasVariableComponent: Scalars['Boolean']['input'];
  /** For an existing payment obligation, the ID. For a new payment obligation, None. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** For a new payment obligation, a unique but repeatable string key. For an existing payment obligation, None. */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  purpose: Scalars['String']['input'];
};

export enum IContractProcessingStatus {
  /** Contract has been deleted; typically not visible over GQL */
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum IContractStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Upcoming = 'UPCOMING'
}

export type IContractTableWidget = IBaseWidget & {
  __typename?: 'ContractTableWidget';
  contracts: Array<IContract>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IContractsCashManagementPeriod = {
  __typename?: 'ContractsCashManagementPeriod';
  endDate: Scalars['Date']['output'];
  isAggregate: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
};

export type IContractsCashManagementRecipient = {
  __typename?: 'ContractsCashManagementRecipient';
  /** True if the recipient has no contracts, only accounting data */
  accountingDataOnly: Scalars['Boolean']['output'];
  amounts: Array<ICashManagementVariancePeriodData>;
  /** Contracts will not include complex fields such as all_versions and payment_obligations. */
  contracts: Array<IContract>;
  /** arbitrary unique ID for this row */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IContractsCashflow = {
  __typename?: 'ContractsCashflow';
  /** order: cells[row][column] */
  cells: Array<Array<IContractsCashflowCell>>;
  /** order: column_aggregates[column] */
  columnAggregates: Array<IContractsCashflowAggregate>;
  /** order: column_metadata[column] */
  columnMetadata: Array<IContractsCashflowColumnMetadata>;
  /** order: row_aggregate_column_metadata[aggregate_period] */
  rowAggregateColumnMetadata: Array<IContractsCashflowColumnMetadata>;
  /** order: row_aggregates[row][aggregate_period] */
  rowAggregates: Array<Array<IContractsCashflowAggregate>>;
  /** order: row_metadata[row] */
  rowMetadata: Array<IContractsCashflowRowMetadata>;
  /** order: table_aggregates[aggregate_period] */
  tableAggregates: Array<IContractsCashflowAggregate>;
};

export type IContractsCashflowAggregate = {
  __typename?: 'ContractsCashflowAggregate';
  /**
   * Per-currency total amounts for this (row, column) pair, sorted by currency code ascending.
   * Typically, this will be a single-element list.
   */
  perCurrencyTotals: Array<IMoneyFormula>;
};

export enum IContractsCashflowAggregatePeriod {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Weeks_13 = 'WEEKS_13',
  Year = 'YEAR'
}

export type IContractsCashflowCell = {
  __typename?: 'ContractsCashflowCell';
  /**
   * Per-currency total amounts for this (row, column) pair, sorted by currency code ascending.
   * Typically, this will be a single-element list.
   */
  perCurrencyTotals: Array<IMoneyFormula>;
};

export type IContractsCashflowColumnMetadata = {
  __typename?: 'ContractsCashflowColumnMetadata';
  periodEnd: Scalars['Date']['output'];
  periodLabel: Scalars['String']['output'];
  periodStart: Scalars['Date']['output'];
};

export type IContractsCashflowContractRowMetadata = {
  __typename?: 'ContractsCashflowContractRowMetadata';
  contract: IContract;
};

export type IContractsCashflowDepartmentRowMetadata = {
  __typename?: 'ContractsCashflowDepartmentRowMetadata';
  contracts: Array<IContract>;
  department: IDepartment;
};

export type IContractsCashflowOwnerRowMetadata = {
  __typename?: 'ContractsCashflowOwnerRowMetadata';
  contracts: Array<IContract>;
  ownerName: Scalars['String']['output'];
};

export type IContractsCashflowRecipientRowMetadata = {
  __typename?: 'ContractsCashflowRecipientRowMetadata';
  contracts: Array<IContract>;
  parsedRecipient?: Maybe<IParsedRecipient>;
  recipient?: Maybe<IRecipient>;
  recipientDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum IContractsCashflowRowCategory {
  Contract = 'CONTRACT',
  Department = 'DEPARTMENT',
  Owner = 'OWNER',
  Recipient = 'RECIPIENT'
}

export type IContractsCashflowRowMetadata = IContractsCashflowContractRowMetadata | IContractsCashflowDepartmentRowMetadata | IContractsCashflowOwnerRowMetadata | IContractsCashflowRecipientRowMetadata;

export type IContractsVariance = {
  __typename?: 'ContractsVariance';
  periods: Array<IContractsCashManagementPeriod>;
  recipients: Array<IContractsCashManagementRecipient>;
  totals: Array<ICashManagementVariancePeriodData>;
};

/** ⚠️ Expensive object. Avoid using in summary view ⚠ */
export type IConversion = {
  __typename?: 'Conversion';
  /** User visible confirmation number */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  destinationAmount: IMoney;
  id: Scalars['ID']['output'];
  payment?: Maybe<IPayment>;
  rate?: Maybe<ICachedRate>;
  /** The date that the conversion settled - set to none before its released */
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  sourceAmount: IMoney;
  status: IExecutionStatus;
  /** The transaction pairs associated with this conversion. For multi-instance conversions (e.g. exchange rate averaging), this includes all instances in ascending order of sourceTransaction.date */
  transactions: Array<IConversionTransactions>;
};

export type IConversionBelowLimitError = IErrorInterface & {
  __typename?: 'ConversionBelowLimitError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IConversionFailedError = IErrorInterface & {
  __typename?: 'ConversionFailedError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IConversionRateChangedError = IErrorInterface & {
  __typename?: 'ConversionRateChangedError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IConversionSummary = {
  __typename?: 'ConversionSummary';
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  destinationAmount: IVariableMoney;
  sourceAmount: IVariableMoney;
};

export type IConversionTransactions = ITransactionPair & {
  __typename?: 'ConversionTransactions';
  destinationTransaction?: Maybe<ITransaction>;
  sourceTransaction?: Maybe<ITransaction>;
};

export type IConvertVendorMissingContractInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type IConvertVendorMissingContractResponse = IBaseResponse & {
  __typename?: 'ConvertVendorMissingContractResponse';
  contract?: Maybe<IContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICoordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type ICounterparty = {
  __typename?: 'Counterparty';
  displayText: Scalars['String']['output'];
};

export type ICreateAccountInput = {
  currency: ICurrency;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ICreateAccountResponse = IBaseResponse & {
  __typename?: 'CreateAccountResponse';
  account?: Maybe<IAccount>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateActivityCommentInput = {
  activityId: Scalars['ID']['input'];
  comment: ICommentInput;
};

export type ICreateActivityCommentResponse = IBaseResponse & {
  __typename?: 'CreateActivityCommentResponse';
  comment?: Maybe<IComment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateAndLinkAccountingVendorInput = {
  levroRecipientId: Scalars['ID']['input'];
};

export type ICreateAndLinkAccountingVendorResponse = IBaseResponse & {
  __typename?: 'CreateAndLinkAccountingVendorResponse';
  errors?: Maybe<Array<IDefaultError>>;
  levroRecipientId?: Maybe<Scalars['String']['output']>;
};

export type ICreateBillInput = {
  /** These attachments will not be parsed, they are for display purposes only */
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
};

export type ICreateBillResponse = IBaseResponse & {
  __typename?: 'CreateBillResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  id?: Maybe<Scalars['ID']['output']>;
  /** null only on error */
  processingState?: Maybe<IBillProcessingState>;
};

/** Use appropriate limit field for Credit or Debit type */
export type ICreateCardInput = {
  cardHolderUserId: Scalars['ID']['input'];
  cardName?: InputMaybe<Scalars['String']['input']>;
  creditCardLimit?: InputMaybe<ICreditCardLimitInput>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  debitCardLimit?: InputMaybe<IDebitCardLimitInput>;
  funding: IFundingType;
  idempotencyKey: Scalars['String']['input'];
  shippingAddress?: InputMaybe<IAddressInput>;
  type: ICardType;
};

export type ICreateCardResponse = IBaseResponse & {
  __typename?: 'CreateCardResponse';
  card?: Maybe<ICard>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateCheckDepositInput = {
  amount: IMoneyInput;
  depositAccountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
};

export type ICreateCheckDepositResponse = IBaseResponse & {
  __typename?: 'CreateCheckDepositResponse';
  activity?: Maybe<IActivity>;
  checkDepositId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateContractCommentInput = {
  comment: ICommentInput;
  contractId: Scalars['ID']['input'];
};

export type ICreateContractCommentResponse = IBaseResponse & {
  __typename?: 'CreateContractCommentResponse';
  comment?: Maybe<IComment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateContractFromProcurementRequestInput = {
  procurementRequestId: Scalars['ID']['input'];
};

export type ICreateContractFromProcurementRequestResponse = IBaseResponse & {
  __typename?: 'CreateContractFromProcurementRequestResponse';
  /** None only on error */
  contract?: Maybe<IContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateConversionWidget = IBaseWidget & {
  __typename?: 'CreateConversionWidget';
  amortized?: Maybe<Scalars['Boolean']['output']>;
  /** Provide when available, otherwise set destinationCurrency */
  destinationAccountId?: Maybe<Scalars['ID']['output']>;
  /** Either source or destination amount will be set */
  destinationAmount?: Maybe<IVariableMoney>;
  id: Scalars['ID']['output'];
  note?: Maybe<INote>;
  rrule?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['ID']['output'];
  /** Either source or destination amount will be set */
  sourceAmount?: Maybe<IVariableMoney>;
  status: IWidgetStatus;
  targetDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
};

export type ICreateDepartmentInput = {
  departmentName: Scalars['String']['input'];
};

export type ICreateDepartmentResponse = IBaseResponse & {
  __typename?: 'CreateDepartmentResponse';
  department?: Maybe<IDepartment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateDraftAccrualInput = {
  accountingClassId?: InputMaybe<Scalars['String']['input']>;
  accountingDepartmentId?: InputMaybe<Scalars['String']['input']>;
  accountingExpenseAccountId?: InputMaybe<Scalars['String']['input']>;
  accountingJournalEntryId?: InputMaybe<Scalars['String']['input']>;
  accountingLiabilityAccountId?: InputMaybe<Scalars['String']['input']>;
  accountingLocationId?: InputMaybe<Scalars['String']['input']>;
  accountingVendorId?: InputMaybe<Scalars['String']['input']>;
  accrualDateUtc?: InputMaybe<Scalars['Date']['input']>;
  amount?: InputMaybe<IVariableMoneyInput>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  postedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  unitAmount?: InputMaybe<IVariableMoneyInput>;
};

export type ICreateDraftAccrualsInput = {
  expenseAccruals: Array<ICreateDraftAccrualInput>;
};

export type ICreateDraftPaymentError = IDefaultError | IDuplicatePaymentCreationError;

export type ICreateDraftPaymentInput = {
  amount?: InputMaybe<IMoneyInput>;
  dueDateUtc?: InputMaybe<Scalars['Date']['input']>;
  idempotencyKey: Scalars['String']['input'];
  method?: InputMaybe<IPaymentMethod>;
  paymentReason?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<ISuperSheetsRecipientInput>;
};

export type ICreateDraftPaymentsError = {
  __typename?: 'CreateDraftPaymentsError';
  errors: Array<ICreateDraftPaymentError>;
  idempotencyKey: Scalars['String']['output'];
};

export type ICreateDraftPaymentsInput = {
  payments: Array<ICreateDraftPaymentInput>;
};

export type ICreateEventInstanceCommentInput = {
  comment: ICommentInput;
  eventId: Scalars['ID']['input'];
  ordinal: Scalars['Int']['input'];
};

export type ICreateEventInstanceCommentResponse = IBaseResponse & {
  __typename?: 'CreateEventInstanceCommentResponse';
  comment?: Maybe<IComment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateFileInput = {
  category: IFileCategory;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ICreateFileResponse = IBaseResponse & {
  __typename?: 'CreateFileResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Null only on error. */
  urlForUpload?: Maybe<Scalars['String']['output']>;
};

export type ICreateInvoiceInput = {
  depositAccountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Date']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  invoiceAmount: IMoneyInput;
  invoiceDate: Scalars['Date']['input'];
  invoiceNumber: Scalars['String']['input'];
  lineItems: Array<IInvoiceLineItemInput>;
  /** Specific payment method, if specified. If not, include all payment methods for currency on the invoice */
  method?: InputMaybe<IPaymentMethod>;
  note?: InputMaybe<INoteInput>;
  /** Specify either payerId or payerRequest. */
  payerId?: InputMaybe<Scalars['ID']['input']>;
  /** Note included in email to customer */
  payerNote?: InputMaybe<Scalars['String']['input']>;
  /** Specify either payerId or payerRequest. */
  payerRequest?: InputMaybe<ICreatePayerInput>;
  /** Send the payer an email with the invoice */
  sendEmail: Scalars['Boolean']['input'];
};

export type ICreateInvoiceResponse = IBaseResponse & {
  __typename?: 'CreateInvoiceResponse';
  errors?: Maybe<Array<IDefaultError>>;
  invoice?: Maybe<IInvoice>;
};

export type ICreateInvoiceWidget = IBaseWidget & {
  __typename?: 'CreateInvoiceWidget';
  id: Scalars['ID']['output'];
  invoice: IAssistantInvoicePrefill;
  status: IWidgetStatus;
  title: Scalars['String']['output'];
};

export type ICreatePayerInput = {
  address?: InputMaybe<IAddressInput>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  defaultDepositAccountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  payerName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ICreatePayerResponse = IBaseResponse & {
  __typename?: 'CreatePayerResponse';
  errors?: Maybe<Array<IDefaultError>>;
  payer?: Maybe<IPayer>;
};

export type ICreatePlaidLinkTokenResponse = IBaseResponse & {
  __typename?: 'CreatePlaidLinkTokenResponse';
  errors?: Maybe<Array<IDefaultError>>;
  plaidLinkToken?: Maybe<Scalars['String']['output']>;
};

export type ICreateProcurementRequestInput = {
  annualContractValue?: InputMaybe<IMoneyFormulaInput>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  estimatedStartDate?: InputMaybe<Scalars['Date']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type ICreateProcurementRequestResponse = IBaseResponse & {
  __typename?: 'CreateProcurementRequestResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** None only on error */
  request?: Maybe<IProcurementRequest>;
};

export type ICreateRecipientUserFromInvitationInput = {
  newAccountInfo: IRecipientUserIdentityInput;
  token: Scalars['String']['input'];
};

export type ICreateRecipientUserFromInvitationResponse = IBaseResponse & {
  __typename?: 'CreateRecipientUserFromInvitationResponse';
  accountCreated: Scalars['Boolean']['output'];
  errors?: Maybe<Array<IDefaultError>>;
  /** Present when a new Auth0 account was created for the recipient */
  passwordResetUrl?: Maybe<Scalars['String']['output']>;
};

export type ICreateRecipientWidget = IBaseWidget & {
  __typename?: 'CreateRecipientWidget';
  id: Scalars['ID']['output'];
  recipient: IAssistantRecipientPrefill;
  status: ICreateRecipientWidgetStatus;
  title: Scalars['String']['output'];
};

export type ICreateRecipientWidgetStatus = IBaseWidgetStatus & {
  __typename?: 'CreateRecipientWidgetStatus';
  recipientId?: Maybe<Scalars['String']['output']>;
  status: IWidgetStatusCategory;
};

export type ICreateScheduledEventCommentInput = {
  comment: ICommentInput;
  eventId: Scalars['ID']['input'];
};

export type ICreateScheduledEventCommentResponse = IBaseResponse & {
  __typename?: 'CreateScheduledEventCommentResponse';
  comment?: Maybe<IComment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateSuperSheetsPaymentResponse = {
  __typename?: 'CreateSuperSheetsPaymentResponse';
  errors?: Maybe<Array<ICreateDraftPaymentError>>;
  payment?: Maybe<ISuperSheetsPayment>;
};

export type ICreateSuperSheetsPaymentsResponse = {
  __typename?: 'CreateSuperSheetsPaymentsResponse';
  errors?: Maybe<Array<ICreateDraftPaymentsError>>;
  payment?: Maybe<Array<ISuperSheetsPayment>>;
};

export type ICreateTransactionCommentInput = {
  comment: ICommentInput;
  transactionId: Scalars['ID']['input'];
};

export type ICreateTransactionCommentResponse = IBaseResponse & {
  __typename?: 'CreateTransactionCommentResponse';
  comment?: Maybe<IComment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ICreateVerificationInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ICreateVerificationResponse = IBaseResponse & {
  __typename?: 'CreateVerificationResponse';
  errors?: Maybe<Array<IDefaultError>>;
  success: Scalars['Boolean']['output'];
};

export type ICreditAccountDetails = {
  __typename?: 'CreditAccountDetails';
  autoPayInfo?: Maybe<IRepaymentInfo>;
  /** Amount of credit limit available to spend */
  available: IMoney;
  /** Available + Hold */
  balance: IMoney;
  createdAt: Scalars['DateTime']['output'];
  creditLimit: IMoney;
  creditTerms: Scalars['String']['output'];
  freezeReason?: Maybe<Scalars['String']['output']>;
  /** Amount held by pending card authorizations */
  hold: IMoney;
  name: Scalars['String']['output'];
  status: IAccountStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ICreditAccountPaymentInput = {
  creditAccountId: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
  paymentAccountId: Scalars['String']['input'];
  paymentAccountType: IRepaymentAccountType;
  /** Amount to be paid down in USD, if none, defaults to statement balance */
  paymentAmount?: InputMaybe<IMoneyInput>;
};

export type ICreditAccountPaymentResponse = IBaseResponse & {
  __typename?: 'CreditAccountPaymentResponse';
  amount?: Maybe<IMoney>;
  errors?: Maybe<Array<IDefaultError>>;
  /** If none, payment settles instantly */
  paymentSettlementDate?: Maybe<Scalars['Date']['output']>;
};

export type ICreditAccountRepayment = {
  __typename?: 'CreditAccountRepayment';
  amount: IMoney;
  createdOn: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  postsOn: Scalars['Date']['output'];
};

/** Used for representing a statement containing credit account transactions */
export type ICreditAccountStatement = IAccountStatementInterface & {
  __typename?: 'CreditAccountStatement';
  account: IAccount;
  /** ⚠️ Expensive. Do not use in summary view */
  balance: ICreditStatementBalance;
  /** ⚠️ Expensive. Generated on demand */
  csvUrl?: Maybe<Scalars['String']['output']>;
  /** ⚠️ Expensive. Generated on demand */
  html?: Maybe<Scalars['String']['output']>;
  /** We identify statements by their period, eg 2023-01 */
  id: Scalars['ID']['output'];
  paymentDueDate: Scalars['Date']['output'];
  /** ⚠️ Expensive. Generated on demand */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  period: IPeriod;
  /** ⚠️ Expensive. Generated on demand */
  qboUrl?: Maybe<Scalars['String']['output']>;
  statementDate: Scalars['Date']['output'];
};

export type ICreditApplication = IBaseResponse & {
  __typename?: 'CreditApplication';
  autoPayInfo: IRepaymentInfo;
  creditLimit?: Maybe<IMoney>;
  errors?: Maybe<Array<IDefaultError>>;
  status: ICreditApplicationStatus;
};

export enum ICreditApplicationStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingExternalAccountReconnect = 'PENDING_EXTERNAL_ACCOUNT_RECONNECT'
}

export type ICreditCardLimit = {
  __typename?: 'CreditCardLimit';
  purchase?: Maybe<ILimit>;
};

export type ICreditCardLimitInput = {
  purchase: ILimitInput;
};

export type ICreditStatementBalance = {
  __typename?: 'CreditStatementBalance';
  closingBalance: IMoney;
  openingBalance: IMoney;
};

export enum ICurrency {
  Aed = 'aed',
  Afn = 'afn',
  All = 'all',
  Amd = 'amd',
  Ang = 'ang',
  Aoa = 'aoa',
  Ars = 'ars',
  Aud = 'aud',
  Awg = 'awg',
  Azn = 'azn',
  Bam = 'bam',
  Bbd = 'bbd',
  Bdt = 'bdt',
  Bgn = 'bgn',
  Bhd = 'bhd',
  Bif = 'bif',
  Bmd = 'bmd',
  Bnd = 'bnd',
  Bob = 'bob',
  Bov = 'bov',
  Brl = 'brl',
  Bsd = 'bsd',
  Btn = 'btn',
  Bwp = 'bwp',
  Byn = 'byn',
  Bzd = 'bzd',
  Cad = 'cad',
  Cdf = 'cdf',
  Che = 'che',
  Chf = 'chf',
  Chw = 'chw',
  Clf = 'clf',
  Clp = 'clp',
  Cny = 'cny',
  Cop = 'cop',
  Cou = 'cou',
  Crc = 'crc',
  Cuc = 'cuc',
  Cup = 'cup',
  Cve = 'cve',
  Czk = 'czk',
  Djf = 'djf',
  Dkk = 'dkk',
  Dop = 'dop',
  Dzd = 'dzd',
  Egp = 'egp',
  Ern = 'ern',
  Etb = 'etb',
  Eur = 'eur',
  Fjd = 'fjd',
  Fkp = 'fkp',
  Gbp = 'gbp',
  Gel = 'gel',
  Ghs = 'ghs',
  Gip = 'gip',
  Gmd = 'gmd',
  Gnf = 'gnf',
  Gtq = 'gtq',
  Gyd = 'gyd',
  Hkd = 'hkd',
  Hnl = 'hnl',
  Hrk = 'hrk',
  Htg = 'htg',
  Huf = 'huf',
  Idr = 'idr',
  Ils = 'ils',
  Inr = 'inr',
  Iqd = 'iqd',
  Irr = 'irr',
  Isk = 'isk',
  Jmd = 'jmd',
  Jod = 'jod',
  Jpy = 'jpy',
  Kes = 'kes',
  Kgs = 'kgs',
  Khr = 'khr',
  Kmf = 'kmf',
  Kpw = 'kpw',
  Krw = 'krw',
  Kwd = 'kwd',
  Kyd = 'kyd',
  Kzt = 'kzt',
  Lak = 'lak',
  Lbp = 'lbp',
  Lkr = 'lkr',
  Lrd = 'lrd',
  Lsl = 'lsl',
  Lyd = 'lyd',
  Mad = 'mad',
  Mdl = 'mdl',
  Mga = 'mga',
  Mkd = 'mkd',
  Mmk = 'mmk',
  Mnt = 'mnt',
  Mop = 'mop',
  Mru = 'mru',
  Mur = 'mur',
  Mvr = 'mvr',
  Mwk = 'mwk',
  Mxn = 'mxn',
  Mxv = 'mxv',
  Myr = 'myr',
  Mzn = 'mzn',
  Nad = 'nad',
  Ngn = 'ngn',
  Nio = 'nio',
  Nok = 'nok',
  Npr = 'npr',
  Nzd = 'nzd',
  Omr = 'omr',
  Pab = 'pab',
  Pen = 'pen',
  Pgk = 'pgk',
  Php = 'php',
  Pkr = 'pkr',
  Pln = 'pln',
  Pyg = 'pyg',
  Qar = 'qar',
  Ron = 'ron',
  Rsd = 'rsd',
  Rub = 'rub',
  Rwf = 'rwf',
  Sar = 'sar',
  Sbd = 'sbd',
  Scr = 'scr',
  Sdg = 'sdg',
  Sek = 'sek',
  Sgd = 'sgd',
  Shp = 'shp',
  Sle = 'sle',
  Sll = 'sll',
  Sos = 'sos',
  Srd = 'srd',
  Ssp = 'ssp',
  Stn = 'stn',
  Svc = 'svc',
  Syp = 'syp',
  Szl = 'szl',
  Thb = 'thb',
  Tjs = 'tjs',
  Tmt = 'tmt',
  Tnd = 'tnd',
  Top = 'top',
  Try = 'try',
  Ttd = 'ttd',
  Twd = 'twd',
  Tzs = 'tzs',
  Uah = 'uah',
  Ugx = 'ugx',
  Usd = 'usd',
  Usn = 'usn',
  Uyi = 'uyi',
  Uyu = 'uyu',
  Uyw = 'uyw',
  Uzs = 'uzs',
  Ved = 'ved',
  Ves = 'ves',
  Vnd = 'vnd',
  Vuv = 'vuv',
  Wst = 'wst',
  Xaf = 'xaf',
  Xag = 'xag',
  Xau = 'xau',
  Xba = 'xba',
  Xbb = 'xbb',
  Xbc = 'xbc',
  Xbd = 'xbd',
  Xcd = 'xcd',
  Xdr = 'xdr',
  Xof = 'xof',
  Xpd = 'xpd',
  Xpf = 'xpf',
  Xpt = 'xpt',
  Xsu = 'xsu',
  Xts = 'xts',
  Xua = 'xua',
  Xxx = 'xxx',
  Yer = 'yer',
  Zar = 'zar',
  Zmw = 'zmw',
  Zwl = 'zwl'
}

export type ICurrencyCostAveragingState = {
  __typename?: 'CurrencyCostAveragingState';
  completedDestinationAmount: IMoney;
  completedSourceAmount: IMoney;
  fixedAmount: IFixedAmount;
  nCompletedSplits: Scalars['Int']['output'];
  nTotalSplits: Scalars['Int']['output'];
  status: IExecutionStatus;
  totalFixedAmount: IMoney;
};

export type ICurrencyPairNotTradeableError = IErrorInterface & {
  __typename?: 'CurrencyPairNotTradeableError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

/** Fields are accessible to all users on the customer account */
export type ICustomer = {
  __typename?: 'Customer';
  approvedAt: Scalars['DateTime']['output'];
  /** ⚠️ Expensive, use sparingly. Returns criteria for customer to see referrals */
  canRefer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  legalName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  products: Array<IProduct>;
  /** ⚠️ Expensive, use sparingly. Returns referral code when customer eligible for referral */
  referral?: Maybe<IReferralResponse>;
  sheetsTier: ISheetsCustomerTier;
  status: ICustomerStatus;
  tier: ICustomerTier;
  /** ⚠️ Expensive, use sparingly. Returns criteria for customer to be considered trusted */
  trusted?: Maybe<Scalars['Boolean']['output']>;
  usesPaymentReleaseStep: Scalars['Boolean']['output'];
};

export type ICustomerPayPalFunding = {
  __typename?: 'CustomerPayPalFunding';
  void: Scalars['Boolean']['output'];
};

export type ICustomerResponse = IBaseResponse & {
  __typename?: 'CustomerResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export enum ICustomerStatus {
  Closed = 'CLOSED',
  Frozen = 'FROZEN',
  Open = 'OPEN',
  PreKyc = 'PRE_KYC'
}

export enum ICustomerTier {
  Essential = 'ESSENTIAL',
  EssentialThread = 'ESSENTIAL_THREAD',
  LegacyPremium = 'LEGACY_PREMIUM',
  LegacyPremiumThread = 'LEGACY_PREMIUM_THREAD',
  Lite = 'LITE',
  PaymentsThread = 'PAYMENTS_THREAD',
  Platinum = 'PLATINUM',
  PlatinumThread = 'PLATINUM_THREAD'
}

export type ICustomerTierSettings = {
  __typename?: 'CustomerTierSettings';
  debitCardCashBackPercent: Scalars['Float']['output'];
  freeLocalRailPaymentsPerMonth: Scalars['Int']['output'];
  freeWirePaymentsPerMonth: Scalars['Int']['output'];
  outgoingLocalRailFee: Scalars['Float']['output'];
  outgoingWireFee: Scalars['Float']['output'];
};

export type IDateBulkPaymentColumn = {
  __typename?: 'DateBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['Date']['output']>>;
};

export type IDebitCardLimit = {
  __typename?: 'DebitCardLimit';
  purchase?: Maybe<ILimit>;
  withdrawal?: Maybe<ILimit>;
};

export type IDebitCardLimitInput = {
  purchase?: InputMaybe<ILimitInput>;
  withdrawal?: InputMaybe<ILimitInput>;
};

export type IDefaultError = IErrorInterface & {
  __typename?: 'DefaultError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IDefaultOrAccountingConnectionRequiredError = IAccountingConnectionRequiredError | IDefaultError;

export type IDefaultParseContractError = IErrorInterface & {
  __typename?: 'DefaultParseContractError';
  fileId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IDeleteActivityCommentInput = {
  activityId: Scalars['ID']['input'];
  commentId: Scalars['String']['input'];
};

export type IDeleteActivityCommentResponse = IBaseResponse & {
  __typename?: 'DeleteActivityCommentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteContractCommentInput = {
  commentId: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
};

export type IDeleteContractCommentResponse = IBaseResponse & {
  __typename?: 'DeleteContractCommentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteContractsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type IDeleteContractsResponse = IBaseResponse & {
  __typename?: 'DeleteContractsResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteDepartmentInput = {
  departmentId: Scalars['ID']['input'];
};

export type IDeleteEventInstanceCommentInput = {
  commentId: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  ordinal: Scalars['Int']['input'];
};

export type IDeleteEventInstanceCommentResponse = IBaseResponse & {
  __typename?: 'DeleteEventInstanceCommentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteScheduledEventCommentInput = {
  commentId: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
};

export type IDeleteScheduledEventCommentResponse = IBaseResponse & {
  __typename?: 'DeleteScheduledEventCommentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteTransactionCommentInput = {
  commentId: Scalars['String']['input'];
  transactionId: Scalars['ID']['input'];
};

export type IDeleteTransactionCommentResponse = IBaseResponse & {
  __typename?: 'DeleteTransactionCommentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDeleteVendorFeedbackInput = {
  feedbackId: Scalars['ID']['input'];
};

export type IDepartment = {
  __typename?: 'Department';
  departmentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** ⚠️ Expensive object. Avoid using in summary view ⚠️ */
export type IDeposit = {
  __typename?: 'Deposit';
  amount: IMoney;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  method: IDepositMethod;
  sender?: Maybe<ISender>;
  /** Only for ACH debits. The date when ACH debit is expected to settle */
  settlementDate?: Maybe<Scalars['Date']['output']>;
  status: IExecutionStatus;
  transaction?: Maybe<ITransaction>;
};

export enum IDepositMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  FedWire = 'FED_WIRE',
  Local = 'LOCAL',
  Swift = 'SWIFT'
}

export type IDepositSummary = {
  __typename?: 'DepositSummary';
  amount: IVariableMoney;
  method: IDepositMethod;
  senderName?: Maybe<Scalars['String']['output']>;
};

export enum IDigitalWalletType {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Other = 'OTHER'
}

export enum IDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type IDisableRecipientInput = {
  recipientId: Scalars['ID']['input'];
};

export type IDisableRecipientResponse = IBaseResponse & {
  __typename?: 'DisableRecipientResponse';
  disabled: Scalars['Boolean']['output'];
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDisconnectExternalAccountInput = {
  connectedAccountId: Scalars['String']['input'];
};

export type IDisconnectExternalAccountResponse = IBaseResponse & {
  __typename?: 'DisconnectExternalAccountResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IDismissVendorMissingContractInput = {
  vendorId: Scalars['String']['input'];
};

export type IDocusignConnection = {
  __typename?: 'DocusignConnection';
  /** Which of the accounts tied to the email is used */
  accountName: Scalars['String']['output'];
  /** Email of the connected account */
  email: Scalars['String']['output'];
};

export type IDownloadStatementsWidget = IBaseWidget & {
  __typename?: 'DownloadStatementsWidget';
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
};

export type IDuplicatePaymentCreationError = IErrorInterface & {
  __typename?: 'DuplicatePaymentCreationError';
  /** The payment ID corresponding to existing payment */
  existingPaymentId: Scalars['String']['output'];
  /** Idempotency key provided that caused error */
  idempotencyKey: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IDuplicatePaymentError = IErrorInterface & {
  __typename?: 'DuplicatePaymentError';
  message: Scalars['String']['output'];
  originalEventApprovalStatus: IApprovalRequestStatus;
  originalEventId: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IDuplicateScheduledEventIdempotencyKeyError = IErrorInterface & {
  __typename?: 'DuplicateScheduledEventIdempotencyKeyError';
  /** The activity ID corresponding to the scheduled event; None for recurring events */
  activityId?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IEurAccountDetails = IAccountDetailsWithLocalPayIns & {
  __typename?: 'EURAccountDetails';
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  localPaymentRailName?: Maybe<Scalars['String']['output']>;
  sepaSwift: Scalars['String']['output'];
  swift: ISwiftAccountDetails;
};

export type IEmptyResponse = IBaseResponse & {
  __typename?: 'EmptyResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IErrorInterface = {
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

/**
 * An instance of a scheduled event that is either scheduled or executed.
 *
 * if canceled before scheduled:
 * - is a ScheduledEventInstance
 * - ScheduledEventInstance.canceled = True
 *
 * if failed and not sent to provider:
 * - is an ExecutedEventInstance
 * - ExecutedEventInstance.scheduling_status = FAILED
 *
 * if sent to provider, and canceled in provider:
 * - is an ExecutedEventInstance
 * - ExecutedEventInstance.scheduling_status = SUCCEEDED
 * - ExecutedEventInstance.entity.status = CANCELED
 *
 * if sent to provider, and failed in provider:
 * - is an ExecutedEventInstance
 * - ExecutedEventInstance.scheduling_status = SUCCEEDED
 * - ExecutedEventInstance.entity.status = FAILED
 *
 * if succeeded:
 * - is an ExecutedEventInstance
 * - ExecutedEventInstance.scheduling_status = SUCCEEDED
 * - ExecutedEventInstance.entity.status = SUCCEEDED
 */
export type IEventInstance = IExecutedEventInstance | IScheduledEventInstance;

export enum IEventInstanceType {
  Canceled = 'CANCELED',
  Executed = 'EXECUTED',
  Scheduled = 'SCHEDULED'
}

export type IExecutedEventInstance = IScheduledEventInstanceInterface & {
  __typename?: 'ExecutedEventInstance';
  /** Use in details views, not summaries. */
  activity?: Maybe<IActivity>;
  activityId: Scalars['ID']['output'];
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use only where a 'cancel' button might be displayed. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  event: IScheduledEvent;
  eventId: Scalars['String']['output'];
  executionTime: Scalars['DateTime']['output'];
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  ordinal: Scalars['Int']['output'];
  scheduledDateEt: Scalars['Date']['output'];
  schedulingStatus: IScheduledEventInstanceStatus;
};

export enum IExecutionStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type IExpectedApprovalInfoResponse = IBaseResponse & {
  __typename?: 'ExpectedApprovalInfoResponse';
  /** Null only on error. */
  automaticallyApproved?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
  /** The expected approval state immediately after creating the request. Null on error or if MLA not enabled. */
  initialState?: Maybe<IMultiLayerApprovalState>;
  manualApprovalRequiredReason?: Maybe<IManualApprovalRequiredReason>;
};

export type IExpenseAccrual = {
  __typename?: 'ExpenseAccrual';
  accountingClass?: Maybe<IAccountingCategory>;
  accountingDepartment?: Maybe<IAccountingCategory>;
  accountingLocation?: Maybe<IAccountingCategory>;
  /** Date to accrue this expense, used to track accounting period */
  accrualDateUtc?: Maybe<Scalars['Date']['output']>;
  amount?: Maybe<IVariableMoney>;
  contract?: Maybe<IContract>;
  createdAtUtc: Scalars['DateTime']['output'];
  expenseAccount?: Maybe<INominalAccount>;
  id: Scalars['ID']['output'];
  liabilityAccount?: Maybe<INominalAccount>;
  postedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  status: ISuperSheetsAccrualStatus;
  unitAmount?: Maybe<IVariableMoney>;
  updatedAtUtc: Scalars['DateTime']['output'];
};

export type IExpenseAccrualIdInput = {
  expenseAccrualId: Scalars['ID']['input'];
};

export type IExpenseAccrualIDsInput = {
  expenseAccrualIds: Array<Scalars['ID']['input']>;
};

export type IExpenseAccrualResponse = IBaseResponse & {
  __typename?: 'ExpenseAccrualResponse';
  errors?: Maybe<Array<IDefaultError>>;
  expenseAccrual?: Maybe<IExpenseAccrual>;
};

export type IExpenseAccrualsResponse = IBaseResponse & {
  __typename?: 'ExpenseAccrualsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  expenseAccruals?: Maybe<Array<IExpenseAccrual>>;
};

export type IExportAccrualsInput = {
  filter: IGetAccrualsFilterInput;
  sort: IGetAccrualsSortInput;
};

export type IExportAccrualsResponse = IBaseResponse & {
  __typename?: 'ExportAccrualsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type IExportPaymentsInput = {
  filter?: InputMaybe<IGetPaymentsFilterInput>;
  sort?: InputMaybe<IGetPaymentsSortInput>;
};

export type IExportPaymentsResponse = IBaseResponse & {
  __typename?: 'ExportPaymentsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type IExportTransactionsInput = {
  filter?: InputMaybe<IGetTransactionsFilterInput>;
};

export type IExportTransactionsResponse = IBaseResponse & {
  __typename?: 'ExportTransactionsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  fileUrl?: Maybe<Scalars['String']['output']>;
};

export type IFxConversionUnavailableError = IErrorInterface & {
  __typename?: 'FXConversionUnavailableError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IFxMarketStatusResponse = {
  __typename?: 'FXMarketStatusResponse';
  isOpen: Scalars['Boolean']['output'];
  nextOpenTimeIso?: Maybe<Scalars['DateTime']['output']>;
};

export type IFxMarketsClosedError = IErrorInterface & {
  __typename?: 'FXMarketsClosedError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export enum IFeatureFlag {
  ActivationChecklist = 'ACTIVATION_CHECKLIST',
  AssistantBulkPayments = 'ASSISTANT_BULK_PAYMENTS',
  AssistantChat = 'ASSISTANT_CHAT',
  AssistantDebug = 'ASSISTANT_DEBUG',
  AssistantFreeTextInput = 'ASSISTANT_FREE_TEXT_INPUT',
  AssistantPythonMode = 'ASSISTANT_PYTHON_MODE',
  AssistantWorkflows = 'ASSISTANT_WORKFLOWS',
  AssistantWorkflowsStrict = 'ASSISTANT_WORKFLOWS_STRICT',
  BulkRecipientUpload = 'BULK_RECIPIENT_UPLOAD',
  CbSuppressAmbiguousBeneficiaryMatch = 'CB_SUPPRESS_AMBIGUOUS_BENEFICIARY_MATCH',
  CbSuppressCcServiceUnavailableError = 'CB_SUPPRESS_CC_SERVICE_UNAVAILABLE_ERROR',
  CbSuppressCcTooManyRequestsError = 'CB_SUPPRESS_CC_TOO_MANY_REQUESTS_ERROR',
  CbSuppressTxOrderDisambgError = 'CB_SUPPRESS_TX_ORDER_DISAMBG_ERROR',
  ChargeCards = 'CHARGE_CARDS',
  DemoFeatures = 'DEMO_FEATURES',
  EnableGbpLocalPayments = 'ENABLE_GBP_LOCAL_PAYMENTS',
  ExternalApi = 'EXTERNAL_API',
  ExternalFundingFixedSourceOnly = 'EXTERNAL_FUNDING_FIXED_SOURCE_ONLY',
  ForecastView = 'FORECAST_VIEW',
  FreeEnterpriseTier = 'FREE_ENTERPRISE_TIER',
  FreeTeamsTier = 'FREE_TEAMS_TIER',
  Levro_2Sheets = 'LEVRO_2_SHEETS',
  MultiLayerApprovals = 'MULTI_LAYER_APPROVALS',
  PlaidMicrodepositVerification = 'PLAID_MICRODEPOSIT_VERIFICATION',
  ProcurementV1 = 'PROCUREMENT_V1',
  SelectPaymentFundingMethod = 'SELECT_PAYMENT_FUNDING_METHOD',
  SelfieVerification = 'SELFIE_VERIFICATION',
  SplitPhpPayments = 'SPLIT_PHP_PAYMENTS',
  StripeBillingEnabled = 'STRIPE_BILLING_ENABLED',
  TinVerification = 'TIN_VERIFICATION',
  ZeroCcPaymentFees = 'ZERO_CC_PAYMENT_FEES'
}

export type IFee = IFeeExempt | IMoney;

export type IFeeExempt = {
  __typename?: 'FeeExempt';
  /** Do not use field. Cannot create empty types */
  void: Scalars['Boolean']['output'];
};

export type IFile = {
  __typename?: 'File';
  category: IFileCategory;
  createdAt: Scalars['DateTime']['output'];
  /** Expensive field for list views as it results in n+1 queries */
  creator: IUser;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: IFileStatus;
  /** Expensive field. Fetch on demand. */
  urlForDownload?: Maybe<Scalars['String']['output']>;
  /**
   *
   * A URL for read, without a default content disposition.
   * Expensive field. Fetch on demand.
   *
   */
  urlForInline?: Maybe<Scalars['String']['output']>;
};

export enum IFileCategory {
  AssistantAttachment = 'ASSISTANT_ATTACHMENT',
  BillAttachment = 'BILL_ATTACHMENT',
  BrandingLogo = 'BRANDING_LOGO',
  Invoice = 'INVOICE',
  InvoiceAttachment = 'INVOICE_ATTACHMENT',
  LiteContract = 'LITE_CONTRACT',
  LiteImportedContract = 'LITE_IMPORTED_CONTRACT',
  ProcurementRequest = 'PROCUREMENT_REQUEST',
  Receipt = 'RECEIPT',
  WebContractTerms = 'WEB_CONTRACT_TERMS'
}

export type IFileConstrainedValue = {
  __typename?: 'FileConstrainedValue';
  file?: Maybe<IFile>;
  isDefault: Scalars['Boolean']['output'];
};

export enum IFileStatus {
  PendingUpload = 'PENDING_UPLOAD',
  SoftDeleted = 'SOFT_DELETED',
  SoftDeletedViolating = 'SOFT_DELETED_VIOLATING',
  Uploaded = 'UPLOADED'
}

export type IFileUrlResponse = IBaseResponse & {
  __typename?: 'FileUrlResponse';
  errors?: Maybe<Array<IDefaultError>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type IFileValueInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
};

export enum IFixedAmount {
  Destination = 'DESTINATION',
  Source = 'SOURCE'
}

export type IFloatBulkPaymentColumn = {
  __typename?: 'FloatBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['Float']['output']>>;
};

export enum IFreezeReason {
  Fraud = 'FRAUD',
  Other = 'OTHER'
}

export enum IFrequency {
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type IFundingMethod = IConnectedAccount | ICustomerPayPalFunding | ILevroBalanceFunding | IWireFunding;

export type IFundingMethodInput =
  /** Used to fund via ACH */
  { connectedAccountId: Scalars['ID']['input']; customerPaypalAccount?: never; levroBalance?: never; wire?: never; }
  |  { connectedAccountId?: never; customerPaypalAccount: Scalars['Boolean']['input']; levroBalance?: never; wire?: never; }
  |  { connectedAccountId?: never; customerPaypalAccount?: never; levroBalance: Scalars['Boolean']['input']; wire?: never; }
  |  { connectedAccountId?: never; customerPaypalAccount?: never; levroBalance?: never; wire: Scalars['Boolean']['input']; };

export enum IFundingStatus {
  AwaitingExecution = 'AWAITING_EXECUTION',
  AwaitingFunds = 'AWAITING_FUNDS',
  AwaitingInitialization = 'AWAITING_INITIALIZATION',
  Canceled = 'CANCELED',
  Funded = 'FUNDED'
}

export enum IFundingType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type IFxRateHistoryWidget = IBaseWidget & {
  __typename?: 'FxRateHistoryWidget';
  amountToConvert?: Maybe<Scalars['Float']['output']>;
  currentRate?: Maybe<Scalars['Float']['output']>;
  destinationCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rateHistoryDates: Array<Scalars['Date']['output']>;
  rateHistoryValues: Array<Scalars['Float']['output']>;
  sourceCurrency: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type IGbpAccountDetails = IAccountDetailsWithLocalPayIns & {
  __typename?: 'GBPAccountDetails';
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  localPaymentRailName?: Maybe<Scalars['String']['output']>;
  sortCode: Scalars['String']['output'];
  swift: ISwiftAccountDetails;
};

export type IGenerateApiKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type IGenerateApiKeyResponse = IBaseResponse & {
  __typename?: 'GenerateApiKeyResponse';
  apiKey?: Maybe<IApiKey>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Made up of 2 parts (prefix and suffix). The suffix is stored hashed and can only be displayed once as we store it hashed. Customer needs to generate a new key if they lose it */
  plainTextApiKey?: Maybe<Scalars['String']['output']>;
};

export type IGenerateDocusignAuthUrlResponse = IBaseResponse & {
  __typename?: 'GenerateDocusignAuthUrlResponse';
  /** URL to redirect to authenticate with Docusign */
  authUrl: Scalars['String']['output'];
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGenerateOAuthUrlInput = {
  /** Session state to validate against */
  sessionState: Scalars['String']['input'];
};

export type IGenerateOAuthUrlResponse = IBaseResponse & {
  __typename?: 'GenerateOAuthUrlResponse';
  /** URL to redirect to */
  authUrl: Scalars['String']['output'];
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGenerateStripeCheckoutSessionResponse = IBaseResponse & {
  __typename?: 'GenerateStripeCheckoutSessionResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** The Stripe client secret */
  sessionKey?: Maybe<Scalars['String']['output']>;
};

export type IGenerateStripeCustomerSession = IBaseResponse & {
  __typename?: 'GenerateStripeCustomerSession';
  /** The Stripe Customer session client secret - null only on error */
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGenerateStripePortalUrlResponse = IBaseResponse & {
  __typename?: 'GenerateStripePortalUrlResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** The Stripe URL to redirect to - null only on error */
  url?: Maybe<Scalars['String']['output']>;
};

export type IGenerateStripeSubscriptionResponse = IBaseResponse & {
  __typename?: 'GenerateStripeSubscriptionResponse';
  /** The Stripe Customer session client secret - null only on error */
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error */
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export type IGenerateVendorFeedbackTokenInput = {
  vendorId: Scalars['ID']['input'];
};

export type IGeneratedVendorFeedbackTokenResponse = IBaseResponse & {
  __typename?: 'GeneratedVendorFeedbackTokenResponse';
  errors?: Maybe<Array<IDefaultError>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type IGetAccountInput = {
  id: Scalars['ID']['input'];
};

export type IGetAccountResponse = IBaseResponse & {
  __typename?: 'GetAccountResponse';
  account?: Maybe<IAccount>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAccountStatementFilterInput = {
  /** When not provided, returns ConsolidatedAccountStatement */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** Either statementId or period must be provided */
  period?: InputMaybe<IPeriodInput>;
  /** Either statementId or period must be provided */
  statementId?: InputMaybe<Scalars['ID']['input']>;
};

export type IGetAccountStatementResponse = IBaseResponse & {
  __typename?: 'GetAccountStatementResponse';
  errors?: Maybe<Array<IDefaultError>>;
  statement?: Maybe<IAccountStatement>;
};

export type IGetAccountStatementsFilterInput = {
  /** When not provided, returns ConsolidatedAccountStatement */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  period?: InputMaybe<IPeriodInput>;
};

export type IGetAccountStatementsInput = {
  filter?: InputMaybe<IGetAccountStatementsFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetAccountStatementsSortInput>;
};

export type IGetAccountStatementsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetAccountStatementsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  statements?: Maybe<Array<IAccountStatement>>;
};

export type IGetAccountStatementsSortInput = {
  sortColumn: IGetStatementsSortColumn;
  sortOrder: IOrderBy;
};

export type IGetAccountingCategoriesResponse = IBaseResponse & {
  __typename?: 'GetAccountingCategoriesResponse';
  categories?: Maybe<Array<IAccountingCategory>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAccountingConnectionResponse = IBaseResponse & {
  __typename?: 'GetAccountingConnectionResponse';
  errors?: Maybe<Array<IDefaultError>>;
  response?: Maybe<IAccountingConnectionResponse>;
};

export type IGetAccountingCustomersInput = {
  filter?: InputMaybe<IAccountingFilter>;
};

export type IGetAccountingCustomersResponse = IBaseResponse & {
  __typename?: 'GetAccountingCustomersResponse';
  customers?: Maybe<Array<IAccountingCustomer>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAccountingDefaultsResponse = IBaseResponse & {
  __typename?: 'GetAccountingDefaultsResponse';
  department?: Maybe<IAccountingCategory>;
  errors?: Maybe<Array<IDefaultError>>;
  klass?: Maybe<IAccountingCategory>;
  location?: Maybe<IAccountingCategory>;
  nominalExpenseAccount?: Maybe<INominalAccount>;
  nominalPaymentAccount?: Maybe<INominalAccount>;
};

export type IGetAccountingItemsResponse = IBaseResponse & {
  __typename?: 'GetAccountingItemsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  items?: Maybe<Array<IBillAccountingItem>>;
};

export type IGetAccountingTaxRatesResponse = IBaseResponse & {
  __typename?: 'GetAccountingTaxRatesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  taxRates: Array<IAccountingTaxRate>;
};

export type IGetAccountingVendorInput = {
  id: Scalars['ID']['input'];
};

export type IGetAccountingVendorResponse = IBaseResponse & {
  __typename?: 'GetAccountingVendorResponse';
  errors?: Maybe<Array<IDefaultError>>;
  vendor?: Maybe<IAccountingVendor>;
};

export type IGetAccountingVendorsFilterInput = {
  nameSearchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type IGetAccountingVendorsInput = {
  filter?: InputMaybe<IGetAccountingVendorsFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IGetAccountingVendorsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetAccountingVendorsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  /** Null when no connection present or when erroring */
  vendors?: Maybe<Array<IAccountingVendor>>;
};

export type IGetAccountsFilterInput = {
  accountType?: InputMaybe<IAccountType>;
  creditAccountRepaymentEligible?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<ICurrency>;
  payoutOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defaults to OPEN if not provided */
  statuses?: InputMaybe<Array<IAccountStatus>>;
};

export type IGetAccountsInput = {
  filter?: InputMaybe<IGetAccountsFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IGetAccountsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetAccountsResponse';
  accounts?: Maybe<Array<IAccount>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export type IGetAccrualsFilterInput = {
  accountingClassIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountingDepartmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountingLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accrualDateSinceUtc?: InputMaybe<Scalars['Date']['input']>;
  accrualDateUntilUtc?: InputMaybe<Scalars['Date']['input']>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  expenseAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  liabilityAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<ISuperSheetsAccrualStatus>>;
};

export type IGetAccrualsInput = {
  filter: IGetAccrualsFilterInput;
  pagination: IPaginationInput;
  sort: IGetAccrualsSortInput;
};

export type IGetAccrualsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetAccrualsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  expenseAccruals?: Maybe<Array<IExpenseAccrual>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetAccrualsSortColumn {
  AccrualDate = 'ACCRUAL_DATE',
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  PostedAt = 'POSTED_AT',
  RecipientName = 'RECIPIENT_NAME',
  Status = 'STATUS'
}

export type IGetAccrualsSortInput = {
  sortColumn?: InputMaybe<IGetAccrualsSortColumn>;
  sortOrder?: InputMaybe<IOrderBy>;
};

export type IGetActivationChecklistResponse = IBaseResponse & {
  __typename?: 'GetActivationChecklistResponse';
  checklist?: Maybe<Array<IActivationChecklistItem>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetActivitiesFilterInput = {
  activityTypes?: InputMaybe<Array<IActivityType>>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  currencies?: InputMaybe<Array<ICurrency>>;
  isBillPayment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<IPaymentMethod>;
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<IExecutionStatus>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IGetActivitiesInput = {
  filter?: InputMaybe<IGetActivitiesFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetActivitiesSortInput>;
};

export type IGetActivitiesResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetActivitiesResponse';
  activities?: Maybe<Array<IActivity>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetActivitiesSortColumn {
  Date = 'DATE'
}

export type IGetActivitiesSortInput = {
  sortColumn: IGetActivitiesSortColumn;
  sortOrder: IOrderBy;
};

export type IGetActivityInput = {
  id: Scalars['ID']['input'];
};

export type IGetActivityResponse = IBaseResponse & {
  __typename?: 'GetActivityResponse';
  activity?: Maybe<IActivity>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAnnotationTasksFilterInput = {
  objectOrgId?: InputMaybe<Scalars['String']['input']>;
  schemaType: ISchemaType;
  status?: InputMaybe<IAnnotationTaskStatus>;
};

export type IGetAnnotationTasksInput = {
  filter: IGetAnnotationTasksFilterInput;
  pagination?: InputMaybe<IPaginationInput>;
};

export type IGetAnnotationTasksResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetAnnotationTasksResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  tasks?: Maybe<Array<IAnnotationTask>>;
};

export type IGetApiKeysResponse = IBaseResponse & {
  __typename?: 'GetApiKeysResponse';
  errors?: Maybe<Array<IDefaultError>>;
  keys?: Maybe<Array<IApiKey>>;
};

export type IGetApplicationInput = {
  applicationId: Scalars['String']['input'];
};

export type IGetApplicationResponse = IBaseResponse & {
  __typename?: 'GetApplicationResponse';
  application?: Maybe<IApplication>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetApplicationsResponse = IBaseResponse & {
  __typename?: 'GetApplicationsResponse';
  applications: Array<IApplicationSummary>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAssistantBoardInput = {
  boardId: Scalars['ID']['input'];
};

export type IGetAssistantBoardResponse = IBaseResponse & {
  __typename?: 'GetAssistantBoardResponse';
  /** Null only on error */
  board?: Maybe<IAssistantBoard>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetAssistantThreadInput = {
  /** If set, returns only this and later events */
  fromEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Return only the most recent N events */
  limit?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
};

export type IGetAssistantThreadResponse = IBaseResponse & {
  __typename?: 'GetAssistantThreadResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error */
  thread?: Maybe<IAssistantThread>;
};

export type IGetAssistantThreadsResponse = IBaseResponse & {
  __typename?: 'GetAssistantThreadsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error */
  pagination?: Maybe<IPagination>;
  threads: Array<IAssistantThread>;
};

export type IGetBillInput = {
  id: Scalars['ID']['input'];
};

export type IGetBillResponse = IBaseResponse & {
  __typename?: 'GetBillResponse';
  /** null only on error */
  bill?: Maybe<IBill>;
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  processingState?: Maybe<IBillProcessingState>;
};

export type IGetBillingAddressResponse = IBaseResponse & {
  __typename?: 'GetBillingAddressResponse';
  address?: Maybe<IAddress>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetBillsEmailInboxAddressResponse = IBaseResponse & {
  __typename?: 'GetBillsEmailInboxAddressResponse';
  billsEmailAddress?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetBillsFilterInput = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  /** [] means do not filter. */
  currency?: Array<ICurrency>;
  dueDateSince?: InputMaybe<Scalars['Date']['input']>;
  dueDateUntil?: InputMaybe<Scalars['Date']['input']>;
  invoiceDateSince?: InputMaybe<Scalars['Date']['input']>;
  invoiceDateUntil?: InputMaybe<Scalars['Date']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  /** [] means do not filter. */
  statuses?: Array<IBillStatus>;
};

export type IGetBillsInput = {
  filter?: InputMaybe<IGetBillsFilterInput>;
  pagination?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetBillsSortInput>;
};

export type IGetBillsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetBillsResponse';
  bills?: Maybe<Array<IBill>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetBillsSortColumn {
  BillDate = 'BILL_DATE',
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE'
}

export type IGetBillsSortInput = {
  sortColumn: IGetBillsSortColumn;
  sortOrder: IOrderBy;
};

export type IGetBrandingPreferencesResponse = IBaseResponse & {
  __typename?: 'GetBrandingPreferencesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  preferences?: Maybe<IBrandingPreferences>;
};

export type IGetBulkPaymentResponse = IBaseResponse & {
  __typename?: 'GetBulkPaymentResponse';
  /** null only on error */
  bulkPayment?: Maybe<IBulkPayment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetCardAuthorizationsInput = {
  /** Takes precedence over funding if both fields provided */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  cardId?: InputMaybe<Scalars['ID']['input']>;
  funding?: InputMaybe<IFundingType>;
  paginationInput?: InputMaybe<IPaginationInput>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IGetCardAuthorizationsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetCardAuthorizationsResponse';
  authorizations?: Maybe<Array<ICardAuthorization>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export type IGetConnectedAccountInput = {
  id: Scalars['ID']['input'];
};

export type IGetConnectedAccountResponse = IBaseResponse & {
  __typename?: 'GetConnectedAccountResponse';
  account?: Maybe<IConnectedAccount>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetConnectedAccountsResponse = IBaseResponse & {
  __typename?: 'GetConnectedAccountsResponse';
  accounts?: Maybe<Array<IConnectedAccount>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetContractInput = {
  id: Scalars['ID']['input'];
};

export type IGetContractResponse = IBaseResponse & {
  __typename?: 'GetContractResponse';
  contract?: Maybe<IContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetContractsCashManagementInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Only YEARLY, MONTHLY and QUARTERLY are supported. */
  frequency?: IFrequency;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IGetContractsCashManagementResponse = {
  __typename?: 'GetContractsCashManagementResponse';
  errors?: Maybe<Array<IDefaultOrAccountingConnectionRequiredError>>;
  /** null only on error */
  variance?: Maybe<IContractsVariance>;
};

export type IGetContractsCashflowFilterInput = {
  /** If null, defaults to today + 1 year. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** For aggregates, iff True, roll end date to the end of the last aggregate period. */
  includeFullAggregateEndPeriod?: Scalars['Boolean']['input'];
  /** For aggregates, iff True, roll back start date to the start of the first aggregate period. */
  includeFullAggregateStartPeriod?: Scalars['Boolean']['input'];
  /** If null, defaults to today. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IGetContractsCashflowGroupByInput = {
  /** Only YEAR is supported for MONTHLY frequency and WEEKS_13 for WEEKLY frequency. */
  aggregationPeriod?: InputMaybe<IContractsCashflowAggregatePeriod>;
  /** Only MONTHLY and WEEKLY are supported. */
  frequency?: IFrequency;
  rowCategory?: IContractsCashflowRowCategory;
};

export type IGetContractsCashflowInput = {
  filter?: IGetContractsCashflowFilterInput;
  groupBy?: IGetContractsCashflowGroupByInput;
};

export type IGetContractsCashflowResponse = IBaseResponse & {
  __typename?: 'GetContractsCashflowResponse';
  /** order: cells[row][column] */
  cells: Array<Array<IContractsCashflowCell>>;
  /** order: column_aggregates[column] */
  columnAggregates: Array<IContractsCashflowAggregate>;
  /** order: column_metadata[column] */
  columnMetadata: Array<IContractsCashflowColumnMetadata>;
  errors?: Maybe<Array<IDefaultError>>;
  /** order: row_aggregate_column_metadata[aggregate_period] */
  rowAggregateColumnMetadata: Array<IContractsCashflowColumnMetadata>;
  /** order: row_aggregates[row][aggregate_period] */
  rowAggregates: Array<Array<IContractsCashflowAggregate>>;
  /** order: row_metadata[row] */
  rowMetadata: Array<IContractsCashflowRowMetadata>;
  /** order: table_aggregates[aggregate_period] */
  tableAggregates: Array<IContractsCashflowAggregate>;
};

export type IGetContractsFilterInput = {
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  sameSeriesAsContractId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<IContractStatus>>;
};

export type IGetContractsInput = {
  filter?: InputMaybe<IGetContractsFilterInput>;
  pagination?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetContractsSortInput>;
};

export type IGetContractsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetContractsResponse';
  contracts?: Maybe<Array<IContract>>;
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetContractsSortColumn {
  DisplayName = 'DISPLAY_NAME',
  NextPaymentDueDate = 'NEXT_PAYMENT_DUE_DATE',
  Sequence = 'SEQUENCE'
}

export type IGetContractsSortInput = {
  sortColumn?: InputMaybe<IGetContractsSortColumn>;
  sortOrder?: InputMaybe<IOrderBy>;
};

export type IGetConversionTimelineInput = {
  destinationCurrency: Scalars['String']['input'];
  requestTime?: InputMaybe<Scalars['DateTime']['input']>;
  sourceCurrency: Scalars['String']['input'];
};

export type IGetCreditApplicationResponse = IBaseResponse & {
  __typename?: 'GetCreditApplicationResponse';
  application?: Maybe<ICreditApplication>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetCurrentUserCustomersResponse = IBaseResponse & {
  __typename?: 'GetCurrentUserCustomersResponse';
  customers: Array<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetCustomerTierSettingsResponse = IBaseResponse & {
  __typename?: 'GetCustomerTierSettingsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  tierSettings?: Maybe<ITierSettings>;
};

export type IGetDepartmentsResponse = IBaseResponse & {
  __typename?: 'GetDepartmentsResponse';
  departments: Array<IDepartment>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetDocusignAuthUrlInput = {
  /** Session state to validate against */
  sessionState: Scalars['String']['input'];
};

export type IGetDocusignConnectionsResponse = IBaseResponse & {
  __typename?: 'GetDocusignConnectionsResponse';
  connections: Array<IDocusignConnection>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetEligibleBusinessContactUsersInput = {
  customerId: Scalars['ID']['input'];
};

export type IGetEligibleBusinessContactUsersResponse = IBaseResponse & {
  __typename?: 'GetEligibleBusinessContactUsersResponse';
  errors?: Maybe<Array<IDefaultError>>;
  users?: Maybe<Array<IUser>>;
};

export type IGetEventInstanceInput = {
  eventId: Scalars['String']['input'];
  ordinal: Scalars['Int']['input'];
};

export type IGetEventInstanceResponse = IBaseResponse & {
  __typename?: 'GetEventInstanceResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  eventInstance?: Maybe<IEventInstance>;
};

export type IGetEventInstancesInput = {
  approvalStatus?: InputMaybe<IApprovalRequestStatus>;
  endDateInclusive?: InputMaybe<Scalars['Date']['input']>;
  instanceType?: InputMaybe<IEventInstanceType>;
  paginationInput?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetEventInstancesSortInput>;
  startDateInclusive?: InputMaybe<Scalars['Date']['input']>;
};

export type IGetEventInstancesResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetEventInstancesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  eventInstances?: Maybe<Array<IEventInstance>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetEventInstancesSortColumn {
  ScheduledDate = 'SCHEDULED_DATE'
}

export type IGetEventInstancesSortInput = {
  sortColumn?: InputMaybe<IGetEventInstancesSortColumn>;
  sortOrder?: InputMaybe<IOrderBy>;
};

export type IGetExpectedPaymentApprovalFlowInput = {
  destinationAmount: IVariableMoneyInput;
  fixedAmount: IFixedAmount;
  /** If true, ensures the request will require explicit approval by skipping requester self-approval if it is the only approval needed. */
  forceManualApproval?: Scalars['Boolean']['input'];
  /**
   * Specify either recipientId or newRecipientManagerId.
   *
   * NOTE: The rest of the new recipient fields are irrelevant to approval flows.
   */
  newRecipientManagerId?: InputMaybe<Scalars['ID']['input']>;
  /** Specify either recipientId or newRecipientManagerId. */
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  sourceAmount: IVariableMoneyInput;
};

export type IGetFileInput = {
  id: Scalars['ID']['input'];
};

export type IGetFileResponse = IBaseResponse & {
  __typename?: 'GetFileResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error. */
  file?: Maybe<IFile>;
};

/** ⚠ On-demand fields: pdfUrl ⚠ */
export type IGetFundingInstructionsPdfResponse = IBaseResponse & {
  __typename?: 'GetFundingInstructionsPdfResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type IGetGoogleConnectionResponse = IBaseResponse & {
  __typename?: 'GetGoogleConnectionResponse';
  connection?: Maybe<IGoogleConnection>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetInvoiceInput = {
  id: Scalars['ID']['input'];
};

export type IGetInvoiceResponse = IBaseResponse & {
  __typename?: 'GetInvoiceResponse';
  errors?: Maybe<Array<IDefaultError>>;
  invoice?: Maybe<IInvoice>;
};

export type IGetInvoicesFilterInput = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  /** [] means do not filter. */
  currency?: Array<ICurrency>;
  dueDateSince?: InputMaybe<Scalars['Date']['input']>;
  dueDateUntil?: InputMaybe<Scalars['Date']['input']>;
  invoiceDateSince?: InputMaybe<Scalars['Date']['input']>;
  invoiceDateUntil?: InputMaybe<Scalars['Date']['input']>;
  payerId?: InputMaybe<Scalars['ID']['input']>;
  /** [] means do not filter. */
  statuses?: Array<IInvoiceStatus>;
};

export type IGetInvoicesInput = {
  filter?: InputMaybe<IGetInvoicesFilterInput>;
  pagination?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetInvoicesSortInput>;
};

export type IGetInvoicesResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetInvoicesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  invoices?: Maybe<Array<IInvoice>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetInvoicesSortColumn {
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  InvoiceDate = 'INVOICE_DATE'
}

export type IGetInvoicesSortInput = {
  sortColumn: IGetInvoicesSortColumn;
  sortOrder: IOrderBy;
};

export type IGetMultiLayerApprovalRulesRequest = {
  /** If null, returns the currectly active version. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** This should always be ScheduledPayment unless we add support for MLA for other types. */
  requestedType: IRequestedType;
};

export type IGetMultiLayerApprovalRulesResponse = IBaseResponse & {
  __typename?: 'GetMultiLayerApprovalRulesResponse';
  approvalRules?: Maybe<IMultiLayerApprovalRules>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetMultiLayerApprovalRulesVersionsRequest = {
  /** This should always be ScheduledPayment unless we add support for MLA for other types. */
  requestedType: IRequestedType;
};

export type IGetMultiLayerApprovalRulesVersionsResponse = IBaseResponse & {
  __typename?: 'GetMultiLayerApprovalRulesVersionsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  versions?: Maybe<Array<IMultiLayerApprovalRulesVersion>>;
};

export type IGetNominalAccountsResponse = IBaseResponse & {
  __typename?: 'GetNominalAccountsResponse';
  accounts?: Maybe<Array<INominalAccount>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetOmiUserProfileResponse = IBaseResponse & {
  __typename?: 'GetOmiUserProfileResponse';
  contractsEmailAddress?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetOrgsWithTasksInput = {
  schemaType: ISchemaType;
};

export type IGetOrgsWithTasksResponse = IBaseResponse & {
  __typename?: 'GetOrgsWithTasksResponse';
  errors?: Maybe<Array<IDefaultError>>;
  orgs?: Maybe<Array<IOrg>>;
};

export type IGetPayerInput = {
  id: Scalars['ID']['input'];
};

export type IGetPayerResponse = IBaseResponse & {
  __typename?: 'GetPayerResponse';
  errors?: Maybe<Array<IDefaultError>>;
  payer?: Maybe<IPayer>;
};

export type IGetPayersFilterInput = {
  nameSearchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type IGetPayersInput = {
  filter?: InputMaybe<IGetPayersFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
};

export type IGetPayersResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetPayersResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  payers?: Maybe<Array<IPayer>>;
};

export type IGetPayment2Response = IBaseResponse & {
  __typename?: 'GetPayment2Response';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  payment?: Maybe<IPayment2Details>;
};

export type IGetPaymentFeesInput = {
  chargeType?: InputMaybe<ISwiftChargeType>;
  destinationAmount?: InputMaybe<Scalars['Float']['input']>;
  fixedAmount?: InputMaybe<IFixedAmount>;
  paymentMethod: IPaymentMethod;
  /** If country not provided, must provide recipientID */
  recipientCountry?: InputMaybe<Scalars['String']['input']>;
  /** If currency not provided, must provide recipientID */
  recipientCurrency?: InputMaybe<ICurrency>;
  /** If recipientID not provided, must provide country and currency */
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  sourceAmount?: InputMaybe<Scalars['Float']['input']>;
  sourceCurrency: Scalars['String']['input'];
};

export type IGetPaymentFeesResponse = IBaseResponse & {
  __typename?: 'GetPaymentFeesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  fee?: Maybe<IFee>;
};

export type IGetPaymentTimelineInput = {
  fundingMethod?: InputMaybe<IFundingMethodInput>;
  method: IPaymentMethod;
  recipientId: Scalars['ID']['input'];
  requestTime?: InputMaybe<Scalars['DateTime']['input']>;
  sourceCurrency: Scalars['String']['input'];
};

/** Any null will result in no filtering. */
export type IGetPayments2Filters = {
  /** Restrict to payments that are part of this bulk payment. */
  bulkPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** Either source or destination currency. Does not filter if empty. */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, only payments awaiting approval by the current user will be returned. */
  currentUserCanResolve?: InputMaybe<Scalars['Boolean']['input']>;
  destinationCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  methods?: InputMaybe<Array<IPaymentMethod>>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Restrict to these payments by ID. Empty list results in no results. Use null to not filter. */
  paymentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not filter if empty. */
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to payments that were requested by these user IDs. Does not filter if empty. */
  requestedByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to payments that were scheduled in this particular range of dates */
  scheduledDate?: IOptionalDateRangeInput;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sourceCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to payments with these status. Only IN_PROGRESS and COMPLETED payments have been sent out */
  statuses?: InputMaybe<Array<IPaymentStatus>>;
};

export type IGetPayments2Input = {
  filters?: IGetPayments2Filters;
  pagination?: InputMaybe<IPaginationInput>;
  sort?: IGetPayments2SortInput;
};

export type IGetPayments2Response = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetPayments2Response';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  /** null only on error */
  payments?: Maybe<Array<IPayment2>>;
};

export enum IGetPayments2SortField {
  ScheduledDate = 'SCHEDULED_DATE'
}

export type IGetPayments2SortInput = {
  direction: IOrderBy;
  field: IGetPayments2SortField;
};

export type IGetPaymentsFilterInput = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  createdSinceUtc?: InputMaybe<Scalars['Date']['input']>;
  createdUntilUtc?: InputMaybe<Scalars['Date']['input']>;
  dueDateSinceUtc?: InputMaybe<Scalars['Date']['input']>;
  dueDateUntilUtc?: InputMaybe<Scalars['Date']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ISuperSheetsPaymentStatus>>;
};

export type IGetPaymentsInput = {
  filter?: InputMaybe<IGetPaymentsFilterInput>;
  pagination?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetPaymentsSortInput>;
};

export enum IGetPaymentsSortColumn {
  Amount = 'AMOUNT',
  CompletedAt = 'COMPLETED_AT',
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  RecipientName = 'RECIPIENT_NAME',
  Status = 'STATUS'
}

export type IGetPaymentsSortInput = {
  sortColumn?: InputMaybe<IGetPaymentsSortColumn>;
  sortOrder?: InputMaybe<IOrderBy>;
};

export type IGetPendingCreditAccountRepaymentsResponse = IBaseResponse & {
  __typename?: 'GetPendingCreditAccountRepaymentsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  repayments: Array<ICreditAccountRepayment>;
};

export type IGetPendingCreditApplicationsResponse = IBaseResponse & {
  __typename?: 'GetPendingCreditApplicationsResponse';
  creditApplications?: Maybe<Array<ICreditApplication>>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IGetPreferencesResponse = IBaseResponse & {
  __typename?: 'GetPreferencesResponse';
  errors?: Maybe<Array<IDefaultError>>;
  preferences?: Maybe<IPreferences>;
};

export type IGetProcurementRequestsInput = {
  approvalStatus?: InputMaybe<IApprovalRequestStatus>;
  currentUserCanResolve?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IGetProcurementRequestsResponse = IBaseResponse & {
  __typename?: 'GetProcurementRequestsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  requests: Array<IProcurementRequest>;
};

export type IGetRatesInput = {
  conversionDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationCurrency: Scalars['String']['input'];
  sourceCurrency: Scalars['String']['input'];
};

export type IGetRatesResponse = IBaseResponse & {
  __typename?: 'GetRatesResponse';
  currencyPairNotTradeable: Scalars['Boolean']['output'];
  errors?: Maybe<Array<IDefaultError>>;
  rate?: Maybe<IRateInfo>;
};

export type IGetRecipientAccountingDefaultsInput = {
  recipientId: Scalars['ID']['input'];
};

export type IGetRecipientInput = {
  approvalStatuses?: Array<IApprovalRequestStatus>;
  recipientId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type IGetRecipientInvitationsInput = {
  paginationInput?: InputMaybe<IPaginationInput>;
  statuses?: InputMaybe<Array<IRecipientInvitationStatus>>;
};

export type IGetRecipientInvitationsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetRecipientInvitationsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  recipientInvitations?: Maybe<Array<IRecipientInvitation>>;
};

export type IGetRecipientPaymentInput = {
  paymentId: Scalars['ID']['input'];
  recipientId: Scalars['ID']['input'];
};

export type IGetRecipientPaymentResponse = IBaseResponse & {
  __typename?: 'GetRecipientPaymentResponse';
  errors?: Maybe<Array<IDefaultError>>;
  payment?: Maybe<IRecipientPayment>;
};

export type IGetRecipientPaymentsFilter = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IGetRecipientPaymentsInput = {
  filter?: InputMaybe<IGetRecipientPaymentsFilter>;
  pagination?: InputMaybe<IPaginationInput>;
  recipientId: Scalars['ID']['input'];
  sort?: InputMaybe<IGetActivitiesSortInput>;
};

export type IGetRecipientPaymentsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetRecipientPaymentsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  payments?: Maybe<Array<IRecipientPayment>>;
};

export type IGetRecipientResponse = IBaseResponse & {
  __typename?: 'GetRecipientResponse';
  errors?: Maybe<Array<IDefaultError>>;
  recipient?: Maybe<IRecipient>;
};

export type IGetRecipientTaxFormInput = {
  id: Scalars['ID']['input'];
};

export type IGetRecipientTaxFormResponse = IBaseResponse & {
  __typename?: 'GetRecipientTaxFormResponse';
  errors?: Maybe<Array<IDefaultError>>;
  taxForm?: Maybe<IRecipientTaxForm>;
};

export type IGetRecipientsInput = {
  filter?: InputMaybe<IRecipientsFilter>;
  paginationInput?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetRecipientsSortInput>;
};

export type IGetRecipientsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetRecipientsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  recipients: Array<IRecipient>;
};

export enum IGetRecipientsSortColumn {
  CreatedAt = 'CREATED_AT',
  Currency = 'CURRENCY',
  Name = 'NAME'
}

export type IGetRecipientsSortInput = {
  sortColumn: IGetRecipientsSortColumn;
  sortOrder: IOrderBy;
};

export type IGetRecipientsWithoutContractFilterInput = {
  /**
   * If null or not specified, includes only recipients sourced from Levro, but does not otherwise filter.
   * If true, returns all recipients that have an accounting vendor, including recipients sourced from the accounting system. (includes recipients with recorded accounting vendors that cannot currently be loaded)
   * If false, returns only recipients that do not have an accounting vendor.
   */
  isAccountingVendor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If false, null or not specified, does not filter.
   * If true, returns only important recipients.
   */
  isImportantRecipient?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IGetRecipientsWithoutContractInput = {
  filter?: InputMaybe<IGetRecipientsWithoutContractFilterInput>;
};

export type IGetRecipientsWithoutContractResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetRecipientsWithoutContractResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  recipients?: Maybe<Array<IRecipient>>;
};

export type IGetScheduledEventInput = {
  eventId: Scalars['String']['input'];
};

export type IGetScheduledEventResponse = IBaseResponse & {
  __typename?: 'GetScheduledEventResponse';
  errors?: Maybe<Array<IDefaultError>>;
  event?: Maybe<IScheduledEvent>;
};

export type IGetScheduledEventsInput = {
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  /** If null, does not filter */
  approvalStatuses?: InputMaybe<Array<IApprovalRequestStatus>>;
  currencies?: InputMaybe<Array<ICurrency>>;
  /** If null, does not filter */
  fundingStatuses?: InputMaybe<Array<IFundingStatus>>;
  paginationInput?: InputMaybe<IPaginationInput>;
  /** If null, does not filter. Otherwise, returns only the events that are (if false, are not) currently awaiting approval (or rejection) by the logged-in user. Must only be used together with approvalStatus PENDING and/or PENDING_RELEASE. */
  pendingApprovalByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** If not null or [], returns only payments to the given recipient. */
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If null or false, does not filter. Otherwise, returns only the events that the specified user has requested, can (MLA-only) or did  approve/reject, or is recipient's manager. TODO: Rename to reflect the actual meaning. */
  requesterUserId?: InputMaybe<Scalars['String']['input']>;
  /** If null, does not filter */
  scheduleCategory?: InputMaybe<IScheduleCategory>;
  /** If null, does not filter. If not null, expects approval_status=APPROVED, and: if true, returns only APPROVED events where requester = resolver. if false, returns only APPROVED events where requester != resolver. */
  selfApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date component is treated as ET; time component is ignored. */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  sortInput?: InputMaybe<IGetScheduledEventsSortInput>;
  /** If null or [], does not filter */
  statuses?: InputMaybe<Array<IScheduledEventStatus>>;
  /** Date component is treated as ET; time component is ignored. */
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IGetScheduledEventsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetScheduledEventsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  events?: Maybe<Array<IScheduledEvent>>;
  pageInfo?: Maybe<IPagination>;
};

export enum IGetScheduledEventsSortColumn {
  Date = 'DATE',
  RecipientName = 'RECIPIENT_NAME'
}

export type IGetScheduledEventsSortInput = {
  sortColumn: IGetScheduledEventsSortColumn;
  sortOrder: IOrderBy;
};

export type IGetSheetsTierSettingsResponse = IBaseResponse & {
  __typename?: 'GetSheetsTierSettingsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  tierSettings?: Maybe<ISheetsTierSettings>;
};

export type IGetSlackConnectionResponse = IBaseResponse & {
  __typename?: 'GetSlackConnectionResponse';
  connection?: Maybe<ISlackConnection>;
  errors?: Maybe<Array<IDefaultError>>;
};

export enum IGetStatementsSortColumn {
  Period = 'PERIOD'
}

export type IGetTransactionInput = {
  id: Scalars['ID']['input'];
};

export type IGetTransactionResponse = IBaseResponse & {
  __typename?: 'GetTransactionResponse';
  errors?: Maybe<Array<IDefaultError>>;
  transaction?: Maybe<ITransaction>;
};

export type IGetTransactionsFilterInput = {
  /** Do not specify both account_id and funding_type */
  accountId?: InputMaybe<Scalars['String']['input']>;
  amountMax?: InputMaybe<Scalars['Float']['input']>;
  amountMin?: InputMaybe<Scalars['Float']['input']>;
  cardHolderId?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Array<ICurrency>>;
  /** Do not specify both funding_type and account_id */
  fundingType?: InputMaybe<IFundingType>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['Date']['input']>;
  transactionTypes?: InputMaybe<Array<ITransactionType>>;
  until?: InputMaybe<Scalars['Date']['input']>;
};

export type IGetTransactionsInput = {
  filter?: InputMaybe<IGetTransactionsFilterInput>;
  paginationInput?: InputMaybe<IPaginationInput>;
  sort?: InputMaybe<IGetTransactionsSortInput>;
};

export type IGetTransactionsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'GetTransactionsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  transactions?: Maybe<Array<ITransaction>>;
};

export enum IGetTransactionsSortColumn {
  Amount = 'AMOUNT',
  Currency = 'CURRENCY',
  Status = 'STATUS',
  TransactionDate = 'TRANSACTION_DATE',
  TransactionType = 'TRANSACTION_TYPE'
}

export type IGetTransactionsSortInput = {
  sortColumn: IGetTransactionsSortColumn;
  sortOrder: IOrderBy;
};

export type IGetUserInput = {
  userId: Scalars['ID']['input'];
};

export type IGetUsersFilterInput = {
  /**
   * If null, does not filter.
   * If True, includes only users that are active.
   * If False, includes only users that are inactive.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** If True, includes only users that can approve payments. Otherwise does not filter. */
  canApprovePayments?: Scalars['Boolean']['input'];
  /** If True, includes only users that can manage recipients. Otherwise does not filter. */
  canManageRecipients?: Scalars['Boolean']['input'];
};

export type IGetUsersInput = {
  filter?: InputMaybe<IGetUsersFilterInput>;
};

export type IGetVendorFeedbackFormDataResponse = IBaseResponse & {
  __typename?: 'GetVendorFeedbackFormDataResponse';
  errors?: Maybe<Array<IDefaultError>>;
  org?: Maybe<IOrg>;
  vendor?: Maybe<IRecipient>;
};

export type IGetVendorFeedbackInput = {
  vendorId: Scalars['ID']['input'];
};

export type IGetVendorFeedbackResponse = IBaseResponse & {
  __typename?: 'GetVendorFeedbackResponse';
  /** Average rating */
  average?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
  /** List of feedback */
  feedback: Array<IVendorFeedback>;
};

export type IGetVendorsMissingContractsResponse = IBaseResponse & {
  __typename?: 'GetVendorsMissingContractsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  vendors: Array<IVendorAccountingInfo>;
};

export type IGetVerificationLetterInput = {
  accountId: Scalars['ID']['input'];
};

/** ⚠ On-demand fields: pdfUrl ⚠ */
export type IGetVerificationLetterResponse = IBaseResponse & {
  __typename?: 'GetVerificationLetterResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type IGetWireAmountForExternalFundingResponse = IBaseResponse & {
  __typename?: 'GetWireAmountForExternalFundingResponse';
  /** USD, including fees. Does not include payments that are pending FX. null only on error. */
  amount?: Maybe<IMoney>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Does not include payments that are pending FX. */
  numPayments: Scalars['Int']['output'];
  /** The number of destination-amount-fixed payments for which we won't know the amount of funding needed until we can create the conversion when FX markets reopen. */
  numPaymentsPendingFx: Scalars['Int']['output'];
};

export type IGoogleConnection = {
  __typename?: 'GoogleConnection';
  /** ID of the connection */
  connectionId: Scalars['String']['output'];
};

export type IHoliday = {
  __typename?: 'Holiday';
  date: Scalars['Date']['output'];
  name: Scalars['String']['output'];
};

export type IIneligibleForReferral = {
  __typename?: 'IneligibleForReferral';
  /** Do not use field. Cannot create empty types */
  void: Scalars['Boolean']['output'];
};

export type IInitiateAchDebitInput = {
  amount: IMoneyInput;
  connectedAccountId: Scalars['ID']['input'];
  depositAccountId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IInitiateAchDebitResponse = IBaseResponse & {
  __typename?: 'InitiateACHDebitResponse';
  activity?: Maybe<IActivity>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IInsufficientBalanceError = IErrorInterface & {
  __typename?: 'InsufficientBalanceError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IIntConstrainedValue = {
  __typename?: 'IntConstrainedValue';
  isDefault: Scalars['Boolean']['output'];
  naturalNumber: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type IIntValueInput = {
  value: Scalars['Int']['input'];
};

/** ⚠️ Expensive object. Avoid using in summary view ⚠ */
export type IInternalTransfer = {
  __typename?: 'InternalTransfer';
  amount: IMoney;
  /** User visible confirmation number */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  destinationAccount: IAccount;
  id: Scalars['ID']['output'];
  sourceAccount: IAccount;
  status: IExecutionStatus;
  /** The transaction pairs associated with this conversion. For multi-instance conversions (e.g. exchange rate averaging), this includes all instances in ascending order of sourceTransaction.date */
  transactions: IInternalTransferTransactions;
};

export type IInternalTransferSummary = {
  __typename?: 'InternalTransferSummary';
  amount: IVariableMoney;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  destinationAccount: IAccount;
  sourceAccount: IAccount;
};

export type IInternalTransferTransactions = ITransactionPair & {
  __typename?: 'InternalTransferTransactions';
  destinationTransaction?: Maybe<ITransaction>;
  sourceTransaction?: Maybe<ITransaction>;
};

export type IInvalidRecipientError = IErrorInterface & {
  __typename?: 'InvalidRecipientError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IInvalidWidget = IBaseWidget & {
  __typename?: 'InvalidWidget';
  errors: Array<IDefaultError>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IInviteRecipientInput = {
  contactEmail: Scalars['String']['input'];
  /** The name of the person or department who will provide payment details. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  isCompany: Scalars['Boolean']['input'];
  /** When checked, after completing self onboarding, an Anvil redirect URL will be presented to fill tax form */
  isTaxFormRequired?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the entity that will receive payments. */
  recipientName: Scalars['String']['input'];
};

export type IInviteRecipientResponse = IBaseResponse & {
  __typename?: 'InviteRecipientResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  recipientInvitation?: Maybe<IRecipientInvitation>;
};

export type IInviteUserInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  role: IUserRole;
};

export type IInviteUserResponse = IBaseResponse & {
  __typename?: 'InviteUserResponse';
  errors?: Maybe<Array<IDefaultError>>;
  user?: Maybe<IUser>;
};

export type IInvoice = {
  __typename?: 'Invoice';
  /** All attached files. Use in details views, not summaries. */
  attachments: Array<IFile>;
  createdAt: Scalars['DateTime']['output'];
  depositAccount: IAccount;
  description?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceAmount: IMoney;
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  /** ⚠️ Expensive, only use on-demand. URL where invoice can be downloaded. */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  isPastDue: Scalars['Boolean']['output'];
  /** ⚠️ Expensive object. Do not use in summary views ⚠ */
  lineItems?: Maybe<Array<IInvoiceLineItem>>;
  /** Use in details views, not summaries. */
  note: INote;
  payer: IPayer;
  /** Note included in email to customer */
  payerNote?: Maybe<Scalars['String']['output']>;
  /** Specific payment method, if specified. If not, include all payment methods for currency */
  paymentMethod?: Maybe<IPaymentMethod>;
  status: IInvoiceStatus;
};

export type IInvoiceEmail = {
  __typename?: 'InvoiceEmail';
  fromEmail: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  textBody?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type IInvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  description?: Maybe<Scalars['String']['output']>;
  ordinal: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type IInvoiceLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ordinal: Scalars['Int']['input'];
  total: Scalars['Float']['input'];
};

export enum IInvoiceStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type ILayerConfig = {
  __typename?: 'LayerConfig';
  approvers: Array<IApprover>;
  logic: IApprovalLogic;
};

export type ILayerConfigInput = {
  /** Must not be empty. */
  approvers: Array<IApproverInput>;
  logic: IApprovalLogic;
};

export type ILayerState = {
  __typename?: 'LayerState';
  approverStates: Array<IApproverState>;
  logic: IApprovalLogic;
  status: ILayerStatus;
};

export enum ILayerStatus {
  Active = 'ACTIVE',
  NotActive = 'NOT_ACTIVE',
  Satisfied = 'SATISFIED'
}

/** Legacy customers do not have tier settings */
export type ILegacyTierCustomer = {
  __typename?: 'LegacyTierCustomer';
  /** Do not use field. Cannot create empty types */
  void: Scalars['Boolean']['output'];
};

export type ILevroBalanceFunding = {
  __typename?: 'LevroBalanceFunding';
  void: Scalars['Boolean']['output'];
};

export type ILimit = {
  __typename?: 'Limit';
  frequency: IFrequency;
  threshold: IMoney;
  utilization: IMoney;
};

export type ILimitInput = {
  frequency: IFrequency;
  threshold: IMoneyInput;
};

export type ILinkAccountingVendorInput = {
  accountingVendorId: Scalars['String']['input'];
  levroRecipientId: Scalars['String']['input'];
};

export type ILinkAccountingVendorResponse = IBaseResponse & {
  __typename?: 'LinkAccountingVendorResponse';
  errors?: Maybe<Array<IDefaultError>>;
  linkedVendorId?: Maybe<Scalars['ID']['output']>;
};

export type ILinkAndCreateAccountingVendorInput =
  { accountingVendorId: Scalars['String']['input']; createAndLinkAccountingVendorId?: never; }
  |  { accountingVendorId?: never; createAndLinkAccountingVendorId: Scalars['Boolean']['input']; };

export type ILinkManuallyVerifiedPlaidAccountInput = {
  plaidAccount: IPlaidAccount;
};

export type ILinkManuallyVerifiedPlaidAccountResponse = IBaseResponse & {
  __typename?: 'LinkManuallyVerifiedPlaidAccountResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type ILiteGetCurrentUserProfileResponse = IBaseResponse & {
  __typename?: 'LiteGetCurrentUserProfileResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Do not fetch details */
  userProfile?: Maybe<IUserProfileResponse>;
};

export type ILiteInviteUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Only LITE roles are allowed */
  role: IUserRole;
};

export type ILiteInviteUserResponse = IBaseResponse & {
  __typename?: 'LiteInviteUserResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  user?: Maybe<IUser>;
};

export type ILiteSignUpInput = {
  companyLegalName: Scalars['String']['input'];
  dbaName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ILiveRate = IBaseRate & {
  __typename?: 'LiveRate';
  asOf: Scalars['DateTime']['output'];
  client: Scalars['Float']['output'];
  markup: Scalars['Float']['output'];
  midmarket: Scalars['Float']['output'];
};

/**
 *
 * Location of a field in a document.
 * Coordinates are [0, 1] and the origin is the top-left corner.
 * x increases left-to-right, y increases top-to-bottom.
 *
 */
export type ILocation = {
  __typename?: 'Location';
  page: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  xMax: Scalars['Float']['output'];
  xMin: Scalars['Float']['output'];
  yMax: Scalars['Float']['output'];
  yMin: Scalars['Float']['output'];
};

export enum IManualApprovalRequiredReason {
  RecipientPendingApproval = 'RECIPIENT_PENDING_APPROVAL'
}

export type IMapDocVaultFormFieldsInput = {
  /** Form fields as JSON schema that the uploaded doc fields will get mapped to. e.g. {'bizName': {'type': 'string'}, 'entityType': {'type': 'string', 'enum': ['LLC', 'PARTNERSHIP']}} */
  formFieldsJsonSchema: Scalars['String']['input'];
};

export type IMapDocVaultFormFieldsResponse = IBaseResponse & {
  __typename?: 'MapDocVaultFormFieldsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** JSON with values filled for provided input schema */
  mappedFormFields?: Maybe<Scalars['String']['output']>;
};

export type IMaybeRecipientTinVerificationStatus = IRecipientMissingTinVerificationInfo | IRecipientTinVerificationInfo;

export type IMerchant = {
  __typename?: 'Merchant';
  category?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type IMoney = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type IMoneyAccountLimit = IAccountLimitInterface & {
  __typename?: 'MoneyAccountLimit';
  limitType: IAccountLimitType;
  threshold?: Maybe<IMoney>;
  utilization: IMoney;
};

export type IMoneyFormula = {
  __typename?: 'MoneyFormula';
  fixedAmount: IMoney;
  /** True iff there is an additional variable amount */
  hasVariableComponent: Scalars['Boolean']['output'];
};

export type IMoneyFormulaInput = {
  fixedAmount: IMoneyInput;
  /** True iff there is an additional variable amount */
  hasVariableComponent: Scalars['Boolean']['input'];
};

export type IMoneyInput = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type IMultiCurrencyMoney = {
  __typename?: 'MultiCurrencyMoney';
  amounts: Array<IMoney>;
  /** The equivalent amount in a single currency; zero USD if fixed_amounts is empty */
  equivalentAmount: IMoney;
};

export type IMultiCurrencyMoneyFormula = {
  __typename?: 'MultiCurrencyMoneyFormula';
  amounts: Array<IMoney>;
  /** The equivalent amount in a single currency; zero USD if fixed_amounts is empty */
  equivalentAmount: IMoney;
  /** True iff there is an additional variable amount */
  hasVariableComponent: Scalars['Boolean']['output'];
};

export type IMultiLayerApprovalRules = {
  __typename?: 'MultiLayerApprovalRules';
  /** Ordered list of approval flows with criteria. The first flow whose criterion is satisfied is used for each request. */
  approvalFlowsAndCriteria: Array<IApprovalFlowAndCriterion>;
  multiLayerApprovalEnabled: Scalars['Boolean']['output'];
  /** If true, after approval, an admin or accountant must release the payment. */
  releaseStep: Scalars['Boolean']['output'];
};

export type IMultiLayerApprovalRulesInput = {
  /** Ordered list of approval flows with criteria. The first flow whose criterion is satisfied is used for each request. Must not be empty. */
  approvalFlowsAndCriteria: Array<IApprovalFlowAndCriterionInput>;
  /** Currency used for resolving all amount threshold criteria in these rules. */
  currency: Scalars['String']['input'];
  /** If true, after approval, an admin or accountant must release the payment. */
  releaseStep: Scalars['Boolean']['input'];
};

export type IMultiLayerApprovalRulesVersion = {
  __typename?: 'MultiLayerApprovalRulesVersion';
  active: Scalars['Boolean']['output'];
  effectiveFrom: Scalars['DateTime']['output'];
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type IMultiLayerApprovalState = {
  __typename?: 'MultiLayerApprovalState';
  adminApproval?: Maybe<IApproval>;
  currentUserResolutionAbility: IUserResolutionAbility;
  layerStates: Array<ILayerState>;
  /** Null if release step is not part of the request's approval flow. */
  releaseState?: Maybe<IReleaseState>;
  /** The amount, possibly after FX conversion, used to determine which rules to apply. */
  requestedAmount: IMoney;
};

export type IMutation = {
  __typename?: 'Mutation';
  acceptTos: IEmptyResponse;
  addContractsToSeries: IAddContractsToSeriesResponse;
  adminUpdateContract: IAdminUpdateContractResponse;
  analyzeBulkPaymentFile: IBulkPaymentAnalysisResponse;
  applyCreditAccount: IApplyCreditAccountResponse;
  approveCreditApplication: IApproveCreditApplicationResponse;
  approveExpenseAccurals: IExpenseAccrualsResponse;
  attachActivityFiles: IAttachActivityFilesResponse;
  attachEventInstanceFiles: IAttachEventInstanceFilesResponse;
  attachScheduledEventFiles: IAttachScheduledEventFilesResponse;
  attachTransactionFiles: IAttachTransactionFilesResponse;
  cancelAutoPay: IEmptyResponse;
  /** Cancels bills. Paid and previously canceled bills cannot be canceled */
  cancelBill: ICancelBillResponse;
  /**
   * Cancels a single event instance (including one associated with an activity).
   *
   * Will succeed if the event instance (or corresponding activity) recently expressed can_cancel=True,
   * even if the instance has already been executed and issued to a provider.
   */
  cancelEventInstance: ICancelEventInstanceResponse;
  cancelPayments: ISuperSheetsPaymentsResponse;
  /**
   * Cancels an entire event, including instances which have not yet been executed.
   *
   * Will fail for events with:
   * 1. dependencies or reverse dependencies, e.g. CCA conversions or payments
   * 2. instances which have already been executed and issued to a provider.
   */
  cancelScheduledEvent: ICancelScheduledEventResponse;
  checkTokenVerification: ICheckVerificationResponse;
  checkTokenVerificationForCustomer: ICheckVerificationResponse;
  closeAccount: ICloseAccountResponse;
  closeCard: ICardActionResponse;
  closeCustomerAccount: ICloseCustomerAccountResponse;
  connectExternalAccount: IConnectAccountResponse;
  convertVendorMissingContract: IConvertVendorMissingContractResponse;
  createAccount: ICreateAccountResponse;
  createActivityComment: ICreateActivityCommentResponse;
  /** Issues an async request to create new Vendor in the accounting using data from a Levro recipient */
  createAndLinkAccountingVendor: ICreateAndLinkAccountingVendorResponse;
  createBill: ICreateBillResponse;
  createCard: ICreateCardResponse;
  /** Starts a new check deposit flow, providing an ID to upload images against */
  createCheckDeposit: ICreateCheckDepositResponse;
  createContractComment: ICreateContractCommentResponse;
  createContractFromProcurementRequest: ICreateContractFromProcurementRequestResponse;
  createDepartment: ICreateDepartmentResponse;
  createDraftAccruals: IExpenseAccrualsResponse;
  createDraftPayment: ICreateSuperSheetsPaymentResponse;
  createDraftPayments: ICreateSuperSheetsPaymentsResponse;
  createEmptyContract: IGetContractResponse;
  createEventInstanceComment: ICreateEventInstanceCommentResponse;
  createFile: ICreateFileResponse;
  createInvoice: ICreateInvoiceResponse;
  createPayer: ICreatePayerResponse;
  createPlaidLinkToken: ICreatePlaidLinkTokenResponse;
  createProcurementRequest: ICreateProcurementRequestResponse;
  createRecipientUserFromInvitation: ICreateRecipientUserFromInvitationResponse;
  createSampleContracts: IGetContractsResponse;
  createScheduledEventComment: ICreateScheduledEventCommentResponse;
  createTokenVerification: ICreateVerificationResponse;
  createTokenVerificationForCustomer: ICreateVerificationResponse;
  createTransactionComment: ICreateTransactionCommentResponse;
  deleteActivityComment: IDeleteActivityCommentResponse;
  deleteContractComment: IDeleteContractCommentResponse;
  deleteContracts: IDeleteContractsResponse;
  deleteDepartment: IEmptyResponse;
  deleteEventInstanceComment: IDeleteEventInstanceCommentResponse;
  deleteScheduledEventComment: IDeleteScheduledEventCommentResponse;
  deleteTransactionComment: IDeleteTransactionCommentResponse;
  deleteVendorFeedback: IEmptyResponse;
  disableRecipient: IDisableRecipientResponse;
  disassociateAndDeleteFile: IEmptyResponse;
  disconnectAccountingConnection: IEmptyResponse;
  disconnectExternalAccount: IDisconnectExternalAccountResponse;
  dismissVendorMissingContract: IEmptyResponse;
  freezeCard: ICardActionResponse;
  generateApiKey: IGenerateApiKeyResponse;
  generateDocusignAuthUrl: IGenerateDocusignAuthUrlResponse;
  generateGoogleAuthUrl: IGenerateOAuthUrlResponse;
  generateSlackAuthUrl: IGenerateOAuthUrlResponse;
  generateStripeCheckoutSession: IGenerateStripeCheckoutSessionResponse;
  generateStripeCustomerSession: IGenerateStripeCustomerSession;
  generateStripePortalUrl: IGenerateStripePortalUrlResponse;
  generateStripeSubscription: IGenerateStripeSubscriptionResponse;
  generateVendorFeedbackToken: IGeneratedVendorFeedbackTokenResponse;
  /** Initiates an ACH debit payment from a connected account */
  initiateAchDebit: IInitiateAchDebitResponse;
  inviteRecipient: IInviteRecipientResponse;
  inviteUser: IInviteUserResponse;
  /** Links an existing Levro recipient to an existing vendor in the accounting system */
  linkAccountingVendor: ILinkAccountingVendorResponse;
  linkManuallyVerifiedPlaidAccount: ILinkManuallyVerifiedPlaidAccountResponse;
  liteCreateFile: ICreateFileResponse;
  liteDisassociateAndDeleteFile: IEmptyResponse;
  liteGenerateFileUrlForDownload: IFileUrlResponse;
  liteGenerateFileUrlForUpload: IFileUrlResponse;
  liteInviteUser: ILiteInviteUserResponse;
  liteSignUp: IEmptyResponse;
  liteVerifyFileUpload: IEmptyResponse;
  mapDocVaultFormFields: IMapDocVaultFormFieldsResponse;
  noop?: Maybe<Scalars['Void']['output']>;
  overrideRecipientTINVerification: IOverrideRecipientTinVerificationResponse;
  parseContracts: IParseContractsResponse;
  payCreditAccount: ICreditAccountPaymentResponse;
  processAssistantMessage: IProcessAssistantMessageResponse;
  recordPaypalCreds: IEmptyResponse;
  recordVendorFeedback: IEmptyResponse;
  /** Refreshes accounting connection data on demand */
  refreshConnectionData: IEmptyResponse;
  refreshStripeSession: IEmptyResponse;
  registerDocusignCallback: IEmptyResponse;
  registerGoogleCallback: IEmptyResponse;
  registerSlackCallback: IEmptyResponse;
  rejectExpenseAccurals: IExpenseAccrualsResponse;
  releasePayments: IReleaseSuperSheetsPaymentsResponse;
  replaceCard: IReplaceCardResponse;
  reportCardLost: ICardActionResponse;
  reportCardStolen: ICardActionResponse;
  requestConversion: IRequestConversionResponse;
  requestInternalTransfer: IRequestInternalTransferResponse;
  /**
   * Issues a payment to a new or existing recipient, and optionally associates it with a bill.
   *
   * Order of operations:
   * (1) create the recipient (if requested); self-approve iff the payment is self-approve
   * (2) update the bill (if specified)
   * (3) issue the payment; self-approve if specified
   *
   * This mutation is *not* atomic - e.g. the recipient may be created but the payment not issued.
   * Therefore,
   * (1) the response indicates which operations succeeded, e.g. by returning the ID of the new recipient.
   * (2) idempotency keys are specified per-operation.
   * (3) operations are idempotent, e.g. duplicate recipient creation is a no-op and will not raise.
   *
   * Note: errors are not distinguished by operation.
   */
  requestPayment: IRequestPaymentResponse;
  requestPayments: IRequestPaymentsResponse;
  requestRecipient: IRequestRecipientResponse;
  requestRecipientFromInvitation: IRequestRecipientFromInvitationResponse;
  requestRecipients: IRequestRecipientsResponse;
  requestTINNameMatch: IRequestTinNameMatchResponse;
  resetOwnMfa: IResetUserMfaResponse;
  resetUserMfa: IResetUserMfaResponse;
  resolvePayments: IResolvePaymentsResponse;
  resolveProcurementRequest: IResolveProcurementRequestResponse;
  resolveRecipients: IResolveRecipientRequestsResponse;
  revokeApiKey: IRevokeApiKeyResponse;
  revokeRecipientInvitation: IRevokeRecipientInvitationResponse;
  setActiveContractVersion: ISetActiveContractVersionResponse;
  setAutoPayMethod: IEmptyResponse;
  /** Sets customer-level defaults to be used when no values are provided at Bill or Recipient level */
  setCustomerAccountingDefaults: ISetDefaultsResponse;
  setMultiLayerApprovalRules: ISetMultiLayerApprovalRulesResponse;
  setOrgPreferences: ISetPreferencesResponse;
  /** Sets recipient-level defaults to be used when no values are provided at Bill level */
  setRecipientAccountingDefaults: ISetDefaultsResponse;
  setSelfPreferences: ISetPreferencesResponse;
  toggleCustomerFreeze: IToggleCustomerFreezeResponse;
  turnOffFeatureFlag: IToggleCustomerFeatureFlagResponse;
  turnOnFeatureFlag: IToggleCustomerFeatureFlagResponse;
  unfreezeCard: ICardActionResponse;
  updateAccount: IUpdateAccountResponse;
  updateBill: IUpdateBillResponse;
  updateBusinessContact: IUpdateBusinessContactResponse;
  updateCard: IUpdateCardResponse;
  updateContractCashflowPeriodDates: IUpdateContractCashflowPeriodDatesResponse;
  updateContractCashflowPeriodTotals: IUpdateContractCashflowPeriodTotalsResponse;
  updateContractFields: IUpdateContractResponse;
  updateContractPaymentObligations: IUpdateContractResponse;
  updateCustomerInfo: IUpdateCustomerInfoResponse;
  updateCustomerTier: IUpdateCustomerTierResponse;
  updateDraftAccruals: IExpenseAccrualsResponse;
  updateDraftPayment: ISuperSheetsPaymentResponse;
  updateInvoiceStatus: IUpdateInvoiceStatusResponse;
  updateLevroOpsUserRole: IUpdateLevroOpsUserRoleResponse;
  updateProcurementRequest: IUpdateProcurementRequestResponse;
  updateRecipient: IUpdateRecipientResponse;
  updateUser: IUpdateUserResponse;
  uploadParseAndMapFieldsFromDoc: IMapDocVaultFormFieldsResponse;
  verifyDocument: IVerifyDocumentResponse;
  verifyFileUpload: IEmptyResponse;
  writeActivityNote: IWriteActivityNoteResponse;
  writeAnnotation: IWriteAnnotationResponse;
  writeEventInstanceNote: IWriteEventInstanceNoteResponse;
  writeScheduledEventNote: IWriteScheduledEventNoteResponse;
  writeTransactionNote: IWriteTransactionNoteResponse;
};


export type IMutationAcceptTosArgs = {
  input: IAcceptTosInput;
};


export type IMutationAddContractsToSeriesArgs = {
  input: IAddContractsToSeriesInput;
};


export type IMutationAdminUpdateContractArgs = {
  input: IAdminUpdateContractInput;
};


export type IMutationAnalyzeBulkPaymentFileArgs = {
  input: IAnalyzeBulkPaymentFileInput;
};


export type IMutationApplyCreditAccountArgs = {
  input: IApplyCreditAccountInput;
};


export type IMutationApproveCreditApplicationArgs = {
  input: IApproveCreditApplicationInput;
};


export type IMutationApproveExpenseAccuralsArgs = {
  input: IExpenseAccrualIDsInput;
};


export type IMutationAttachActivityFilesArgs = {
  input: IAttachActivityFilesInput;
};


export type IMutationAttachEventInstanceFilesArgs = {
  input: IAttachEventInstanceFilesInput;
};


export type IMutationAttachScheduledEventFilesArgs = {
  input: IAttachScheduledEventFilesInput;
};


export type IMutationAttachTransactionFilesArgs = {
  input: IAttachTransactionFilesInput;
};


export type IMutationCancelBillArgs = {
  input: ICancelBillInput;
};


export type IMutationCancelEventInstanceArgs = {
  input: ICancelEventInstanceInput;
};


export type IMutationCancelPaymentsArgs = {
  input: IPaymentIDsInput;
};


export type IMutationCancelScheduledEventArgs = {
  input: ICancelScheduledEventInput;
};


export type IMutationCheckTokenVerificationArgs = {
  input: ICheckVerificationInput;
};


export type IMutationCheckTokenVerificationForCustomerArgs = {
  input: ICheckVerificationForCustomerInput;
};


export type IMutationCloseAccountArgs = {
  input: ICloseAccountInput;
};


export type IMutationCloseCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type IMutationCloseCustomerAccountArgs = {
  input: ICloseCustomerAccountInput;
};


export type IMutationConnectExternalAccountArgs = {
  input: IConnectAccountInput;
};


export type IMutationConvertVendorMissingContractArgs = {
  input: IConvertVendorMissingContractInput;
};


export type IMutationCreateAccountArgs = {
  input: ICreateAccountInput;
};


export type IMutationCreateActivityCommentArgs = {
  input: ICreateActivityCommentInput;
};


export type IMutationCreateAndLinkAccountingVendorArgs = {
  input: ICreateAndLinkAccountingVendorInput;
};


export type IMutationCreateBillArgs = {
  input: ICreateBillInput;
};


export type IMutationCreateCardArgs = {
  input: ICreateCardInput;
};


export type IMutationCreateCheckDepositArgs = {
  input: ICreateCheckDepositInput;
};


export type IMutationCreateContractCommentArgs = {
  input: ICreateContractCommentInput;
};


export type IMutationCreateContractFromProcurementRequestArgs = {
  input: ICreateContractFromProcurementRequestInput;
};


export type IMutationCreateDepartmentArgs = {
  input: ICreateDepartmentInput;
};


export type IMutationCreateDraftAccrualsArgs = {
  input: ICreateDraftAccrualsInput;
};


export type IMutationCreateDraftPaymentArgs = {
  input: ICreateDraftPaymentInput;
};


export type IMutationCreateDraftPaymentsArgs = {
  input: ICreateDraftPaymentsInput;
};


export type IMutationCreateEventInstanceCommentArgs = {
  input: ICreateEventInstanceCommentInput;
};


export type IMutationCreateFileArgs = {
  input: ICreateFileInput;
};


export type IMutationCreateInvoiceArgs = {
  input: ICreateInvoiceInput;
};


export type IMutationCreatePayerArgs = {
  input: ICreatePayerInput;
};


export type IMutationCreateProcurementRequestArgs = {
  input: ICreateProcurementRequestInput;
};


export type IMutationCreateRecipientUserFromInvitationArgs = {
  input: ICreateRecipientUserFromInvitationInput;
};


export type IMutationCreateScheduledEventCommentArgs = {
  input: ICreateScheduledEventCommentInput;
};


export type IMutationCreateTokenVerificationArgs = {
  input: ICreateVerificationInput;
};


export type IMutationCreateTransactionCommentArgs = {
  input: ICreateTransactionCommentInput;
};


export type IMutationDeleteActivityCommentArgs = {
  input: IDeleteActivityCommentInput;
};


export type IMutationDeleteContractCommentArgs = {
  input: IDeleteContractCommentInput;
};


export type IMutationDeleteContractsArgs = {
  input: IDeleteContractsInput;
};


export type IMutationDeleteDepartmentArgs = {
  input: IDeleteDepartmentInput;
};


export type IMutationDeleteEventInstanceCommentArgs = {
  input: IDeleteEventInstanceCommentInput;
};


export type IMutationDeleteScheduledEventCommentArgs = {
  input: IDeleteScheduledEventCommentInput;
};


export type IMutationDeleteTransactionCommentArgs = {
  input: IDeleteTransactionCommentInput;
};


export type IMutationDeleteVendorFeedbackArgs = {
  input: IDeleteVendorFeedbackInput;
};


export type IMutationDisableRecipientArgs = {
  input: IDisableRecipientInput;
};


export type IMutationDisassociateAndDeleteFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type IMutationDisconnectExternalAccountArgs = {
  input: IDisconnectExternalAccountInput;
};


export type IMutationDismissVendorMissingContractArgs = {
  input: IDismissVendorMissingContractInput;
};


export type IMutationFreezeCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type IMutationGenerateApiKeyArgs = {
  input?: InputMaybe<IGenerateApiKeyInput>;
};


export type IMutationGenerateDocusignAuthUrlArgs = {
  input: IGetDocusignAuthUrlInput;
};


export type IMutationGenerateGoogleAuthUrlArgs = {
  input: IGenerateOAuthUrlInput;
};


export type IMutationGenerateSlackAuthUrlArgs = {
  input: IGenerateOAuthUrlInput;
};


export type IMutationGenerateVendorFeedbackTokenArgs = {
  input: IGenerateVendorFeedbackTokenInput;
};


export type IMutationInitiateAchDebitArgs = {
  input: IInitiateAchDebitInput;
};


export type IMutationInviteRecipientArgs = {
  input: IInviteRecipientInput;
};


export type IMutationInviteUserArgs = {
  input: IInviteUserInput;
};


export type IMutationLinkAccountingVendorArgs = {
  input: ILinkAccountingVendorInput;
};


export type IMutationLinkManuallyVerifiedPlaidAccountArgs = {
  input: ILinkManuallyVerifiedPlaidAccountInput;
};


export type IMutationLiteCreateFileArgs = {
  input: ICreateFileInput;
};


export type IMutationLiteDisassociateAndDeleteFileArgs = {
  input: IGetFileInput;
};


export type IMutationLiteGenerateFileUrlForDownloadArgs = {
  input: IGetFileInput;
};


export type IMutationLiteGenerateFileUrlForUploadArgs = {
  input: IGetFileInput;
};


export type IMutationLiteInviteUserArgs = {
  input: ILiteInviteUserInput;
};


export type IMutationLiteSignUpArgs = {
  input: ILiteSignUpInput;
};


export type IMutationLiteVerifyFileUploadArgs = {
  input: IGetFileInput;
};


export type IMutationMapDocVaultFormFieldsArgs = {
  input: IMapDocVaultFormFieldsInput;
};


export type IMutationOverrideRecipientTinVerificationArgs = {
  input: IOverrideRecipientTinVerificationInput;
};


export type IMutationParseContractsArgs = {
  input: IParseContractsInput;
};


export type IMutationPayCreditAccountArgs = {
  input: ICreditAccountPaymentInput;
};


export type IMutationProcessAssistantMessageArgs = {
  input: IProcessAssistantMessageInput;
};


export type IMutationRecordPaypalCredsArgs = {
  input: IPaypalCredentialsInput;
};


export type IMutationRecordVendorFeedbackArgs = {
  input: IRecordVendorFeedbackInput;
};


export type IMutationRegisterDocusignCallbackArgs = {
  input: IRegisterDocusignCallbackInput;
};


export type IMutationRegisterGoogleCallbackArgs = {
  input: IRegisterOAuthCallbackInput;
};


export type IMutationRegisterSlackCallbackArgs = {
  input: IRegisterOAuthCallbackInput;
};


export type IMutationRejectExpenseAccuralsArgs = {
  input: IExpenseAccrualIDsInput;
};


export type IMutationReleasePaymentsArgs = {
  input: IPaymentIDsInput;
};


export type IMutationReplaceCardArgs = {
  input: IReplaceCardInput;
};


export type IMutationReportCardLostArgs = {
  cardId: Scalars['ID']['input'];
};


export type IMutationReportCardStolenArgs = {
  cardId: Scalars['ID']['input'];
};


export type IMutationRequestConversionArgs = {
  input: IRequestConversionInput;
};


export type IMutationRequestInternalTransferArgs = {
  input: IRequestInternalTransferInput;
};


export type IMutationRequestPaymentArgs = {
  input: IRequestPaymentInput;
};


export type IMutationRequestPaymentsArgs = {
  input: IRequestPaymentsInput;
};


export type IMutationRequestRecipientArgs = {
  input: IRequestRecipientInput;
};


export type IMutationRequestRecipientFromInvitationArgs = {
  input: IRequestRecipientFromInvitationInput;
};


export type IMutationRequestRecipientsArgs = {
  input: IRequestRecipientsInput;
};


export type IMutationRequestTinNameMatchArgs = {
  input: IRequestTinNameMatchInput;
};


export type IMutationResetUserMfaArgs = {
  input: IResetUserMfaInput;
};


export type IMutationResolvePaymentsArgs = {
  input: IResolvePaymentsInput;
};


export type IMutationResolveProcurementRequestArgs = {
  input: IResolveProcurementRequestInput;
};


export type IMutationResolveRecipientsArgs = {
  input: IResolveRecipientRequestsInput;
};


export type IMutationRevokeApiKeyArgs = {
  input: IRevokeApiKeyInput;
};


export type IMutationRevokeRecipientInvitationArgs = {
  input: IRevokeRecipientInvitationInput;
};


export type IMutationSetActiveContractVersionArgs = {
  input: ISetActiveContractVersionInput;
};


export type IMutationSetAutoPayMethodArgs = {
  input: ISetAutoPayInput;
};


export type IMutationSetCustomerAccountingDefaultsArgs = {
  input: ISetCustomerAccountingDefaultsInput;
};


export type IMutationSetMultiLayerApprovalRulesArgs = {
  input: ISetMultiLayerApprovalRulesRequest;
};


export type IMutationSetOrgPreferencesArgs = {
  input: ISetPreferencesInput;
};


export type IMutationSetRecipientAccountingDefaultsArgs = {
  input: ISetRecipientAccountingDefaultsInput;
};


export type IMutationSetSelfPreferencesArgs = {
  input: ISetPreferencesInput;
};


export type IMutationToggleCustomerFreezeArgs = {
  input: IToggleCustomerFreezeInput;
};


export type IMutationTurnOffFeatureFlagArgs = {
  input: IToggleCustomerFeatureFlagInput;
};


export type IMutationTurnOnFeatureFlagArgs = {
  input: IToggleCustomerFeatureFlagInput;
};


export type IMutationUnfreezeCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type IMutationUpdateAccountArgs = {
  input: IUpdateAccountInput;
};


export type IMutationUpdateBillArgs = {
  input: IUpdateBillInput;
};


export type IMutationUpdateBusinessContactArgs = {
  input: IUpdateBusinessContactInput;
};


export type IMutationUpdateCardArgs = {
  input: IUpdateCardInput;
};


export type IMutationUpdateContractCashflowPeriodDatesArgs = {
  input: IUpdateContractCashflowPeriodDatesInput;
};


export type IMutationUpdateContractCashflowPeriodTotalsArgs = {
  input: IUpdateContractCashflowPeriodTotalsInput;
};


export type IMutationUpdateContractFieldsArgs = {
  input: IUpdateContractFieldsInput;
};


export type IMutationUpdateContractPaymentObligationsArgs = {
  input: IUpdateContractPaymentObligationsInput;
};


export type IMutationUpdateCustomerInfoArgs = {
  input: IUpdateCustomerInfoInput;
};


export type IMutationUpdateCustomerTierArgs = {
  input: IUpdateCustomerTierInput;
};


export type IMutationUpdateDraftAccrualsArgs = {
  input: IUpdateDraftExpenseAccrualsInput;
};


export type IMutationUpdateDraftPaymentArgs = {
  input: IUpdateDraftPaymentInput;
};


export type IMutationUpdateInvoiceStatusArgs = {
  input: IUpdateInvoiceStatusInput;
};


export type IMutationUpdateLevroOpsUserRoleArgs = {
  input: IUpdateLevroOpsUserRoleInput;
};


export type IMutationUpdateProcurementRequestArgs = {
  input: IUpdateProcurementRequestInput;
};


export type IMutationUpdateRecipientArgs = {
  input: IUpdateRecipientInput;
};


export type IMutationUpdateUserArgs = {
  input: IUpdateUserInput;
};


export type IMutationUploadParseAndMapFieldsFromDocArgs = {
  input: IUploadParseAndMapFieldsFromDocInput;
};


export type IMutationVerifyDocumentArgs = {
  input: IVerifyDocumentInput;
};


export type IMutationVerifyFileUploadArgs = {
  fileId: Scalars['ID']['input'];
};


export type IMutationWriteActivityNoteArgs = {
  input: IWriteActivityNoteInput;
};


export type IMutationWriteAnnotationArgs = {
  input: IWriteAnnotationInput;
};


export type IMutationWriteEventInstanceNoteArgs = {
  input: IWriteEventInstanceNoteInput;
};


export type IMutationWriteScheduledEventNoteArgs = {
  input: IWriteScheduledEventNoteInput;
};


export type IMutationWriteTransactionNoteArgs = {
  input: IWriteTransactionNoteInput;
};

export type INominalAccount = {
  __typename?: 'NominalAccount';
  classification?: Maybe<INominalAccountClassification>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentNominalAccount?: Maybe<INominalAccount>;
  status?: Maybe<IAccountingCategoryStatus>;
};

export enum INominalAccountClassification {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Income = 'INCOME',
  Liability = 'LIABILITY',
  Unknown = 'UNKNOWN'
}

export type INote = {
  __typename?: 'Note';
  /** At most 1023 characters. */
  memo?: Maybe<Scalars['String']['output']>;
};

export type INoteInput = {
  /** At most 1023 characters. */
  memo?: InputMaybe<Scalars['String']['input']>;
};

export type IOmiPreferences = {
  __typename?: 'OmiPreferences';
  defaultOptOutDays: IIntConstrainedValue;
  incomeStatementAccountsOnly: IToggleConstrainedValue;
  missingContractsLookbackAmount: IIntConstrainedValue;
  missingContractsLookbackMonths: IIntConstrainedValue;
  notificationDays: IIntConstrainedValue;
};

export type IOmiPreferencesInput = {
  defaultOptOutDays?: InputMaybe<IIntValueInput>;
  incomeStatementAccountsOnly?: InputMaybe<IToggleValueInput>;
  missingContractsLookbackAmount?: InputMaybe<IIntValueInput>;
  missingContractsLookbackMonths?: InputMaybe<IIntValueInput>;
  notificationDays?: InputMaybe<IIntValueInput>;
};

export type IOmiTablePreferences = {
  __typename?: 'OmiTablePreferences';
  /** A per-user preference. */
  contractTable: IBlobConstrainedValue;
};

export type IOmiTablePreferencesInput = {
  contractTable?: InputMaybe<IBlobValueInput>;
};

export type IOneTime = {
  __typename?: 'OneTime';
  date: Scalars['Date']['output'];
};

export type IOptionalDateRangeInput = {
  fromInclusive?: InputMaybe<Scalars['Date']['input']>;
  toInclusive?: InputMaybe<Scalars['Date']['input']>;
};

export enum IOrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type IOrg = {
  __typename?: 'Org';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Marks a recipient's TIN as verified when automatic verification failed. */
export type IOverrideRecipientTinVerificationInput = {
  recipientId: Scalars['ID']['input'];
  /** This will be checked against the recipient record to ensure consistency. */
  tin: Scalars['String']['input'];
};

export type IOverrideRecipientTinVerificationResponse = IBaseResponse & {
  __typename?: 'OverrideRecipientTINVerificationResponse';
  errors?: Maybe<Array<IDefaultError>>;
  success: Scalars['Boolean']['output'];
};

export type IPaginatedResponse = {
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
};

export type IPagination = {
  __typename?: 'Pagination';
  pageNumber: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IPaginationInput = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type IParseContractError = IDefaultError | IDefaultParseContractError;

export type IParseContractsInput = {
  fileIds: Array<Scalars['ID']['input']>;
};

export type IParseContractsResponse = {
  __typename?: 'ParseContractsResponse';
  contracts?: Maybe<Array<IContract>>;
  errors?: Maybe<Array<IParseContractError>>;
};

export type IParsedRecipient = {
  __typename?: 'ParsedRecipient';
  /** ⚠ Sensitive! Only request when needed. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<IAddress>;
  bankAddress?: Maybe<IAddress>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Will be null when isCompany=False */
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Will be null when isCompany=True */
  firstName?: Maybe<Scalars['String']['output']>;
  isCompany: Scalars['Boolean']['output'];
  isIban?: Maybe<Scalars['Boolean']['output']>;
  /** Will be null when isCompany=True */
  lastName?: Maybe<Scalars['String']['output']>;
  rawAddress?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  routingNumber2?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  /** ⚠ Sensitive! Only request when needed. */
  taxId?: Maybe<Scalars['String']['output']>;
};

export type IParsedRecipientInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<IAddressInput>;
  bankAddress?: InputMaybe<IAddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  rawAddress?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber2?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type IPayPalCredentials = {
  __typename?: 'PayPalCredentials';
  clientIdLast4: Scalars['String']['output'];
  clientSecretLast4: Scalars['String']['output'];
};

export type IPayPalCredentialsResponse = IBaseResponse & {
  __typename?: 'PayPalCredentialsResponse';
  /** NULL without errors means the user has not entered creds */
  credentials?: Maybe<IPayPalCredentials>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IPayer = {
  __typename?: 'Payer';
  address?: Maybe<IAddress>;
  contactName?: Maybe<Scalars['String']['output']>;
  defaultDepositAccount?: Maybe<IAccount>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payerName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** ⚠️ Expensive object. Avoid using in summary view. On-demand fields: mtUrl, swiftTrackingInfo ⚠ */
export type IPayment = {
  __typename?: 'Payment';
  achTraceNumber?: Maybe<Scalars['String']['output']>;
  /** Additional ACH payment description presented by some institutions */
  additionalDescription?: Maybe<Scalars['String']['output']>;
  amount: IMoney;
  bill?: Maybe<IBill>;
  /** User visible confirmation number */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  conversion?: Maybe<IConversion>;
  failedTransaction?: Maybe<ITransaction>;
  fee?: Maybe<IMoney>;
  feeTransaction?: Maybe<ITransaction>;
  fundingMethod: IFundingMethod;
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isSwiftInfoReady?: Maybe<Scalars['Boolean']['output']>;
  mtUrl?: Maybe<Scalars['String']['output']>;
  /** Payment originated by user name or sender */
  originatedBy?: Maybe<Scalars['String']['output']>;
  paymentRail?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<IRecipient>;
  reference: Scalars['String']['output'];
  /** The date that the provider released the payment - set to none before its released */
  releaseDate?: Maybe<Scalars['Date']['output']>;
  status: IExecutionStatus;
  swiftTrackingInfo?: Maybe<ISwiftPaymentTrackingInfo>;
  transaction?: Maybe<ITransaction>;
  uetr?: Maybe<Scalars['String']['output']>;
};

export type IPayment2 = {
  __typename?: 'Payment2';
  /** Error message if async approval recently failed */
  asyncApprovalError?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentUserResolutionAbility?: Maybe<IUserResolutionAbility>;
  destinationAmount: IVariableMoney;
  /** Date by which funds must be available to execute the payment. */
  fundingDeadline?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  method: IPaymentMethod;
  ordinal?: Maybe<Scalars['Int']['output']>;
  /** Be careful not to request any expensive or details-only subfields as that will dramatically decrease performance. */
  recipient: IRecipient;
  requester?: Maybe<IUser>;
  schedule?: Maybe<ISchedule>;
  /** The date a payment was or is scheduled to be executed. Null for pending or rejected payments with no scheduled date. */
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  sourceAmount: IVariableMoney;
  status: IPaymentStatus;
};

export type IPayment2Details = {
  __typename?: 'Payment2Details';
  eventInstance?: Maybe<IEventInstance>;
  payment: IPayment2;
  paymentTimeline?: Maybe<IPaymentTimeline>;
  scheduledPayment: IScheduledPayment;
};

export type IPaymentBillInput = {
  billDate: Scalars['Date']['input'];
  billPaymentNominalAccountId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<IBillLineItemInput>;
};

export type IPaymentDetailsWidget = IBaseWidget & {
  __typename?: 'PaymentDetailsWidget';
  details: IPayment2Details;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IPaymentError = IErrorInterface & {
  __typename?: 'PaymentError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IPaymentIdInput = {
  id: Scalars['ID']['input'];
};

export type IPaymentIDsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export enum IPaymentMethod {
  Local = 'LOCAL',
  Paypal = 'PAYPAL',
  Priority = 'PRIORITY',
  Venmo = 'VENMO'
}

export type IPaymentMethodBulkPaymentColumn = {
  __typename?: 'PaymentMethodBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  values: Array<Maybe<IPaymentMethod>>;
};

export type IPaymentRecipientInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  recipient: IRecipientInput;
};

export enum IPaymentRequestSource {
  Assistant = 'ASSISTANT',
  Flatfile = 'FLATFILE'
}

export enum IPaymentStatus {
  AwaitingFunds = 'AWAITING_FUNDS',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PendingApproval = 'PENDING_APPROVAL',
  PendingRelease = 'PENDING_RELEASE',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export type IPaymentSummary = {
  __typename?: 'PaymentSummary';
  amount: IVariableMoney;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  conversionSummary?: Maybe<IConversionSummary>;
  reason?: Maybe<Scalars['String']['output']>;
  recipientSummary?: Maybe<IRecipientSummary>;
  reference: Scalars['String']['output'];
};

export type IPaymentTableWidget = IBaseWidget & {
  __typename?: 'PaymentTableWidget';
  id: Scalars['ID']['output'];
  payments: Array<IPayment2>;
  title: Scalars['String']['output'];
};

export type IPaymentTerms = {
  __typename?: 'PaymentTerms';
  /** Number of days after the invoice is received when the payment is due. 0 iff the payment is due on receipt. */
  netDays: Scalars['Int']['output'];
};

export type IPaymentTermsInput = {
  netDays: Scalars['Int']['input'];
};

export type IPaymentTimeline = {
  __typename?: 'PaymentTimeline';
  arrivalBufferBusinessDays: Scalars['Int']['output'];
  arrivalDate: Scalars['Date']['output'];
  holidays: Array<IHoliday>;
  sendDate: Scalars['Date']['output'];
};

export type IPaymentTimelineResponse = IBaseResponse & {
  __typename?: 'PaymentTimelineResponse';
  errors?: Maybe<Array<IDefaultError>>;
  paymentTimeline?: Maybe<IPaymentTimeline>;
};

export type IPaymentsLocations = {
  __typename?: 'PaymentsLocations';
  allFields?: Maybe<Array<ILocation>>;
};

export type IPaypalCredentialsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type IPeriod = {
  __typename?: 'Period';
  endTime: Scalars['DateTime']['output'];
  /** @deprecated Use start/end time instead */
  month: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  /** @deprecated Use start/end time instead */
  year: Scalars['Int']['output'];
};

export type IPeriodInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use start/end time instead */
  month?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use start/end time instead */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type IPermissionsResponse = {
  __typename?: 'PermissionsResponse';
  permissions: Array<Scalars['String']['output']>;
};

export enum IPinStatus {
  NotSet = 'NOT_SET',
  Set = 'SET'
}

export type IPlaidAccount = {
  accountId: Scalars['ID']['input'];
  accountType: IAccountType;
  bankName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type IPlaidError = IErrorInterface & {
  __typename?: 'PlaidError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
  updateLinkToken?: Maybe<Scalars['String']['output']>;
};

export type IPreferenceError = {
  __typename?: 'PreferenceError';
  errors: Array<IDefaultError>;
  name: IPreferenceName;
};

export enum IPreferenceName {
  BillPayLineItemsShowBillable = 'BILL_PAY__LINE_ITEMS__SHOW_BILLABLE',
  BillPayLineItemsShowClass = 'BILL_PAY__LINE_ITEMS__SHOW_CLASS',
  BillPayLineItemsShowCustomer = 'BILL_PAY__LINE_ITEMS__SHOW_CUSTOMER',
  BillPayLineItemsShowDepartment = 'BILL_PAY__LINE_ITEMS__SHOW_DEPARTMENT',
  BillPayLineItemsShowLocation = 'BILL_PAY__LINE_ITEMS__SHOW_LOCATION',
  BillPayShowNominalPaymentAccounts = 'BILL_PAY__SHOW_NOMINAL_PAYMENT_ACCOUNTS',
  BrandingLogoFile = 'BRANDING__LOGO_FILE',
  BrandingPrimaryColor = 'BRANDING__PRIMARY_COLOR',
  BrandingSecondaryColor = 'BRANDING__SECONDARY_COLOR',
  OmiTableContract = 'OMI_TABLE__CONTRACT',
  OmiAccountingIncomeStatementOnly = 'OMI__ACCOUNTING__INCOME_STATEMENT_ONLY',
  OmiContractsDefaultOptOutDays = 'OMI__CONTRACTS__DEFAULT_OPT_OUT_DAYS',
  OmiContractsNotificationDays = 'OMI__CONTRACTS__NOTIFICATION_DAYS',
  OmiMissingContractsLookbackAmount = 'OMI__MISSING_CONTRACTS__LOOKBACK_AMOUNT',
  OmiMissingContractsLookbackMonths = 'OMI__MISSING_CONTRACTS__LOOKBACK_MONTHS',
  PaymentsRecipientBccEmail = 'PAYMENTS__RECIPIENT_BCC_EMAIL'
}

export enum IPreferenceScope {
  Org = 'ORG',
  Self = 'SELF'
}

export type IPreferences = {
  __typename?: 'Preferences';
  billPay: IBillPayPreferences;
  branding: IBrandingPreferences;
  omi: IOmiPreferences;
  omiTable: IOmiTablePreferences;
  scope: IPreferenceScope;
};

export type IProcessAssistantMessageInput = {
  /** IDs of files to attach to the message */
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: IAssistantMessageInput;
  /** null creates a new thread */
  threadId?: InputMaybe<Scalars['ID']['input']>;
};

export type IProcessAssistantMessageResponse = IBaseResponse & {
  __typename?: 'ProcessAssistantMessageResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** Null only on error */
  messageId?: Maybe<Scalars['ID']['output']>;
  /** Null only on error */
  thread?: Maybe<IAssistantThread>;
};

export type IProcurementRequest = {
  __typename?: 'ProcurementRequest';
  annualContractValue?: Maybe<IMoneyFormula>;
  approvalInfo: IApprovalInfo;
  department?: Maybe<IDepartment>;
  estimatedStartDate?: Maybe<Scalars['Date']['output']>;
  file?: Maybe<IFile>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<IUser>;
  vendor?: Maybe<IRecipient>;
  vendorName?: Maybe<Scalars['String']['output']>;
};

export enum IProduct {
  FullLevro = 'FULL_LEVRO',
  Supersheets = 'SUPERSHEETS'
}

export type IPurchaseTransactionMetadata = {
  __typename?: 'PurchaseTransactionMetadata';
  cardId?: Maybe<Scalars['ID']['output']>;
  cardPresent?: Maybe<Scalars['Boolean']['output']>;
  coordinates?: Maybe<ICoordinates>;
  digitalWallet?: Maybe<IDigitalWalletType>;
  ecommerce?: Maybe<Scalars['Boolean']['output']>;
  merchant?: Maybe<IMerchant>;
  originalCurrencyAmount?: Maybe<IMoney>;
  paymentMethod?: Maybe<ICardPaymentMethod>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  verificationMethod?: Maybe<IVerificationMethod>;
};

export type IQuery = {
  __typename?: 'Query';
  adminGetContracts: IAdminGetContractsResponse;
  adminGetCustomerOrgs: IAdminGetCustomerOrgsResponse;
  checkRecipientInvitationToken: ICheckRecipientInvitationTokenResponse;
  exportAccruals: IExportAccrualsResponse;
  exportPayments: IExportPaymentsResponse;
  exportTransactions: IExportTransactionsResponse;
  fxMarketStatus: IFxMarketStatusResponse;
  getAccount: IGetAccountResponse;
  getAccountInfo: IAccountInfoResponse;
  getAccountLimits: Array<IAccountLimit>;
  getAccountStatement: IGetAccountStatementResponse;
  getAccountStatements: IGetAccountStatementsResponse;
  /** Gets classes from the accounting system - used to set the class on line items */
  getAccountingClasses: IGetAccountingCategoriesResponse;
  /** Get customers from the accounting system - used to set the customer on line items */
  getAccountingConnection: IGetAccountingConnectionResponse;
  /** Get customers from the accounting system - used to set the customer on line items */
  getAccountingCustomers: IGetAccountingCustomersResponse;
  /** Gets departments from the accounting system - used to set the class on line items */
  getAccountingDepartments: IGetAccountingCategoriesResponse;
  getAccountingItems: IGetAccountingItemsResponse;
  /** Gets locations from the accounting system - used to set the location on line items */
  getAccountingLocations: IGetAccountingCategoriesResponse;
  getAccountingTaxRates: IGetAccountingTaxRatesResponse;
  /** Get Vendor from the accounting system, these can be linked to recipients in Levro */
  getAccountingVendor: IGetAccountingVendorResponse;
  /** Get Vendors from the accounting system, these can be linked to recipients in Levro */
  getAccountingVendors: IGetAccountingVendorsResponse;
  getAccounts: IGetAccountsResponse;
  getAccrual: IExpenseAccrualResponse;
  getAccruals: IGetAccrualsResponse;
  getAchPullTimeline: IPaymentTimelineResponse;
  getActivationChecklist: IGetActivationChecklistResponse;
  getActiveFeatures: Array<IFeatureFlag>;
  getActivities: IGetActivitiesResponse;
  getActivity: IGetActivityResponse;
  getAnnotationTasks: IGetAnnotationTasksResponse;
  getApiKeys: IGetApiKeysResponse;
  getApplication: IGetApplicationResponse;
  getApplications: IGetApplicationsResponse;
  getAssistantBoard: IGetAssistantBoardResponse;
  getAssistantThread: IGetAssistantThreadResponse;
  getAssistantThreads: IGetAssistantThreadsResponse;
  getBill: IGetBillResponse;
  /** Gets accounts for bill payment from the accounting system - used as the account to book a payment to */
  getBillPaymentNominalAccounts: IGetNominalAccountsResponse;
  getBillingAddress: IGetBillingAddressResponse;
  getBills: IGetBillsResponse;
  getBillsEmailInboxAddress: IGetBillsEmailInboxAddressResponse;
  /** Returns branding prefrences, to be used for un-authed flows such as recipient onboarding. */
  getBrandingPreferences: IGetBrandingPreferencesResponse;
  getBulkPayment: IGetBulkPaymentResponse;
  getCardAuthorizations: IGetCardAuthorizationsResponse;
  getCards: ICardsResponse;
  getConnectedAccount: IGetConnectedAccountResponse;
  getConnectedAccounts: IGetConnectedAccountsResponse;
  getContract: IGetContractResponse;
  getContracts: IGetContractsResponse;
  getContractsCashManagement: IGetContractsCashManagementResponse;
  getContractsCashflow: IGetContractsCashflowResponse;
  getConversionTimeline: IPaymentTimelineResponse;
  getCreditApplication: IGetCreditApplicationResponse;
  getCurrentUser: IUserResponse;
  getCurrentUserCustomers: IGetCurrentUserCustomersResponse;
  getCustomerAccountingDefaults: IGetAccountingDefaultsResponse;
  getCustomerBasic: ICustomerResponse;
  getCustomerTierSettings: IGetCustomerTierSettingsResponse;
  getDepartments: IGetDepartmentsResponse;
  getDocusignConnections: IGetDocusignConnectionsResponse;
  getEligibleBusinessContactUsers: IGetEligibleBusinessContactUsersResponse;
  getEventInstance: IGetEventInstanceResponse;
  getEventInstances: IGetEventInstancesResponse;
  getExpectedPaymentApprovalFlow: IExpectedApprovalInfoResponse;
  getFile: IGetFileResponse;
  getFundingInstructionsPdf: IGetFundingInstructionsPdfResponse;
  getGoogleConnection: IGetGoogleConnectionResponse;
  getInvoice: IGetInvoiceResponse;
  getInvoices: IGetInvoicesResponse;
  getMultiLayerApprovalRules: IGetMultiLayerApprovalRulesResponse;
  /** NOT IMPLEMENTED YET */
  getMultiLayerApprovalRulesVersions: IGetMultiLayerApprovalRulesVersionsResponse;
  /** Gets accounts for bill line items from the accounting system - used as the account to book a line item to */
  getNominalAccounts: IGetNominalAccountsResponse;
  getOmiUserProfile: IGetOmiUserProfileResponse;
  /**
   * Returns preferences for the current user's org.
   * - if the org has previously set a preference, returns that preference.
   * - else returns the global default preference.
   */
  getOrgPreferences: IGetPreferencesResponse;
  getOrgsWithTasks: IGetOrgsWithTasksResponse;
  getPayer: IGetPayerResponse;
  getPayers: IGetPayersResponse;
  getPayment: ISuperSheetsPaymentResponse;
  getPayment2: IGetPayment2Response;
  getPaymentFees: IGetPaymentFeesResponse;
  getPaymentTimeline: IPaymentTimelineResponse;
  getPayments: ISuperSheetsPaymentsResponse;
  getPayments2: IGetPayments2Response;
  getPaypalCreds: IPayPalCredentialsResponse;
  getPendingCreditAccountRepayments: IGetPendingCreditAccountRepaymentsResponse;
  getPendingCreditApplications: IGetPendingCreditApplicationsResponse;
  getProcurementRequests: IGetProcurementRequestsResponse;
  getRates: IGetRatesResponse;
  getRecipient: IGetRecipientResponse;
  getRecipientAccountingDefaults: IGetAccountingDefaultsResponse;
  getRecipientInvitations: IGetRecipientInvitationsResponse;
  getRecipientPayment: IGetRecipientPaymentResponse;
  getRecipientPayments: IGetRecipientPaymentsResponse;
  getRecipientTaxForm: IGetRecipientTaxFormResponse;
  getRecipients: IGetRecipientsResponse;
  getRecipientsWithoutContracts: IGetRecipientsWithoutContractResponse;
  getScheduledEvent: IGetScheduledEventResponse;
  getScheduledEvents: IGetScheduledEventsResponse;
  /**
   * Returns preferences for the current user.
   * - if the user has previously set a preference, returns that preference.
   * - if the org has previously set a preference, returns that preference.
   * - else returns the global default preference.
   */
  getSelfPreferences: IGetPreferencesResponse;
  getSheetsTierSettings: IGetSheetsTierSettingsResponse;
  getSlackConnection: IGetSlackConnectionResponse;
  getTransaction: IGetTransactionResponse;
  getTransactions: IGetTransactionsResponse;
  getUser: IUserResponse;
  getUserPermissions: IPermissionsResponse;
  getUsers: IUsersResponse;
  getVendorFeedback: IGetVendorFeedbackResponse;
  getVendorFeedbackFormData: IGetVendorFeedbackFormDataResponse;
  getVendorsMissingContract: IGetVendorsMissingContractsResponse;
  getVerificationLetter: IGetVerificationLetterResponse;
  getWireAmountForExternalFunding: IGetWireAmountForExternalFundingResponse;
  liteGetCurrentUserProfile: ILiteGetCurrentUserProfileResponse;
  liteGetFile: IGetFileResponse;
  ping: Scalars['String']['output'];
};


export type IQueryAdminGetContractsArgs = {
  input: IAdminGetContractsInput;
};


export type IQueryCheckRecipientInvitationTokenArgs = {
  token: Scalars['String']['input'];
};


export type IQueryExportAccrualsArgs = {
  input?: InputMaybe<IExportAccrualsInput>;
};


export type IQueryExportPaymentsArgs = {
  input?: InputMaybe<IExportPaymentsInput>;
};


export type IQueryExportTransactionsArgs = {
  input?: InputMaybe<IExportTransactionsInput>;
};


export type IQueryGetAccountArgs = {
  input: IGetAccountInput;
};


export type IQueryGetAccountStatementArgs = {
  input: IGetAccountStatementFilterInput;
};


export type IQueryGetAccountStatementsArgs = {
  input?: InputMaybe<IGetAccountStatementsInput>;
};


export type IQueryGetAccountingCustomersArgs = {
  input?: InputMaybe<IGetAccountingCustomersInput>;
};


export type IQueryGetAccountingVendorArgs = {
  input: IGetAccountingVendorInput;
};


export type IQueryGetAccountingVendorsArgs = {
  input?: InputMaybe<IGetAccountingVendorsInput>;
};


export type IQueryGetAccountsArgs = {
  input?: InputMaybe<IGetAccountsInput>;
};


export type IQueryGetAccrualArgs = {
  input: IExpenseAccrualIdInput;
};


export type IQueryGetAccrualsArgs = {
  input?: InputMaybe<IGetAccrualsInput>;
};


export type IQueryGetActivitiesArgs = {
  input?: InputMaybe<IGetActivitiesInput>;
};


export type IQueryGetActivityArgs = {
  input: IGetActivityInput;
};


export type IQueryGetAnnotationTasksArgs = {
  input: IGetAnnotationTasksInput;
};


export type IQueryGetApplicationArgs = {
  input?: InputMaybe<IGetApplicationInput>;
};


export type IQueryGetAssistantBoardArgs = {
  input: IGetAssistantBoardInput;
};


export type IQueryGetAssistantThreadArgs = {
  input: IGetAssistantThreadInput;
};


export type IQueryGetAssistantThreadsArgs = {
  input?: InputMaybe<IPaginationInput>;
};


export type IQueryGetBillArgs = {
  input: IGetBillInput;
};


export type IQueryGetBillsArgs = {
  input?: InputMaybe<IGetBillsInput>;
};


export type IQueryGetBrandingPreferencesArgs = {
  token: Scalars['String']['input'];
};


export type IQueryGetBulkPaymentArgs = {
  id: Scalars['String']['input'];
};


export type IQueryGetCardAuthorizationsArgs = {
  input: IGetCardAuthorizationsInput;
};


export type IQueryGetCardsArgs = {
  input?: InputMaybe<ICardsInput>;
};


export type IQueryGetConnectedAccountArgs = {
  input: IGetConnectedAccountInput;
};


export type IQueryGetContractArgs = {
  input: IGetContractInput;
};


export type IQueryGetContractsArgs = {
  input: IGetContractsInput;
};


export type IQueryGetContractsCashManagementArgs = {
  input: IGetContractsCashManagementInput;
};


export type IQueryGetContractsCashflowArgs = {
  input: IGetContractsCashflowInput;
};


export type IQueryGetConversionTimelineArgs = {
  input: IGetConversionTimelineInput;
};


export type IQueryGetEligibleBusinessContactUsersArgs = {
  input: IGetEligibleBusinessContactUsersInput;
};


export type IQueryGetEventInstanceArgs = {
  input: IGetEventInstanceInput;
};


export type IQueryGetEventInstancesArgs = {
  input: IGetEventInstancesInput;
};


export type IQueryGetExpectedPaymentApprovalFlowArgs = {
  input: IGetExpectedPaymentApprovalFlowInput;
};


export type IQueryGetFileArgs = {
  input: IGetFileInput;
};


export type IQueryGetInvoiceArgs = {
  input: IGetInvoiceInput;
};


export type IQueryGetInvoicesArgs = {
  input?: InputMaybe<IGetInvoicesInput>;
};


export type IQueryGetMultiLayerApprovalRulesArgs = {
  input: IGetMultiLayerApprovalRulesRequest;
};


export type IQueryGetMultiLayerApprovalRulesVersionsArgs = {
  input: IGetMultiLayerApprovalRulesVersionsRequest;
};


export type IQueryGetOrgsWithTasksArgs = {
  input: IGetOrgsWithTasksInput;
};


export type IQueryGetPayerArgs = {
  input: IGetPayerInput;
};


export type IQueryGetPayersArgs = {
  input: IGetPayersInput;
};


export type IQueryGetPaymentArgs = {
  input: IPaymentIdInput;
};


export type IQueryGetPayment2Args = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['String']['input'];
};


export type IQueryGetPaymentFeesArgs = {
  input: IGetPaymentFeesInput;
};


export type IQueryGetPaymentTimelineArgs = {
  input: IGetPaymentTimelineInput;
};


export type IQueryGetPaymentsArgs = {
  input?: InputMaybe<IGetPaymentsInput>;
};


export type IQueryGetPayments2Args = {
  input: IGetPayments2Input;
};


export type IQueryGetProcurementRequestsArgs = {
  input: IGetProcurementRequestsInput;
};


export type IQueryGetRatesArgs = {
  input: IGetRatesInput;
};


export type IQueryGetRecipientArgs = {
  input: IGetRecipientInput;
};


export type IQueryGetRecipientAccountingDefaultsArgs = {
  input: IGetRecipientAccountingDefaultsInput;
};


export type IQueryGetRecipientInvitationsArgs = {
  input: IGetRecipientInvitationsInput;
};


export type IQueryGetRecipientPaymentArgs = {
  input: IGetRecipientPaymentInput;
};


export type IQueryGetRecipientPaymentsArgs = {
  input: IGetRecipientPaymentsInput;
};


export type IQueryGetRecipientTaxFormArgs = {
  input: IGetRecipientTaxFormInput;
};


export type IQueryGetRecipientsArgs = {
  input: IGetRecipientsInput;
};


export type IQueryGetRecipientsWithoutContractsArgs = {
  input: IGetRecipientsWithoutContractInput;
};


export type IQueryGetScheduledEventArgs = {
  input: IGetScheduledEventInput;
};


export type IQueryGetScheduledEventsArgs = {
  input: IGetScheduledEventsInput;
};


export type IQueryGetTransactionArgs = {
  input: IGetTransactionInput;
};


export type IQueryGetTransactionsArgs = {
  input?: InputMaybe<IGetTransactionsInput>;
};


export type IQueryGetUserArgs = {
  input: IGetUserInput;
};


export type IQueryGetUsersArgs = {
  input: IGetUsersInput;
};


export type IQueryGetVendorFeedbackArgs = {
  input: IGetVendorFeedbackInput;
};


export type IQueryGetVendorFeedbackFormDataArgs = {
  token: Scalars['String']['input'];
};


export type IQueryGetVerificationLetterArgs = {
  input: IGetVerificationLetterInput;
};


export type IQueryLiteGetFileArgs = {
  input: IGetFileInput;
};

export type IRateInfo = ICachedRate | ILiveRate;

export type IRecipient = {
  __typename?: 'Recipient';
  /** ⚠ Sensitive! Only request when needed. */
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountNumberLastDigits?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<IRecipientAccountType>;
  /** ⚠️ Makes external API call. Only use in detail view */
  accountingVendor?: Maybe<IRecipientAccountingVendor>;
  address?: Maybe<IAddress>;
  /** ⚠️ Makes N+1 DB query; only use in detail view */
  approvalInfo: IApprovalInfo;
  /** Only resolvable in getContracts or getContract */
  averageFeedback?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  creationTimeUtc: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** Either a user-supplied nickname or the official first+last or company name. */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasLinkedAccountingVendor: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invitation?: Maybe<IRecipientInvitation>;
  isCompany: Scalars['Boolean']['output'];
  isUsTaxResident?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<IUser>;
  paypalEmail?: Maybe<Scalars['String']['output']>;
  /** ⚠ Sensitive! Only request when needed. */
  paypalId?: Maybe<Scalars['String']['output']>;
  paypalPhone?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  routingNumber2?: Maybe<Scalars['String']['output']>;
  supportedPaymentMethods: Array<IPaymentMethod>;
  swift?: Maybe<Scalars['String']['output']>;
  /** ⚠️Expensive, request for one recipient at a time */
  taxForms?: Maybe<Array<IRecipientTaxForm>>;
  /** ⚠ Sensitive! Only request when needed. */
  taxId?: Maybe<Scalars['String']['output']>;
  /** ⚠ Sensitive! Only request when needed. */
  usTin?: Maybe<Scalars['String']['output']>;
  /** Only use in detail view */
  usTinVerificationInfo?: Maybe<IMaybeRecipientTinVerificationStatus>;
  user?: Maybe<IUser>;
  venmoHandle?: Maybe<Scalars['String']['output']>;
  versionId: Scalars['ID']['output'];
};

export type IRecipientAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<IRecipientAccountType>;
  address?: InputMaybe<IAddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  paypalEmail?: InputMaybe<Scalars['String']['input']>;
  paypalId?: InputMaybe<Scalars['String']['input']>;
  paypalPhone?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber2?: InputMaybe<Scalars['String']['input']>;
  supportedPaymentMethods: Array<IPaymentMethod>;
  swift?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  venmoHandle?: InputMaybe<Scalars['String']['input']>;
};

export enum IRecipientAccountType {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type IRecipientAccountingVendor = IAccountingVendor | IAccountingVendorSyncing;

export type IRecipientInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<IRecipientAccountType>;
  address?: InputMaybe<IAddressInput>;
  /** required iff is_company */
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  /** if absent, will be derived from the other name fields */
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** required iff not is_company */
  firstName?: InputMaybe<Scalars['String']['input']>;
  isCompany: Scalars['Boolean']['input'];
  /** Required when self onboarding and invitation.isTaxFormRequired is true. This field determines which tax form to fill */
  isUsTaxResident?: InputMaybe<Scalars['Boolean']['input']>;
  /** required iff not is_company */
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkAndCreateAccountingVendor?: InputMaybe<ILinkAndCreateAccountingVendorInput>;
  paypalEmail?: InputMaybe<Scalars['String']['input']>;
  paypalId?: InputMaybe<Scalars['String']['input']>;
  paypalPhone?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  routingNumber2?: InputMaybe<Scalars['String']['input']>;
  supportedPaymentMethods: Array<IPaymentMethod>;
  swift?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Required when self onboarding and isUsTaxResident is true */
  usTin?: InputMaybe<Scalars['String']['input']>;
  venmoHandle?: InputMaybe<Scalars['String']['input']>;
};

/** An invitation for a recipient to enter their payment details. */
export type IRecipientInvitation = {
  __typename?: 'RecipientInvitation';
  /** Deprecated. Use recipient.approval_info.status. */
  approvalStatus?: Maybe<IApprovalRequestStatus>;
  contactEmail: Scalars['String']['output'];
  /** The name of the person or department who will provide payment details. */
  contactName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationStatus: IRecipientInvitationStatus;
  invitedBy: IUser;
  isCompany: Scalars['Boolean']['output'];
  /** When checked, after completing self onboarding, an Anvil redirect URL will be presented to fill tax form */
  isTaxFormRequired: Scalars['Boolean']['output'];
  manager?: Maybe<IUser>;
  recipient?: Maybe<IRecipient>;
  /** The name of the entity that will receive payments. */
  recipientName: Scalars['String']['output'];
  /** Deprecated. Use recipient.approval_info.resolver.first/last_name. */
  resolverName?: Maybe<Scalars['String']['output']>;
};

/** A subset of RecipientInvitation that is safe to expose to the invitee. */
export type IRecipientInvitationForRecipient = {
  __typename?: 'RecipientInvitationForRecipient';
  contactEmail: Scalars['String']['output'];
  /** The name of the person or department who will provide payment details. */
  contactName?: Maybe<Scalars['String']['output']>;
  hasRecipientAccount: Scalars['Boolean']['output'];
  invitedByOrgName: Scalars['String']['output'];
  invitedByUserEmail: Scalars['String']['output'];
  invitedByUserName: Scalars['String']['output'];
  isCompany: Scalars['Boolean']['output'];
  isTaxFormRequired: Scalars['Boolean']['output'];
  /** The name of the entity that will receive payments. */
  recipientName: Scalars['String']['output'];
  status: IRecipientInvitationStatus;
  /** If a recipient started filling out a tax form but didn't finish, they can come back to fill it using the recipient invitation */
  taxFormContinueUrl?: Maybe<Scalars['String']['output']>;
};

export enum IRecipientInvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Invited = 'INVITED',
  NeedsTaxForm = 'NEEDS_TAX_FORM',
  Revoked = 'REVOKED'
}

export type IRecipientLocations = {
  __typename?: 'RecipientLocations';
  name?: Maybe<ILocation>;
};

export type IRecipientMissingTinVerificationInfo = {
  __typename?: 'RecipientMissingTINVerificationInfo';
  /** types may not have zero fields */
  null?: Maybe<Scalars['Boolean']['output']>;
};

export type IRecipientNameError = IRecipientNameNoMatchError | IRecipientNamePartialMatchError;

export type IRecipientNameNoMatchError = IErrorInterface & {
  __typename?: 'RecipientNameNoMatchError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IRecipientNamePartialMatchError = IErrorInterface & {
  __typename?: 'RecipientNamePartialMatchError';
  actualName?: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IRecipientPayment = {
  __typename?: 'RecipientPayment';
  amount: IMoney;
  /** Recipient-visible attached files. Use in details views, not summaries. */
  attachments?: Maybe<Array<IFile>>;
  /** User visible confirmation number */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  /** Expensive fields. Use in details views, not summaries. */
  details?: Maybe<IRecipientPaymentDetail>;
  id: Scalars['ID']['output'];
};

export type IRecipientPaymentDetail = {
  __typename?: 'RecipientPaymentDetail';
  achTraceNumber?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  paymentRail?: Maybe<Scalars['String']['output']>;
  uetr?: Maybe<Scalars['String']['output']>;
};

export type IRecipientSummary = {
  __typename?: 'RecipientSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type IRecipientTinVerificationInfo = {
  __typename?: 'RecipientTINVerificationInfo';
  status: ITinMatchStatus;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<IUser>;
};

export type IRecipientTableWidget = IBaseWidget & {
  __typename?: 'RecipientTableWidget';
  id: Scalars['ID']['output'];
  recipients: Array<IRecipient>;
  title: Scalars['String']['output'];
};

export type IRecipientTaxForm = {
  __typename?: 'RecipientTaxForm';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  status: ITaxFormStatus;
  taxFormType: ITaxFormType;
  /** ⚠️Expensive, request on-demand */
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type IRecipientUserIdentityInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type IRecipientsFilter = {
  approvalStatuses?: InputMaybe<Array<IApprovalRequestStatus>>;
  currencies?: InputMaybe<Array<ICurrency>>;
  /**
   * If null or not specified, includes only recipients sourced from Levro, but does not otherwise filter.
   * If true, returns all recipients that have an accounting vendor, including recipients sourced from the accounting system. (includes recipients with recorded accounting vendors that cannot currently be loaded)
   * If false, returns only recipients that do not have an accounting vendor.
   */
  isAccountingVendor?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If null or not specified, does not filter.
   * If empty, returns only recipients that have no manager.
   * Otherwise, returns only recipients with the specified manager.
   */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type IRecordVendorFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  raterEmail: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type IRecurring = {
  __typename?: 'Recurring';
  nInstances: Scalars['Int']['output'];
  rrule: Scalars['String']['output'];
};

export type IReferralCode = {
  __typename?: 'ReferralCode';
  code: Scalars['String']['output'];
};

export type IReferralResponse = IIneligibleForReferral | IReferralCode;

export type IRegisterDocusignCallbackInput = {
  code: Scalars['String']['input'];
  /** Session state to validate against */
  sessionState: Scalars['String']['input'];
  /** State from callback query */
  state: Scalars['String']['input'];
};

export type IRegisterOAuthCallbackInput = {
  code: Scalars['String']['input'];
  /** Session state to validate against */
  sessionState: Scalars['String']['input'];
  /** State from callback query */
  state: Scalars['String']['input'];
};

export type IReleaseInfo = {
  __typename?: 'ReleaseInfo';
  releasedBy: IUser;
  timestamp: Scalars['DateTime']['output'];
};

export type IReleaseState = {
  __typename?: 'ReleaseState';
  /** null if not yet released */
  releaseInfo?: Maybe<IReleaseInfo>;
};

export type IReleaseSuperSheetsPaymentError = IDefaultError | IPaymentError | ISuperSheetsPaymentValidationError;

export type IReleaseSuperSheetsPaymentsResponse = {
  __typename?: 'ReleaseSuperSheetsPaymentsResponse';
  errors?: Maybe<Array<IReleaseSuperSheetsPaymentError>>;
  payments?: Maybe<Array<ISuperSheetsPayment>>;
};

export type IRepaymentAccount = IAccount | IConnectedAccount;

export enum IRepaymentAccountType {
  External = 'EXTERNAL',
  Levro = 'LEVRO'
}

export type IRepaymentInfo = {
  __typename?: 'RepaymentInfo';
  frequency: IFrequency;
  nextRepaymentDueDate: Scalars['Date']['output'];
  repaymentAccount: IRepaymentAccount;
};

export type IReplaceCardInput = {
  cardId: Scalars['ID']['input'];
  shippingAddress?: InputMaybe<IAddressInput>;
};

export type IReplaceCardResponse = IBaseResponse & {
  __typename?: 'ReplaceCardResponse';
  card?: Maybe<ICard>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IRequestConversionError = IConversionBelowLimitError | IConversionFailedError | IConversionRateChangedError | ICurrencyPairNotTradeableError | IDefaultError | IDuplicateScheduledEventIdempotencyKeyError | IFxConversionUnavailableError | IFxMarketsClosedError | IInsufficientBalanceError;

export type IRequestConversionInput = {
  amortized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provide when available, otherwise set destinationCurrency */
  destinationAccountId?: InputMaybe<Scalars['ID']['input']>;
  destinationAmount: IVariableMoneyInput;
  /** Provide only when destinationAccountId is not available. Do not set to USD */
  destinationCurrency?: InputMaybe<Scalars['String']['input']>;
  fileIds: Array<Scalars['ID']['input']>;
  fixedAmount: IFixedAmount;
  /** If true, ensures the request will require explicit approval by skipping requester self-approval if it is the only approval needed. */
  forceManualApproval?: Scalars['Boolean']['input'];
  /** If true, prevents synchronous execution if it would have been possible in favor of running via the scheduler. */
  forceScheduled?: Scalars['Boolean']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  note: INoteInput;
  rrule?: InputMaybe<Scalars['String']['input']>;
  sourceAccountId: Scalars['ID']['input'];
  sourceAmount: IVariableMoneyInput;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IRequestConversionResponse = {
  __typename?: 'RequestConversionResponse';
  errors?: Maybe<Array<IRequestConversionError>>;
  /** Non-null iff the conversion was recorded. */
  result?: Maybe<IRequestConversionResult>;
};

export type IRequestConversionResult = IRequestConversionScheduledResult | IRequestConversionSynchronousResult;

export type IRequestConversionScheduledResult = {
  __typename?: 'RequestConversionScheduledResult';
  approvalInfo: IApprovalInfo;
  eventId: Scalars['ID']['output'];
};

export type IRequestConversionSynchronousResult = {
  __typename?: 'RequestConversionSynchronousResult';
  activityId: Scalars['ID']['output'];
  /** Non-null iff the conversion was issued by the provider. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
};

export type IRequestInternalTransferInput = {
  amount: IMoneyInput;
  destinationAccountId: Scalars['ID']['input'];
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  idempotencyKey: Scalars['String']['input'];
  note?: InputMaybe<INoteInput>;
  sourceAccountId: Scalars['ID']['input'];
};

export type IRequestInternalTransferResponse = IBaseResponse & {
  __typename?: 'RequestInternalTransferResponse';
  activity?: Maybe<IActivity>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IRequestPaymentError = IConversionBelowLimitError | IConversionFailedError | IConversionRateChangedError | ICurrencyPairNotTradeableError | IDefaultError | IDuplicatePaymentError | IDuplicateScheduledEventIdempotencyKeyError | IFxConversionUnavailableError | IFxMarketsClosedError | IInsufficientBalanceError | IInvalidRecipientError;

export type IRequestPaymentInput = {
  /** iff False (the default), raises DuplicatePaymentError iff the payment is a duplicate. */
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  amortized?: InputMaybe<Scalars['Boolean']['input']>;
  bill?: InputMaybe<IPaymentBillInput>;
  chargeType?: InputMaybe<ISwiftChargeType>;
  destinationAmount: IVariableMoneyInput;
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fixedAmount: IFixedAmount;
  /** If true, ensures the request will require explicit approval by skipping requester self-approval if it is the only approval needed. */
  forceManualApproval?: Scalars['Boolean']['input'];
  /** If true, prevents synchronous execution if it would have been possible in favor of running via the scheduler. */
  forceScheduled?: Scalars['Boolean']['input'];
  fundingMethod: IFundingMethodInput;
  /** idempotency key used for creating the payment (does not apply to the recipient or bill). */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Required by CC for INR payments only */
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  /** Required by CC for INR payments only */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  linkAndCreateAccountingVendor?: InputMaybe<ILinkAndCreateAccountingVendorInput>;
  method: IPaymentMethod;
  note?: InputMaybe<INoteInput>;
  purposeCode?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  /** Specify either recipientId or recipientRequest. */
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  /** Specify either recipientId or recipientRequest. */
  recipientRequest?: InputMaybe<IPaymentRecipientInput>;
  reference: Scalars['String']['input'];
  rrule?: InputMaybe<Scalars['String']['input']>;
  showFilesToRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only set to null when external funding */
  sourceAccountId?: InputMaybe<Scalars['ID']['input']>;
  sourceAmount: IVariableMoneyInput;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IRequestPaymentResponse = {
  __typename?: 'RequestPaymentResponse';
  billErrors?: Maybe<Array<IDefaultError>>;
  /** Null iff the bill could not be updated. */
  billId?: Maybe<Scalars['ID']['output']>;
  /** Null iff the payment could not be issued. */
  payment?: Maybe<IRequestPaymentResult>;
  paymentErrors?: Maybe<Array<IRequestPaymentError>>;
  /** Null iff the recipient does not already exist, and could not be created. */
  recipient?: Maybe<IRecipient>;
  recipientErrors?: Maybe<Array<IDefaultError>>;
  requestedNewRecipient: Scalars['Boolean']['output'];
};

export type IRequestPaymentResult = IRequestPaymentScheduledResult | IRequestPaymentSynchronousResult;

export type IRequestPaymentScheduledResult = {
  __typename?: 'RequestPaymentScheduledResult';
  approvalInfo: IApprovalInfo;
  eventId: Scalars['ID']['output'];
  fundingMethod: IFundingMethod;
  fundingStatus: IFundingStatus;
};

export type IRequestPaymentSynchronousResult = {
  __typename?: 'RequestPaymentSynchronousResult';
  activityId: Scalars['ID']['output'];
  /** Non-null iff the payment was issued by the provider. */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  scheduledPaymentId: Scalars['ID']['output'];
};

export type IRequestPaymentsInput = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  requestedPayments: Array<IRequestPaymentInput>;
  /** Source platform for the bulk payment request */
  source?: IPaymentRequestSource;
  /** ID of the bulk payment request in the source platform */
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type IRequestPaymentsResponse = IBaseResponse & {
  __typename?: 'RequestPaymentsResponse';
  /** null only on error */
  bulkPaymentId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Per-request responses in the same order as request; null only on error */
  paymentResponses?: Maybe<Array<IRequestPaymentResponse>>;
};

export type IRequestRecipientFromInvitationInput = {
  /** ⚠ displayName and email will be ignored in favor of values stored on the invitation */
  recipient: IRecipientInput;
  token: Scalars['String']['input'];
};

export type IRequestRecipientFromInvitationResponse = IBaseResponse & {
  __typename?: 'RequestRecipientFromInvitationResponse';
  /** When provided, redirect recipient to Anvil tax form */
  anvilTaxFormUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<IDefaultError>>;
  recipientRequested: Scalars['Boolean']['output'];
};

export type IRequestRecipientInput = {
  /** If true, ensures the request will require explicit approval by skipping requester self-approval if it is the only approval needed. */
  forceManualApproval?: Scalars['Boolean']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  overrideGbpConfirmation?: Scalars['Boolean']['input'];
  recipient: IRecipientInput;
};

export type IRequestRecipientResponse = IBaseResponse & {
  __typename?: 'RequestRecipientResponse';
  errors?: Maybe<Array<IDefaultError>>;
  nameMatchErrors?: Maybe<Array<IRecipientNameError>>;
  recipient?: Maybe<IRecipient>;
};

export type IRequestRecipientsInput = {
  requests: Array<IRequestRecipientInput>;
};

export type IRequestRecipientsResponse = {
  __typename?: 'RequestRecipientsResponse';
  responses: Array<IRequestRecipientResponse>;
};

export type IRequestTinNameMatchInput = {
  name: Scalars['String']['input'];
  /** required for authentication when called on behalf of an invited recipient who does not yet have an account */
  recipientInvitationToken?: InputMaybe<Scalars['String']['input']>;
  tin: Scalars['String']['input'];
};

export type IRequestTinNameMatchResponse = IBaseResponse & {
  __typename?: 'RequestTINNameMatchResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  response?: Maybe<ITinMatchResponseCategory>;
};

export enum IRequestedType {
  Bill = 'BILL',
  ProcurementRequest = 'PROCUREMENT_REQUEST',
  RecipientVersion = 'RECIPIENT_VERSION',
  ScheduledConversion = 'SCHEDULED_CONVERSION',
  ScheduledPayment = 'SCHEDULED_PAYMENT'
}

export type IResetUserMfaInput = {
  userId: Scalars['ID']['input'];
};

export type IResetUserMfaResponse = IBaseResponse & {
  __typename?: 'ResetUserMFAResponse';
  errors?: Maybe<Array<IDefaultError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** No errors means success. */
export type IResolvePaymentResult = IBaseResponse & {
  __typename?: 'ResolvePaymentResult';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  paymentId?: Maybe<Scalars['ID']['output']>;
};

export type IResolvePaymentsAsyncResult = {
  __typename?: 'ResolvePaymentsAsyncResult';
  /** These payments were submitted for resolution; resolution may or may not have completed for each. */
  paymentIds: Array<Scalars['ID']['output']>;
};

export type IResolvePaymentsInput = {
  fundingMethod?: InputMaybe<IFundingMethodInput>;
  paymentIds: Array<Scalars['ID']['input']>;
  /** Must be either APPROVED or REJECTED */
  resolution: IApprovalRequestStatus;
  /** Only impacts multi-layer approvals */
  useAdminOverride?: Scalars['Boolean']['input'];
};

/** Payments will be resolved after this function returns; it is possible that resolution fails for one or more payments. */
export type IResolvePaymentsResponse = IBaseResponse & {
  __typename?: 'ResolvePaymentsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  result?: Maybe<IResolvePaymentsResult>;
};

export type IResolvePaymentsResult = IResolvePaymentsAsyncResult | IResolvePaymentsSyncResult;

export type IResolvePaymentsSyncResult = {
  __typename?: 'ResolvePaymentsSyncResult';
  results: Array<IResolvePaymentResult>;
};

export type IResolveProcurementRequestInput = {
  approve: Scalars['Boolean']['input'];
  requestId: Scalars['String']['input'];
};

export type IResolveProcurementRequestResponse = IBaseResponse & {
  __typename?: 'ResolveProcurementRequestResponse';
  /** None on error or if procurement request did not transition to fully approved. */
  contract?: Maybe<IContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IResolveRecipientRequestResponse = IBaseResponse & {
  __typename?: 'ResolveRecipientRequestResponse';
  errors?: Maybe<Array<IDefaultError>>;
  recipient?: Maybe<IRecipient>;
};

export type IResolveRecipientRequestsInput = {
  recipientVersionIds: Array<Scalars['ID']['input']>;
  /** Must be either APPROVED or REJECTED */
  resolution: IApprovalRequestStatus;
};

export type IResolveRecipientRequestsResponse = IBaseResponse & {
  __typename?: 'ResolveRecipientRequestsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  responses: Array<IResolveRecipientRequestResponse>;
};

export type IRevokeApiKeyInput = {
  prefix: Scalars['String']['input'];
};

export type IRevokeApiKeyResponse = IBaseResponse & {
  __typename?: 'RevokeApiKeyResponse';
  errors?: Maybe<Array<IDefaultError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type IRevokeRecipientInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

export type IRevokeRecipientInvitationResponse = IBaseResponse & {
  __typename?: 'RevokeRecipientInvitationResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  recipientInvitation?: Maybe<IRecipientInvitation>;
};

export type IRoleApprover = {
  __typename?: 'RoleApprover';
  role: IApproverUserRole;
};

export type IRoleApproverInput = {
  role: IApproverUserRole;
};

export type ISwiftAccountDetails = {
  __typename?: 'SWIFTAccountDetails';
  accountHolder: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  ibanOrAccountNumber: Scalars['String']['output'];
  swiftCode: Scalars['String']['output'];
};

export enum ISwiftChargeType {
  Ours = 'OURS',
  Shared = 'SHARED'
}

export type ISwiftForeignExchangeDetail = {
  __typename?: 'SWIFTForeignExchangeDetail';
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  sourceCurrency?: Maybe<Scalars['String']['output']>;
  targetCurrency?: Maybe<Scalars['String']['output']>;
};

export type ISwiftPaymentTrackingEvent = {
  __typename?: 'SWIFTPaymentTrackingEvent';
  chargeAmounts?: Maybe<Array<IMoney>>;
  chargeType?: Maybe<Scalars['String']['output']>;
  confirmedAmount?: Maybe<IMoney>;
  foreignExchangeDetails?: Maybe<ISwiftForeignExchangeDetail>;
  forwardedToAgentBd?: Maybe<IBankDetail>;
  fromBd?: Maybe<IBankDetail>;
  fundsAvailable?: Maybe<Scalars['DateTime']['output']>;
  instructedAmount?: Maybe<IMoney>;
  interbankSettlementAmount?: Maybe<IMoney>;
  interbankSettlementDate?: Maybe<Scalars['Date']['output']>;
  lastUpdateTime?: Maybe<Scalars['DateTime']['output']>;
  originatorBd?: Maybe<IBankDetail>;
  senderAcknowledgementReceipt?: Maybe<Scalars['DateTime']['output']>;
  serialParties?: Maybe<ISwiftSerialParties>;
  toBd?: Maybe<IBankDetail>;
  trackerEventType?: Maybe<Scalars['String']['output']>;
  transactionStatus?: Maybe<ISwiftTransactionStatus>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type ISwiftPaymentTrackingInfo = {
  __typename?: 'SWIFTPaymentTrackingInfo';
  completionTime?: Maybe<Scalars['DateTime']['output']>;
  initiationTime?: Maybe<Scalars['DateTime']['output']>;
  lastUpdateTime?: Maybe<Scalars['DateTime']['output']>;
  paymentEvents?: Maybe<Array<ISwiftPaymentTrackingEvent>>;
  transactionStatus?: Maybe<ISwiftTransactionStatus>;
  uetr?: Maybe<Scalars['String']['output']>;
};

export type ISwiftSerialParties = {
  __typename?: 'SWIFTSerialParties';
  creditorAgentBd?: Maybe<IBankDetail>;
  creditorBd?: Maybe<IBankDetail>;
  debtorAgentBd?: Maybe<IBankDetail>;
  debtorBd?: Maybe<IBankDetail>;
  instructingReimbursementAgentBd?: Maybe<IBankDetail>;
  intermediaryAgent1Bd?: Maybe<IBankDetail>;
};

export type ISwiftTransactionStatus = {
  __typename?: 'SWIFTTransactionStatus';
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ISchedule = IOneTime | IRecurring;

export enum IScheduleCategory {
  OneTimeOnEnable = 'ONE_TIME_ON_ENABLE',
  OneTimeScheduled = 'ONE_TIME_SCHEDULED',
  OneTimeSynchronous = 'ONE_TIME_SYNCHRONOUS',
  Recurring = 'RECURRING'
}

export type IScheduledConversion = IScheduledEventInterface & {
  __typename?: 'ScheduledConversion';
  approvalInfo: IApprovalInfo;
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  creationTime: Scalars['DateTime']['output'];
  currencyCostAveragingState?: Maybe<ICurrencyCostAveragingState>;
  destinationAmount?: Maybe<Scalars['Float']['output']>;
  destinationCurrency: Scalars['String']['output'];
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  id: Scalars['ID']['output'];
  /** All instances for the event, in ascending order of ordinal. Use in details views, not summaries. */
  instances?: Maybe<Array<IEventInstance>>;
  levroActivation: IScheduledEventActivation;
  /** @deprecated Use ScheduledEventInterface.note.memo instead */
  memo?: Maybe<Scalars['String']['output']>;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  schedule?: Maybe<ISchedule>;
  sourceAmount?: Maybe<Scalars['Float']['output']>;
  sourceCurrency: Scalars['String']['output'];
  status: IScheduledEventStatus;
  userActivation: IScheduledEventActivation;
};

export type IScheduledEvent = IScheduledConversion | IScheduledPayment;

export enum IScheduledEventActivation {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type IScheduledEventInstance = IScheduledEventInstanceInterface & {
  __typename?: 'ScheduledEventInstance';
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use only where a 'cancel' button might be displayed. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  canceled: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  event: IScheduledEvent;
  eventId: Scalars['String']['output'];
  expectedExecutionTime: Scalars['DateTime']['output'];
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  ordinal: Scalars['Int']['output'];
  scheduledDateEt: Scalars['Date']['output'];
};

export type IScheduledEventInstanceInterface = {
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use only where a 'cancel' button might be displayed. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  event: IScheduledEvent;
  eventId: Scalars['String']['output'];
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  ordinal: Scalars['Int']['output'];
  scheduledDateEt: Scalars['Date']['output'];
};

export enum IScheduledEventInstanceStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FailedReschedulable = 'FAILED_RESCHEDULABLE',
  Initiated = 'INITIATED',
  Scheduled = 'SCHEDULED',
  SkippedReschedulable = 'SKIPPED_RESCHEDULABLE',
  Succeeded = 'SUCCEEDED'
}

export type IScheduledEventInterface = {
  approvalInfo: IApprovalInfo;
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  creationTime: Scalars['DateTime']['output'];
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  id: Scalars['ID']['output'];
  /** All instances for the event, in ascending order of ordinal. Use in details views, not summaries. */
  instances?: Maybe<Array<IEventInstance>>;
  levroActivation: IScheduledEventActivation;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  schedule?: Maybe<ISchedule>;
  status: IScheduledEventStatus;
  userActivation: IScheduledEventActivation;
};

export enum IScheduledEventStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type IScheduledPayment = IScheduledEventInterface & {
  __typename?: 'ScheduledPayment';
  approvalInfo: IApprovalInfo;
  /** Error message if async approval recently failed */
  asyncApprovalError?: Maybe<Scalars['String']['output']>;
  bill?: Maybe<IBill>;
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  canCancel: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  creationTime: Scalars['DateTime']['output'];
  currencyCostAveragingState?: Maybe<ICurrencyCostAveragingState>;
  destinationAmount?: Maybe<Scalars['Float']['output']>;
  destinationCurrency: Scalars['String']['output'];
  fee?: Maybe<IMoney>;
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  fundingMethod: IFundingMethod;
  fundingStatus: IFundingStatus;
  id: Scalars['ID']['output'];
  /** All instances for the event, in ascending order of ordinal. Use in details views, not summaries. */
  instances?: Maybe<Array<IEventInstance>>;
  /** Required by CC for INR payments only */
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  /** Required by CC for INR payments only */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  levroActivation: IScheduledEventActivation;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  paymentRail?: Maybe<Scalars['String']['output']>;
  purposeCode?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  recipient: IRecipient;
  reference: Scalars['String']['output'];
  schedule?: Maybe<ISchedule>;
  sourceAmount?: Maybe<Scalars['Float']['output']>;
  sourceCurrency: Scalars['String']['output'];
  status: IScheduledEventStatus;
  userActivation: IScheduledEventActivation;
};

export type ISchedulingInfo = {
  __typename?: 'SchedulingInfo';
  /** Use only where a 'cancel' button might be displayed. */
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  currencyCostAveragingState?: Maybe<ICurrencyCostAveragingState>;
  id: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  schedule?: Maybe<ISchedule>;
  scheduledDateEt: Scalars['Date']['output'];
  schedulingStatus: IScheduledEventInstanceStatus;
};

export enum ISchemaType {
  Contract = 'CONTRACT'
}

export type ISendBulkPaymentWidget = IBaseWidget & {
  __typename?: 'SendBulkPaymentWidget';
  bulkPaymentData: IBulkPaymentAnalysisResponse;
  file?: Maybe<IFile>;
  id: Scalars['ID']['output'];
  status: IBulkPaymentWidgetStatus;
  title: Scalars['String']['output'];
};

export type ISendPaymentWidget = IBaseWidget & {
  __typename?: 'SendPaymentWidget';
  destinationAmount: IVariableMoney;
  fixedAmount?: Maybe<IFixedAmount>;
  id: Scalars['ID']['output'];
  method?: Maybe<IPaymentMethod>;
  reason?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<IAssistantRecipientPrefill>;
  recipientId?: Maybe<Scalars['ID']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['ID']['output'];
  sourceAmount: IVariableMoney;
  status: ISendPaymentWidgetStatus;
  targetDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
};

export type ISendPaymentWidgetStatus = IBaseWidgetStatus & {
  __typename?: 'SendPaymentWidgetStatus';
  paymentId?: Maybe<Scalars['ID']['output']>;
  status: IWidgetStatusCategory;
};

export type ISender = {
  __typename?: 'Sender';
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  identifierType?: Maybe<IBankDetailIdentifier>;
  isIban?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentRail?: Maybe<Scalars['String']['output']>;
  routingCode?: Maybe<Scalars['String']['output']>;
};

export type ISetActiveContractVersionInput = {
  contractId: Scalars['ID']['input'];
};

export type ISetActiveContractVersionResponse = IBaseResponse & {
  __typename?: 'SetActiveContractVersionResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type ISetAutoPayInput = {
  accountId: Scalars['String']['input'];
  accountType: IRepaymentAccountType;
};

/** Passing in a null value against a default will unset it */
export type ISetCustomerAccountingDefaultsInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  nominalExpenseAccountId?: InputMaybe<Scalars['ID']['input']>;
  nominalPaymentAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type ISetDefaultsResponse = IBaseResponse & {
  __typename?: 'SetDefaultsResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type ISetMultiLayerApprovalRulesRequest = {
  /** Null to use default rules. */
  approvalRules?: InputMaybe<IMultiLayerApprovalRulesInput>;
  /** If null, new rules take effect immediately for all new requests. */
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** This should always be ScheduledPayment unless we add support for MLA for other types. */
  requestedType: IRequestedType;
};

export type ISetMultiLayerApprovalRulesResponse = IBaseResponse & {
  __typename?: 'SetMultiLayerApprovalRulesResponse';
  /** Null only on error. */
  approvalRules?: Maybe<IMultiLayerApprovalRules>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type ISetPreferenceError = IDefaultError | IPreferenceError;

export type ISetPreferencesInput = {
  billPay?: InputMaybe<IBillPayPreferencesInput>;
  branding?: InputMaybe<IBrandingPreferencesInput>;
  omi?: InputMaybe<IOmiPreferencesInput>;
  omiTable?: InputMaybe<IOmiTablePreferencesInput>;
};

export type ISetPreferencesResponse = {
  __typename?: 'SetPreferencesResponse';
  errors: Array<ISetPreferenceError>;
  preferences?: Maybe<IPreferences>;
};

/** Passing in a null value against a default will unset it */
export type ISetRecipientAccountingDefaultsInput = {
  classId?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  nominalExpenseAccountId?: InputMaybe<Scalars['ID']['input']>;
  nominalPaymentAccountId?: InputMaybe<Scalars['ID']['input']>;
  recipientId: Scalars['ID']['input'];
};

export enum ISheetsCustomerTier {
  Basic = 'BASIC',
  Enterprise = 'ENTERPRISE',
  Premium = 'PREMIUM'
}

export type ISheetsTierQuotaUsage = {
  __typename?: 'SheetsTierQuotaUsage';
  contracts: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type ISheetsTierSettings = {
  __typename?: 'SheetsTierSettings';
  accountIntegrationEnabled: Scalars['Boolean']['output'];
  cashFlowEnabled: Scalars['Boolean']['output'];
  exportEnabled: Scalars['Boolean']['output'];
  maxContracts: Scalars['Int']['output'];
  maxUsers: Scalars['Int']['output'];
  tierQuotaUsage: ISheetsTierQuotaUsage;
};

export type ISingleUserApprover = {
  __typename?: 'SingleUserApprover';
  user: IUser;
};

export type ISingleUserApproverInput = {
  userId: Scalars['ID']['input'];
};

export type ISlackConnection = {
  __typename?: 'SlackConnection';
  /** Team name of the connected account */
  teamName: Scalars['String']['output'];
};

export type ISpreadsheetValueInput =
  { date: Scalars['DateTime']['input']; number?: never; string?: never; }
  |  { date?: never; number: Scalars['Float']['input']; string?: never; }
  |  { date?: never; number?: never; string: Scalars['String']['input']; };

export type IStaticContentWidget = IBaseWidget & {
  __typename?: 'StaticContentWidget';
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type IStrBulkPaymentColumn = {
  __typename?: 'StrBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

/**
 * Valid transitions:
 * - DRAFT -> (APPROVED, REJECTED)
 * - APPROVED -> SYNCING
 * - SYNCING -> SYNCED
 * - SYNCED -> REVERSING
 * - REVERSING -> REVERSED
 * - SYNCING, REVERSING are ephemeral statuses while we wait to receive webhook from Accounting System
 * Once synced, the entry will be posted to the accounting system and cannot be rejected
 */
export enum ISuperSheetsAccrualStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  Reversed = 'REVERSED',
  Reversing = 'REVERSING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type ISuperSheetsPayment = {
  __typename?: 'SuperSheetsPayment';
  actionedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  amount?: Maybe<IMoney>;
  attachments?: Maybe<Array<IFile>>;
  completedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  createdAtUtc: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  failedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  method?: Maybe<IPaymentMethod>;
  paymentReason?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<ISuperSheetsRecipient>;
  status: ISuperSheetsPaymentStatus;
};

export type ISuperSheetsPaymentResponse = IBaseResponse & {
  __typename?: 'SuperSheetsPaymentResponse';
  errors?: Maybe<Array<IDefaultError>>;
  payment?: Maybe<ISuperSheetsPayment>;
};

/**
 * Valid transitions:
 * - DRAFT -> (RELEASED, CANCELED)
 * - RELEASED -> (COMPLETED, FAILED)
 * - RELEASING is an ephemeral status, safe to ignore for customers. Primarily used by the BE to prevent updates.
 */
export enum ISuperSheetsPaymentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Released = 'RELEASED',
  Releasing = 'RELEASING'
}

/** Communicates validation error when trying to release payment */
export type ISuperSheetsPaymentValidationError = {
  __typename?: 'SuperSheetsPaymentValidationError';
  amount?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  method?: Maybe<Array<Scalars['String']['output']>>;
  paymentReason?: Maybe<Array<Scalars['String']['output']>>;
  recipient?: Maybe<ISuperSheetsRecipientValidationErrors>;
};

export type ISuperSheetsPaymentsResponse = IBaseResponse & IPaginatedResponse & {
  __typename?: 'SuperSheetsPaymentsResponse';
  errors?: Maybe<Array<IDefaultError>>;
  pageInfo?: Maybe<IPagination>;
  payments?: Maybe<Array<ISuperSheetsPayment>>;
};

export type ISuperSheetsRecipient = {
  __typename?: 'SuperSheetsRecipient';
  name?: Maybe<Scalars['String']['output']>;
  paypalEmail?: Maybe<Scalars['String']['output']>;
  venmoHandle?: Maybe<Scalars['String']['output']>;
};

export type ISuperSheetsRecipientInput = {
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPaypalEmail?: InputMaybe<Scalars['String']['input']>;
  recipientVenmoHandle?: InputMaybe<Scalars['String']['input']>;
};

/** Communicates validation error when trying to release payment */
export type ISuperSheetsRecipientValidationErrors = {
  __typename?: 'SuperSheetsRecipientValidationErrors';
  name?: Maybe<Array<Scalars['String']['output']>>;
  paypalEmail?: Maybe<Array<Scalars['String']['output']>>;
  venmoHandle?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ITinMatchResponseCategory {
  Error = 'ERROR',
  Match = 'MATCH',
  NoMatch = 'NO_MATCH'
}

export enum ITinMatchStatus {
  Error = 'ERROR',
  ManualOverride = 'MANUAL_OVERRIDE',
  Match = 'MATCH',
  NoMatch = 'NO_MATCH'
}

export type ITableWidget = IBaseWidget & {
  __typename?: 'TableWidget';
  id: Scalars['ID']['output'];
  tableColumns: Array<Scalars['String']['output']>;
  tableRows: Array<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export enum ITaxFormStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum ITaxFormType {
  W8Ben = 'W8_BEN',
  W8BenE = 'W8_BEN_E',
  W9 = 'W9'
}

export type ITextConstrainedValue = {
  __typename?: 'TextConstrainedValue';
  isDefault: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ITextValueInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ITierSettings = ICustomerTierSettings | ILegacyTierCustomer;

export type IToggleConstrainedValue = {
  __typename?: 'ToggleConstrainedValue';
  canToggle: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type IToggleCustomerFeatureFlagInput = {
  customerId: Scalars['ID']['input'];
  flag: IFeatureFlag;
};

export type IToggleCustomerFeatureFlagResponse = IBaseResponse & {
  __typename?: 'ToggleCustomerFeatureFlagResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IToggleCustomerFreezeInput = {
  customerId: Scalars['String']['input'];
  reason?: InputMaybe<IFreezeReason>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type IToggleCustomerFreezeResponse = IBaseResponse & {
  __typename?: 'ToggleCustomerFreezeResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IToggleValueInput = {
  enabled: Scalars['Boolean']['input'];
};

/** ⚠ Summary-view fields to avoid: activity, metadata, relatedTransaction, receiptAvailable. On-demand fields: receiptUrl ⚠️ */
export type ITransaction = {
  __typename?: 'Transaction';
  accountId: Scalars['String']['output'];
  activity?: Maybe<IActivity>;
  /** True iff current user may attach files. Use in details views, not summaries. */
  canAttachFiles: Scalars['Boolean']['output'];
  /** True iff current user may write a note for the event. Use in details views, not summaries. */
  canWriteNote: Scalars['Boolean']['output'];
  /** Card transaction only */
  cardHolderUser?: Maybe<IUser>;
  /** Card transaction only */
  cardLast4?: Maybe<Scalars['String']['output']>;
  /** Card transaction only */
  cardTransactionType?: Maybe<ICardTransactionType>;
  /** Use in details views, not summaries. */
  comments: Array<IComment>;
  counterparty?: Maybe<ICounterparty>;
  currencyAmount: IMoney;
  currencyBalance: IMoney;
  date?: Maybe<Scalars['Date']['output']>;
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  direction: IDirection;
  /** All attached files. Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  files?: Maybe<Array<IFile>>;
  id: Scalars['ID']['output'];
  /** Card transaction only */
  metadata?: Maybe<ITransactionMetadata>;
  /** Nullable iff the event does not currently (and possibly temporarily) support notes. Use in details views, not summaries. */
  note?: Maybe<INote>;
  receiptAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Set to null when there's no receipt - receipts are only prsent for for payment activities */
  receiptUrl?: Maybe<Scalars['String']['output']>;
  relatedTransaction?: Maybe<ITransaction>;
  status: IExecutionStatus;
  transactionType: ITransactionType;
};

export type ITransactionMetadata = IAtmTransactionMetadata | IPurchaseTransactionMetadata;

export type ITransactionPair = {
  destinationTransaction?: Maybe<ITransaction>;
  sourceTransaction?: Maybe<ITransaction>;
};

export type ITransactionTableWidget = IBaseWidget & {
  __typename?: 'TransactionTableWidget';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  transactions: Array<ITransaction>;
};

export enum ITransactionType {
  Card = 'CARD',
  Conversion = 'CONVERSION',
  Deposit = 'DEPOSIT',
  Fee = 'FEE',
  Interest = 'INTEREST',
  InternalTransfer = 'INTERNAL_TRANSFER',
  Other = 'OTHER',
  Payment = 'PAYMENT'
}

export type IUsdAccountDetails = IAccountDetailsWithLocalPayIns & {
  __typename?: 'USDAccountDetails';
  abaRoutingNumber: Scalars['String']['output'];
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountNumberIsIban: Scalars['Boolean']['output'];
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  localPaymentRailName?: Maybe<Scalars['String']['output']>;
  swift: ISwiftAccountDetails;
};

export type IUnmappedBulkPaymentColumn = {
  __typename?: 'UnmappedBulkPaymentColumn';
  sourceColumn: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type IUpdateAccountInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateAccountResponse = IBaseResponse & {
  __typename?: 'UpdateAccountResponse';
  account?: Maybe<IAccount>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateBillInput = {
  amount: Scalars['Float']['input'];
  billDate: Scalars['Date']['input'];
  billPaymentNominalAccountId?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<IBillLineItemInput>;
  method?: InputMaybe<IPaymentMethod>;
  /** Specify either parsedRecipient or recipientId */
  parsedRecipient?: InputMaybe<IParsedRecipientInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Specify either parsedRecipient or recipientId */
  recipientId?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateBillResponse = IBaseResponse & {
  __typename?: 'UpdateBillResponse';
  errors?: Maybe<Array<IDefaultError>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type IUpdateBusinessContactInput = {
  customerId: Scalars['ID']['input'];
  newBusinessContactUserId: Scalars['ID']['input'];
};

export type IUpdateBusinessContactResponse = IBaseResponse & {
  __typename?: 'UpdateBusinessContactResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateCardInput = {
  cardId: Scalars['ID']['input'];
  cardName?: InputMaybe<Scalars['String']['input']>;
  creditCardLimit?: InputMaybe<ICreditCardLimitInput>;
  debitCardLimit?: InputMaybe<IDebitCardLimitInput>;
  /** Cannot be changed, provided for BE performance optimization */
  funding: IFundingType;
  shippingAddress?: InputMaybe<IAddressInput>;
  /** Cannot be changed, provided for BE performance optimization */
  type: ICardType;
};

export type IUpdateCardResponse = IBaseResponse & {
  __typename?: 'UpdateCardResponse';
  card?: Maybe<ICard>;
  errors?: Maybe<Array<IDefaultError>>;
};

/** Changes the date of payment obligations in the specified period. */
export type IUpdateContractCashflowPeriodDatesInput = {
  contractIds: Array<Scalars['ID']['input']>;
  offsetByNPeriods: Scalars['Int']['input'];
  offsetByPeriod: IFrequency;
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
};

export type IUpdateContractCashflowPeriodDatesResponse = IBaseResponse & {
  __typename?: 'UpdateContractCashflowPeriodDatesResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

/** Overwrites payment obligations for the specified period. Deletes payment obligations with due_date between (period_start_date, period_end_date), and creates a single summary payment obligation on period_end_date. */
export type IUpdateContractCashflowPeriodTotalsInput = {
  contractId: Scalars['ID']['input'];
  perCurrencyTotals: Array<IMoneyFormulaInput>;
  periodEndDate: Scalars['Date']['input'];
  periodStartDate: Scalars['Date']['input'];
};

export type IUpdateContractCashflowPeriodTotalsResponse = IBaseResponse & {
  __typename?: 'UpdateContractCashflowPeriodTotalsResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateContractFieldsInput = {
  annualContractValue?: InputMaybe<IMoneyFormulaInput>;
  autoRenews?: InputMaybe<Scalars['Boolean']['input']>;
  billingTerms?: InputMaybe<IBillingTerms>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** A known end date, in the past, present, or future */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** True only if the contract is known to have ended (even if end_date is not known); False or None otherwise. */
  hasEnded?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  noticePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  /** Specify either parsedRecipient or recipientId */
  parsedRecipient?: InputMaybe<IParsedRecipientInput>;
  paymentSummary?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<IPaymentTermsInput>;
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
  /** Specify either parsedRecipient or recipientId */
  recipientId?: InputMaybe<Scalars['String']['input']>;
  renewalDate?: InputMaybe<Scalars['Date']['input']>;
  signatureDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type IUpdateContractPaymentObligationsInput = {
  id: Scalars['ID']['input'];
  paymentObligations?: InputMaybe<Array<IContractPaymentObligationInput>>;
};

export type IUpdateContractResponse = IBaseResponse & {
  __typename?: 'UpdateContractResponse';
  contract?: Maybe<IContract>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateCustomerInfoInput = {
  address?: InputMaybe<IAddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateCustomerInfoResponse = IBaseResponse & {
  __typename?: 'UpdateCustomerInfoResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateCustomerInfoWidget = IBaseWidget & {
  __typename?: 'UpdateCustomerInfoWidget';
  address?: Maybe<IAddress>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: IWidgetStatus;
  title: Scalars['String']['output'];
};

export type IUpdateCustomerTierInput = {
  customerId: Scalars['String']['input'];
  newTier: ICustomerTier;
};

export type IUpdateCustomerTierResponse = IBaseResponse & {
  __typename?: 'UpdateCustomerTierResponse';
  customer?: Maybe<ICustomer>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IUpdateDraftExpenseAccrualInput = {
  accountingClassId?: InputMaybe<Scalars['String']['input']>;
  accountingDepartmentId?: InputMaybe<Scalars['String']['input']>;
  accountingExpenseAccountId?: InputMaybe<Scalars['String']['input']>;
  accountingJournalEntryId?: InputMaybe<Scalars['String']['input']>;
  accountingLiabilityAccountId?: InputMaybe<Scalars['String']['input']>;
  accountingLocationId?: InputMaybe<Scalars['String']['input']>;
  accountingVendorId?: InputMaybe<Scalars['String']['input']>;
  accrualDateUtc?: InputMaybe<Scalars['Date']['input']>;
  amount?: InputMaybe<IVariableMoneyInput>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  postedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  unitAmount?: InputMaybe<IVariableMoneyInput>;
};

export type IUpdateDraftExpenseAccrualsInput = {
  expenseAccruals: Array<IUpdateDraftExpenseAccrualInput>;
};

/** NULL acts as UNSET */
export type IUpdateDraftPaymentInput = {
  amount?: InputMaybe<IMoneyInput>;
  dueDateUtc?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  method?: InputMaybe<IPaymentMethod>;
  paymentReason?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<ISuperSheetsRecipientInput>;
};

export type IUpdateInvoiceStatusInput = {
  depositActivityId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  newStatus: IInvoiceStatus;
};

export type IUpdateInvoiceStatusResponse = IBaseResponse & {
  __typename?: 'UpdateInvoiceStatusResponse';
  errors?: Maybe<Array<IDefaultError>>;
  invoice?: Maybe<IInvoice>;
};

export type IUpdateLevroOpsUserRoleInput = {
  orgId: Scalars['ID']['input'];
  role: IUserRole;
};

export type IUpdateLevroOpsUserRoleResponse = IBaseResponse & {
  __typename?: 'UpdateLevroOpsUserRoleResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  role?: Maybe<IUserRole>;
};

export type IUpdateProcurementRequestInput = {
  annualContractValue?: InputMaybe<IMoneyFormulaInput>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  estimatedStartDate?: InputMaybe<Scalars['Date']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateProcurementRequestResponse = IBaseResponse & {
  __typename?: 'UpdateProcurementRequestResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** None only on error */
  request?: Maybe<IProcurementRequest>;
};

export type IUpdateRecipientInput = {
  /**
   * Null leaves account information unchanged. Non-null replaces all account information with the provided values.
   *
   * NOTE: Address must exactly match the existing address if the recipient has tax doc collection enabled.
   */
  accountInformation?: InputMaybe<IRecipientAccountInput>;
  /** Null or absent leaves unchanged; empty string resets to legal name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Null or absent leaves unchanged; empty string removes an existing email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Null or absent leaves unchanged; empty string removes an existing manager */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  recipientId: Scalars['ID']['input'];
  /** Null or absent leaves unchanged; empty string removes an existing US TIN */
  usTin?: InputMaybe<Scalars['String']['input']>;
};

export type IUpdateRecipientResponse = IBaseResponse & {
  __typename?: 'UpdateRecipientResponse';
  accountInformationErrors?: Maybe<Array<IDefaultError>>;
  errors?: Maybe<Array<IDefaultError>>;
  /** Absent only on error. */
  recipient?: Maybe<IRecipient>;
};

export type IUpdateUserError = ICannotReduceRecipientManagerPermissionError | ICannotUpdateBusinessContactRoleError | IDefaultError | IUserNotFoundError;

export type IUpdateUserInput = {
  /** Iff non-null, updates first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Iff non-null, updates last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Iff non-null, updates phone */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Iff non-null, updates role */
  role?: InputMaybe<IUserRole>;
  userId: Scalars['ID']['input'];
};

export type IUpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  errors?: Maybe<Array<IUpdateUserError>>;
};

export type IUploadParseAndMapFieldsFromDocInput = {
  fileIds: Array<Scalars['String']['input']>;
  /** Form fields as JSON schema that the uploaded doc fields will get mapped to. e.g. {'bizName': {'type': 'string'}, 'entityType': {'type': 'string', 'enum': ['LLC', 'PARTNERSHIP']}}. When this field is not provided, only performs upload and parse. */
  formFieldsJsonSchema?: InputMaybe<Scalars['String']['input']>;
};

export type IUser = {
  __typename?: 'User';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** Only set when user is logged in to recipient context */
  recipientId?: Maybe<Scalars['ID']['output']>;
  restrictedDetails?: Maybe<IUserRestrictedDetails>;
};

export type IUserGroupApprover = {
  __typename?: 'UserGroupApprover';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  users: Array<IUser>;
};

export type IUserGroupApproverInput = {
  groupId: Scalars['ID']['input'];
};

export type IUserNotFoundError = IErrorInterface & {
  __typename?: 'UserNotFoundError';
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type IUserNotSignedUp = {
  __typename?: 'UserNotSignedUp';
  /** Do not use field. Cannot create empty types */
  void: Scalars['Boolean']['output'];
};

export type IUserProfileResponse = IUser | IUserNotSignedUp;

/** Denotes what actions a user can take on a request (admin override is not taken into account). */
export enum IUserResolutionAbility {
  /** User may reject. User may approve and no additional approvals will be required. */
  FinalApproval = 'FINAL_APPROVAL',
  /** User may reject. User may approve but additional approvals will still be required. */
  IntermediateApproval = 'INTERMEDIATE_APPROVAL',
  /** User may not approve/reject the request */
  None = 'NONE'
}

export type IUserResponse = IBaseResponse & {
  __typename?: 'UserResponse';
  errors?: Maybe<Array<IDefaultError>>;
  user?: Maybe<IUser>;
};

export type IUserRestrictedDetails = {
  __typename?: 'UserRestrictedDetails';
  authInfo?: Maybe<IAuthInfo>;
  dob?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  isUnitBusinessContact: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rolesInfo?: Maybe<IUserRolesInfo>;
};

export enum IUserRole {
  Accountant = 'ACCOUNTANT',
  Administrator = 'ADMINISTRATOR',
  Auditor = 'AUDITOR',
  Cardholder = 'CARDHOLDER',
  LiteAdmin = 'LITE_ADMIN',
  LiteUser = 'LITE_USER',
  Recipient = 'RECIPIENT',
  Reviewer = 'REVIEWER'
}

export type IUserRolesInfo = IBaseResponse & {
  __typename?: 'UserRolesInfo';
  errors?: Maybe<Array<IDefaultError>>;
  role?: Maybe<IUserRole>;
};

export type IUsersResponse = IBaseResponse & {
  __typename?: 'UsersResponse';
  errors?: Maybe<Array<IDefaultError>>;
  users: Array<IUser>;
};

export type IVariableMoney = {
  __typename?: 'VariableMoney';
  /** A nullable amount. If None, the amount is typically derived in the future from related variables. */
  amount?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
};

export type IVariableMoneyInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
};

export type IVendorAccountingInfo = {
  __typename?: 'VendorAccountingInfo';
  accountingCategories: Array<IAccountingCategory>;
  firstTransactionDate?: Maybe<Scalars['Date']['output']>;
  lastTransactionDate?: Maybe<Scalars['Date']['output']>;
  nominalAccounts: Array<INominalAccount>;
  numRecentTransactions: Scalars['Int']['output'];
  recentSpend: IMoney;
  vendor: IRecipient;
  vendorId: Scalars['ID']['output'];
};

export type IVendorFeedback = {
  __typename?: 'VendorFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  raterEmail: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
};

export type IVendorManagerApprover = {
  __typename?: 'VendorManagerApprover';
  /** types may not have zero fields */
  null?: Maybe<Scalars['Void']['output']>;
};

export type IVendorManagerApproverInput = {
  /** types may not have zero fields */
  null?: InputMaybe<Scalars['Void']['input']>;
};

export enum IVerificationMethod {
  Address = 'ADDRESS',
  AddressAndCvv2 = 'ADDRESS_AND_CVV2',
  Cvv2 = 'CVV2'
}

export type IVerifyDocumentInput = {
  applicationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type IVerifyDocumentResponse = IBaseResponse & {
  __typename?: 'VerifyDocumentResponse';
  errors?: Maybe<Array<IDefaultError>>;
};

export type IVolumeAccountLimit = IAccountLimitInterface & {
  __typename?: 'VolumeAccountLimit';
  limitType: IAccountLimitType;
  nThreshold?: Maybe<Scalars['Int']['output']>;
  nUtilized: Scalars['Int']['output'];
};

export type IWidget = IAccountsWidget | IApprovalFlowWidget | IBillDetailsWidget | IBillPayWidget | IBillTableWidget | ICardActionWidget | ICheckDepositWidget | IContractCashflowWidget | IContractDetailsWidget | IContractTableWidget | ICreateConversionWidget | ICreateInvoiceWidget | ICreateRecipientWidget | IDownloadStatementsWidget | IFxRateHistoryWidget | IInvalidWidget | IPaymentDetailsWidget | IPaymentTableWidget | IRecipientTableWidget | ISendBulkPaymentWidget | ISendPaymentWidget | IStaticContentWidget | ITableWidget | ITransactionTableWidget | IUpdateCustomerInfoWidget;

export type IWidgetStatus = IBaseWidgetStatus & {
  __typename?: 'WidgetStatus';
  status: IWidgetStatusCategory;
};

export enum IWidgetStatusCategory {
  Actioned = 'ACTIONED',
  New = 'NEW'
}

export type IWireFunding = {
  __typename?: 'WireFunding';
  deadline: Scalars['DateTime']['output'];
};

export type IWriteActivityNoteInput = {
  activityId: Scalars['ID']['input'];
  note: INoteInput;
};

export type IWriteActivityNoteResponse = IBaseResponse & {
  __typename?: 'WriteActivityNoteResponse';
  errors?: Maybe<Array<IDefaultError>>;
  note: INote;
};

export type IWriteAnnotationInput = {
  annotationJson: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type IWriteAnnotationResponse = IBaseResponse & {
  __typename?: 'WriteAnnotationResponse';
  annotation?: Maybe<IAnnotation>;
  errors?: Maybe<Array<IDefaultError>>;
};

export type IWriteEventInstanceNoteInput = {
  eventId: Scalars['ID']['input'];
  note: INoteInput;
  ordinal: Scalars['Int']['input'];
};

export type IWriteEventInstanceNoteResponse = IBaseResponse & {
  __typename?: 'WriteEventInstanceNoteResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  note?: Maybe<INote>;
};

export type IWriteScheduledEventNoteInput = {
  eventId: Scalars['ID']['input'];
  note: INoteInput;
};

export type IWriteScheduledEventNoteResponse = IBaseResponse & {
  __typename?: 'WriteScheduledEventNoteResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  note?: Maybe<INote>;
};

export type IWriteTransactionNoteInput = {
  note: INoteInput;
  transactionId: Scalars['ID']['input'];
};

export type IWriteTransactionNoteResponse = IBaseResponse & {
  __typename?: 'WriteTransactionNoteResponse';
  errors?: Maybe<Array<IDefaultError>>;
  /** null only on error */
  note?: Maybe<INote>;
};
